<script>
import * as am4core from "@amcharts/amcharts4/core";
import Multiselect from "vue-multiselect";
import axios from "axios";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { scrollIntoView } from "seamless-scroll-polyfill";
import jsPDF from "jspdf";
import "jspdf-autotable";
am4core.useTheme(am4themes_animated);

const R = require("ramda"); //todo swap ramda calls to lodash since we need lodash anyway for debounce
import _ from "lodash";

import Navbar from "@/Navbar2";
import budgetComponent from "@/budgetChart/budgetComponent";

// import SpendidScore from "@/ScoreCards/SpendidScore";

import transformer_38 from "@/transformers/transformer_new";
import common_monthly from "@/transformers/common_monthly";
import common_monthly_short from "@/transformers/common_monthly_short";
import common_monthly_2 from "@/transformers/common_monthly_2";
import common_monthly_short_2 from "@/transformers/common_monthly_short_2";
import transformer_category from "@/transformers/transformer_category";
import CoreExpenseCategories from "@/CoreExpenseCategories/CoreCategories.vue";
import EliminateCategory from "@/EliminateCategory/EliminateCategory.vue";
import ChatGptList from "@/components/ChatGptList";
// import BudgetChart from '@/budgetChart/budgetChart.vue';
import HowTo from "@/LearnMore/HowTo.vue";
import stepform from "@/StepForm/stepform";
import zip_codes from "@/data/zip_codes.json";
import state_gross from "@/data/state_gross_up.json";

import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/antd.css";
import { new_api } from "../auth_config.json";
function initialState() {
  let token;
  try {
    var cookieArr = document.cookie.split(";");

    // Loop through the array elements
    for (var i = 0; i < cookieArr.length; i++) {
      var cookiePair = cookieArr[i].split("=");

      /* Removing whitespace at the beginning of the cookie name
        and compare it with the given string */
      if ("userDetail" == cookiePair[0].trim()) {
        // Decode the cookie value and return
        token = decodeURIComponent(cookiePair[1]);
      }
    }
  } catch (e) {
    // eslint-disable-next-line no-console
  }
  return {
    fill: { gradient: ["blue", "blue", "blue"] },
    net_amount: [
      {
        amount: "",
        freq: 12,
        manual: "2",
        occupation: null,
        level: null,
        grossOrNet: "net",
        net: 0,
        gross: 0,
      },
    ],
    auth: {},
    value: 1,
    data: [
      {
        id: 1,
        name: "1",
      },
      {
        id: 2,
        name: "2",
      },
      {
        id: 3,
        name: "3",
      },
      {
        id: 4,
        name: "4",
      },
      {
        id: 5,
        name: "5+",
      },
    ],
    dotOptions: [],
    predictGrowth: "6.0",
    selected: "first",
    grossOrNet: "gross",
    home_options: [
      { text: "Renter", value: false },
      { text: "Owner", value: true },
    ],
    income_method_val: false,
    income_method: [
      { text: "Occupation", value: "1" },
      { text: "Manual Input", value: "2" },
    ],
    occupations_val: null,
    annual_gross_salary_level_val: 0,
    annual_gross_salary_level: [
      { text: "Low/Entry", value: 1 },
      { text: "Median", value: 2 },
      { text: "High/Experienced", value: 3 },
    ],
    dark: true,
    page: "main",
    hideBarChart: true,
    cancelToken: undefined,
    netAmount: 0,
    occupations: [],
    savingEdit: false,
    visibleResultsSummary: false,
    visibleYourHousehold: false,
    visibleCoreExp: false,
    visibleCustCoreExp: false,
    visibleVhCustCoreExp: false,
    visibleDbtCustCoreExp: false,
    visibleSvAmtCoreExp: false,
    visiblePersComp: false,
    visibleCoreExpCat: false,
    visibleProfileHousehold: true,
    visibleOtherExpCat: false,
    visibleFutureExpCat: false,
    visibleCommonBillsCat: false,
    visibleMonthlyBillsCat: false,
    visibleDisabledCat: false,
    visibleResultDetails: false,
    visibleYourBudget: false,
    visibleYourPeers: false,
    visibleCashHealthAnalysis: true,
    visibleFAQ: false,
    visibleFaqOne: false,
    visibleFaqTwo: false,
    visibleFaqThree: false,
    visibleFaqFour: false,
    visibleFaqFive: false,
    visibleFaqSix: false,
    visibleFaqSeven: false,
    visibleFaqEight: false,
    visibleFaqNine: false,
    visibleFaqTen: false,
    visibleFaqEleven: false,
    visibleFaqTwelve: false,
    visibleFaqThirteen: false,
    visibleFaqFourteen: false,
    visibleFaqFifteen: false,
    visibleModalPieChart: false,
    info_hover: false,
    visible: true,
    sortBy: "",
    sortType: "",
    isHidden: true,
    checked: true,
    chart: null,
    chart_range: "month",
    is_typing: false,
    api_updates_pending: false,
    active_persona_index: 0,
    money: {
      decimal: ".",
      thousands: ",",
      prefix: "$",
      suffix: "",
      precision: "0",
      masked: false,
    },
    budget: null,
    demographics_response: null,
    scores: null,
    lending_score: null,
    pie_chart: null,
    pie_chart2: null,
    pie_chart3: null,
    pie_chart4: null,
    pie_chart5: null,
    speed_chart: null,
    bar_chart: null,
    barChart: null,
    peers_input_value: null,
    filtered_barchart: null,
    savings_input_value: null,
    savings_input_value_freq: 12,
    mortgage_and_rent_input_value: null,
    mortgage_and_rent_input_value_freq: 12,
    vehicle_purchase_and_lease_input_value: null,
    vehicle_purchase_and_lease_input_value_freq: 12,
    health_insurance_input_value: null,
    health_insurance_input_value_freq: 12,
    debt_input_value: null,
    debt_input_value_freq: 12,
    peer_income: "--",
    // monthly_take_home_input_value: "",
    monthly_take_home_input_value_freq: 12,
    age: "22",
    household_members: "1",
    occupationGrossIncome: "0",
    zip: "",
    is_homeowner: false,
    filter_cateory: "",
    selected_category: "transformer_24",
    budgetFilter: null,
    peerFilter: null,
    differenceFilter: null,
    frequencyOptions: [
      { text: "Monthly", value: 12 },
      { text: "Weekly", value: 52 },
      { text: "Quarterly", value: 4 },
      { text: "Semi-Annually", value: 2 },
      { text: "Annually", value: 1 },
    ],
    frequencyOptionsNew: [
      { text: "Weekly", value: 52 },
      { text: "Every 2 Weeks", value: 26 },
      { text: "Twice per Month", value: 24 },
      { text: "Monthly", value: 12 },
      { text: "Quarterly", value: 4 },
      { text: "Semi-Annually", value: 2 },
      { text: "Annually", value: 1 },
    ],
    changedValues: {},
    changedValuesText: {},
    defaultSelectedEliminationName: "",
    eliminated: {},
    sortDefault: true,
    gridFirst: false,
    gridSecond: true,
    gridThird: false,
    showPeer: true,
    chart3Data: [],
    chart4Data: [],
    isActive: true,
    percentage: 0,
    access_token: token,
    apiReq: null,
    callDemographicsAPIRes: null,
    callBudgetAPIRes: null,
    callScoringAPIRes: null,
    callLendingScoreAPIRes: null,
    dataSent: null,
    useCase: null,
    defaultUseCase: null,
    defaultEducation: null,
    loginLoading: false,
    user_name: "",
    user_email: "",
    user_password: "",
    otp: "",
    verifyEnable: true,
    verifyMsg: "",
    stepEnable: false,
    byPass: false,
    key: "hCqpmeIgXhrnRnMwAanDT2qqocZDUtQ1yTZHUkle",
    zip_codes: zip_codes,
    state_gross: state_gross,
    common_monthly,
    common_monthly_2,
    activeTab: "Your Result",
    showYourResultsTab: true,
    userActivityTimeout: null,
    activeLink: "",
    user_email_pdf: "",
    modalShow: false,
    uses: "",
    defaultActiveTab: "",
    demographicsCached: null,
    budgetCached: null,
    scoresCached: null,
    lendingScoreCached: null,
  };
}
export default {
  name: "landing-app",
  components: {
    Multiselect,
    ChatGptList,
    Navbar,
    budgetComponent,
    stepform,
    // SidebarComp,
    // ReportAssesment,
    // BudgetChart,
    CoreExpenseCategories,
    EliminateCategory,
    // createAuth0Client,
    // BudgetChart,
    HowTo,
    VueSlider,
    // SpeedoMeter,
    // VueSpeedometer
    // FAQS,
    // Meter
    // Blog,
    // BudgetPieChart
  },
  data() {
    return initialState();
  },

  computed: {
    occupationGrossIncomeFormat() {
      const sum = this.occupationGrossIncome;
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
      });

      return formatter.format(Math.round(sum));
    },
    netAmountInput() {
      const sum = this.net_amount.reduce(
        (partialSum, a) => partialSum + parseFloat(a.net || 0),
        0
      );
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
      });

      return formatter.format(Math.round(sum));
    },
    
    netAmountInput2() {
      const sum = this.net_amount.reduce(
        (partialSum, a) => partialSum + parseFloat(a.net || 0),
        0
      );
      return Math.round(sum);
    },
    returnScoreLending() {
      const saving =
        Array.isArray(this.filtered_barchart) &&
        this.filtered_barchart.length > 0
          ? this.filtered_barchart[4]
          : null;
      var monthly_cash_excess = (saving && saving.peer_monthly) || 0;
      var net_value = this.netAmountInput2;
      return (
        this.lending_score &&
        (((monthly_cash_excess / net_value) + 0.8) * 100).toFixed(1)
      );
    },
    returnScore() {
      return (
        this.scores &&
        this.scores.breakeven &&
        (parseFloat(this.scores.breakeven) > 100
          ? parseFloat(this.scores.breakeven)
          : parseFloat(this.scores.breakeven))
      );
    },
    getCookies() {
      return (
        (this.$cookies.get("userDetail") &&
          this.$cookies.get("userDetail").data) ||
        this.$cookies.get("userDetail")
      );
    },
    saving_peer_amount() {
      const saving =
        this.filtered_barchart.length > 0 ? this.filtered_barchart[4] : null;
      if (saving) {
        var formatter = new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
          maximumFractionDigits: 0,
          minimumFractionDigits: 0,
        });
        return formatter.format(saving.peer_monthly);
      }
      return 0;
    },
    verifySubmitButton() {
      if (!this.user_name) {
        return true;
        /* eslint-disable */
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.user_email)) {
        return true;
      }
      return false;
    },
    checkForNext1() {
      if (
        !this.age ||
        this.age < 18 ||
        this.monthly_take_home_input_value_check <= 0
      ) {
        return false;
      } else if (this.zip.length !== 5) {
        return false;
      }
      return true;
    },
    checkForNext2() {
      if (
        this.debt_value !== null &&
        this.debt_value >= 0 &&
        this.vehicle_purchase_and_lease_value !== null &&
        this.vehicle_purchase_and_lease_value >= 0 &&
        this.health_insurance_value !== null &&
        this.mortgage_and_rent_value >= 0 &&
        this.health_insurance_value !== null &&
        this.health_insurance_value >= 0
      ) {
        return true;
      }
      return false;
    },
    saving_display_value() {
      if (this.savings_input_value && this.savings_input_value.includes("$")) {
        return this.savings_input_value || "$0";
      } else {
        return this.savings_input_value ? `$${this.savings_input_value}` : "$0";
      }
    },
    //  is_mobile() {
    //   const isMobile = window.matchMedia("only screen and (max-width: 760px)")
    //     return isMobile.matches ? true : false
    //   },

    // validation() {
    //   return this.userId.length > 4 && this.userId.length < 13
    //   return this.zipcodeId.length < 5
    //   },
    is_homeowner_value() {
      if (this.is_homeowner === "") {
        return null;
      } else {
        return this.is_homeowner === true;
      }
    },
    set_filter_cateory() {
      return this.filter_cateory;
    },
    savings_value() {
      if (this.savings_input_value) {
        let val = parseFloat(this.unmaskMoneyValue(this.savings_input_value));
        let is_percentage = val > 0 && val < 1;
        return is_percentage ? this.monthly_take_home * val : val;
      } else {
        return null;
      }
    },
    debt_value() {
      return this.debt_input_value
        ? parseFloat(this.unmaskMoneyValue(this.debt_input_value))
        : null;
    },
    health_insurance_value() {
      return this.health_insurance_input_value
        ? parseFloat(this.unmaskMoneyValue(this.health_insurance_input_value))
        : null;
    },
    mortgage_and_rent_value() {
      return this.mortgage_and_rent_input_value
        ? parseFloat(this.unmaskMoneyValue(this.mortgage_and_rent_input_value))
        : null;
    },
    vehicle_purchase_and_lease_value() {
      return this.vehicle_purchase_and_lease_input_value
        ? parseFloat(
            this.unmaskMoneyValue(this.vehicle_purchase_and_lease_input_value)
          )
        : null;
    },
    scores_ready() {
      return this.scores != null && !this.api_updates_pending;
    },
    savings_grade() {
      return this.scores_ready ? this.score_to_grade(this.scores.saving) : "";
    },
    savings_grade_css_classes() {
      return this.scores_ready
        ? this.grade_to_css_class(this.savings_grade)
        : {};
    },
    breakeven_grade() {
      return this.lending_score
        ? this.score_to_grade(this.lending_score.elements.cash_excess / 12)
        : "";
    },
    breakeven_grade_css_classes() {
      return this.scores_ready
        ? this.grade_to_css_class(this.breakeven_grade)
        : {};
    },
    saving_peer_amount_grade() {
      const saving =
        this.filtered_barchart.length > 0 ? this.filtered_barchart[4] : null;
      if (this.scores_ready && saving) {
        return this.score_to_grade(saving.peer_monthly);
      }
      return "";
    },
    saving_peer_amount_css_classes() {
      return this.scores_ready
        ? this.grade_to_css_class(this.saving_peer_amount_grade)
        : {};
    },
    lending_grade() {
      return this.scores_ready ? this.score_to_grade(this.scores.lending) : "";
    },
    lending_grade_css_classes() {
      return this.scores_ready
        ? this.grade_to_css_class(this.lending_grade)
        : {};
    },
    monthly_take_home_input_value_check() {
      const sum = this.net_amount.reduce(
        (partialSum, a) =>
          partialSum + parseFloat(this.unmaskMoneyValue(a.amount)) * a.freq,
        0
      );
      return Math.round(sum / 12);
    },
    monthly_take_home_input_value() {
      const sum = this.net_amount.reduce(
        (partialSum, a) => partialSum + parseFloat(a.gross || 0),
        0
      );
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
      });
      // this.recalculateNet(Math.round(sum / 12));
      return formatter.format(Math.round(sum));
    },
    monthly_take_home() {
      return this.monthly_take_home_input_value
        ? parseFloat(this.unmaskMoneyValue(this.monthly_take_home_input_value))
        : null;
    },
    monthly_take_home_net() {
      return this.netAmountInput
        ? parseFloat(this.unmaskMoneyValue(this.netAmountInput))
        : null;
    },
    lending_score_cash_excess_formattedNon() {
      if (this.lending_score == null) {
        return "";
      }
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
      });
      var monthly_cash_excess = (
        this.lending_score.elements.cash_excess / 12
      ).toFixed(0);
      return formatter.format(
        monthly_cash_excess < 0 ? 0 : monthly_cash_excess
      );
    },

    lending_score_cash_excess_formatted() {
      if (this.lending_score == null) {
        return "";
      }
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
      });
      var monthly_cash_excess = this.lending_score.elements.cash_excess / 12;
      return formatter.format(monthly_cash_excess);
    },
    selected_transformer() {
      return transformer_38;
      // switch (this.selected_category) {
      //   case "transformer_38":
      //     return transformer_38;
      //   case "transformer_24":
      //     return transformer_24;
      //   case "transformer_13":
      //     return transformer_13;
      //   case "transformer_8":
      //     return transformer_8;
      //   default:
      //     return transformer_24;
      // }
    },
  },
  watch: {
    income_method_val(val) {
      this.net_amount = [
        {
          amount: "",
          freq: 12,
        },
      ];
      console.log("ds");
    },
    occupations_val: {
      handler(val) {
        if (val && this.annual_gross_salary_level_val) {
          const selectedOccupation = this.occupations.find(
            (item) => item.id == val
          );
          if (this.annual_gross_salary_level_val == 1) {
            console.log(selectedOccupation.low, "1");
            this.occupationGrossIncome = selectedOccupation.low;
            this.net_amount = [
              {
                amount: `$${selectedOccupation.low}`,
                freq: 1,
              },
            ];
          } else if (this.annual_gross_salary_level_val == 2) {
            this.occupationGrossIncome = selectedOccupation.median;
            this.net_amount = [
              {
                amount: `$${selectedOccupation.median}`,
                freq: 1,
              },
            ];
          } else if (this.annual_gross_salary_level_val == 3) {
            this.occupationGrossIncome = selectedOccupation.high;
            this.net_amount = [
              {
                amount: `$${selectedOccupation.high}`,
                freq: 1,
              },
            ];
          }
        }
        // const sum = this.net_amount.reduce(
        //   (partialSum, a) =>
        //     partialSum + parseFloat(this.unmaskMoneyValue(a.amount)) * a.freq,
        //   0
        // );
        this.recalculateNet(Math.round(sum / 12));
      },
      deep: true,
      immediate: true,
    },
    annual_gross_salary_level_val: {
      handler(val) {
        if (this.occupations_val && val) {
          const selectedOccupation = this.occupations.find(
            (item) => item.id == this.occupations_val
          );
          if (val == 1) {
            console.log(selectedOccupation.low, "1");
            this.occupationGrossIncome = selectedOccupation.low;
            this.net_amount = [
              {
                amount: `$${selectedOccupation.low}`,
                freq: 1,
              },
            ];
          } else if (val == 2) {
            this.occupationGrossIncome = selectedOccupation.median;
            this.net_amount = [
              {
                amount: `$${selectedOccupation.median}`,
                freq: 1,
              },
            ];
          } else if (val == 3) {
            this.occupationGrossIncome = selectedOccupation.high;
            this.net_amount = [
              {
                amount: `$${selectedOccupation.high}`,
                freq: 1,
              },
            ];
          }
          this.grossOrNet = "gross";
          const sum = this.net_amount.reduce(
            (partialSum, a) =>
              partialSum + parseFloat(this.unmaskMoneyValue(a.amount)) * a.freq,
            0
          );
          this.recalculateNet(Math.round(sum / 12));
        }
      },
      deep: true,
      immediate: true,
    },
    async grossOrNet(val) {
      // console.log(1);
      this.is_typing = true;
      this.api_updates_pending = true;
      const sum = this.net_amount.reduce(
        (partialSum, a) =>
          partialSum + parseFloat(this.unmaskMoneyValue(a.amount)) * a.freq,
        0
      );
      // console.log(2);
      this.recalculateNet(Math.round(sum / 12));
      setTimeout(() => {
        if (this.checkForValidate()) {
          this.updateCharts();
        }
      }, 2500);
      localStorage.setItem("grossOrNet", val);
    },
    async lending_score_cash_excess_formattedNonFormat() {
      if (this.checkForValidate()) {
        this.is_typing = true;
        this.api_updates_pending = true;
        await this.updateChartsCached();
      }
    },
    access_token: {
      handler() {
        if (this.access_token) {
          this.loadUser();
        }
      },
      deep: true,
      immediate: true,
    },
    async sortBy() {
      // console.log(this.sortDefault,this.sortBy)
      await this.changeFilter(this.sortDefault);
    },
    async monthly_take_home() {
      this.is_typing = true;
      this.api_updates_pending = true;
      await this.updateCharts();
    },
    async household_members() {
      if (this.household_members < 1) {
        return false;
      }
      if (this.checkForValidate()) {
        this.is_typing = true;
        this.api_updates_pending = true;
        await this.updateCharts();
      }
    },
    async age() {
      if (this.age < 18) {
        return false;
      }
      if (this.checkForValidate()) {
        this.is_typing = true;
        this.api_updates_pending = true;
        await this.updateCharts();
      }
    },
    async zip() {
      if (this.checkForValidate()) {
        this.is_typing = true;
        this.api_updates_pending = true;
        await this.updateCharts();
      }
    },
    async is_homeowner() {
      if (this.checkForValidate()) {
        this.is_typing = true;
        this.api_updates_pending = true;
        await this.updateCharts();
      }
    },
    async user_name() {
      if (this.checkForValidate()) {
        this.is_typing = true;
        this.api_updates_pending = true;
        await this.updateCharts();
      }
    },
    async user_email() {
      this.visibleCashHealthAnalysis = true;
      if (this.checkForValidate()) {
        this.is_typing = true;
        this.api_updates_pending = true;
        await this.updateCharts();
      }
    },
    async monthly_take_home_input_value_freq() {
      this.is_typing = true;
      this.api_updates_pending = true;
      await this.updateCharts();
    },
    async savings_input_value() {
      this.is_typing = true;
      this.api_updates_pending = true;
      await this.updateCharts();
    },
    async savings_input_value_freq() {
      this.is_typing = true;
      this.api_updates_pending = true;
      await this.updateCharts();
    },
    async debt_input_value() {
      this.is_typing = true;
      this.api_updates_pending = true;
      await this.updateCharts();
    },
    async debt_input_value_freq() {
      this.is_typing = true;
      this.api_updates_pending = true;
      await this.updateCharts();
    },
    async mortgage_and_rent_input_value() {
      this.is_typing = true;
      this.api_updates_pending = true;
      await this.updateCharts();
    },
    async mortgage_and_rent_input_value_freq() {
      this.is_typing = true;
      this.api_updates_pending = true;
      await this.updateCharts();
    },
    async health_insurance_input_value() {
      this.is_typing = true;
      this.api_updates_pending = true;
      await this.updateCharts();
    },
    async health_insurance_input_value_freq() {
      this.is_typing = true;
      this.api_updates_pending = true;
      await this.updateCharts();
    },
    async vehicle_purchase_and_lease_input_value() {
      this.is_typing = true;
      this.api_updates_pending = true;
      await this.updateCharts();
    },
    async vehicle_purchase_and_lease_input_value_freq() {
      this.is_typing = true;
      this.api_updates_pending = true;
      await this.updateCharts();
    },
    async selected_category() {
      this.is_typing = true;
      this.api_updates_pending = true;
      await this.updateCharts();
    },
    async chart_range() {
      if (this.chart_range === "week") {
        this.pie_chart.series.template.dataFields.value = "weekly";
        // this.pie_chart2.series.template.dataFields.value = "weekly";
      } else if (this.chart_range === "month") {
        this.pie_chart.series.template.dataFields.value = "monthly";
        // this.pie_chart2.series.template.dataFields.value = "monthly";
      } else {
        this.pie_chart.series.template.dataFields.value = "yearly";
        // this.pie_chart2.series.template.dataFields.value = "yearly";
      }
    },
  },
  async mounted() {
    if (this.$route.query.onboard) {
      this.resetDefault(true);
      this.$router.replace({ query: null });
    }

    let headers = {
      key: this.key,
    };
    this.$http
      .post(
        "https://panel.spendid.io/spendid_analytics/public/api/validate",
        {},
        { headers }
      )
      .then(() => {})
      .catch(() => {
        // document.getElementById("app").innerHTML =
        //   "You are not authorized to access the iframe";
      });

    let storedData;
    let userData;
    let assessment;
    try {
      storedData = await localStorage.getItem("storedData");
      const firstSession = (await localStorage.getItem("firstSession"))
        ? localStorage.getItem("firstSession") == "1"
        : false;
      const grossOrNet = (await localStorage.getItem("grossOrNet"))
        ? localStorage.getItem("grossOrNet")
        : "gross";
      this.grossOrNet = grossOrNet;
      if (firstSession) {
        this.stepEnable = false;
      } else {
        this.stepEnable = true;
      }

      if (!!storedData) {
        storedData = JSON.parse(storedData);
        if (storedData.age) {
          this.visibleOtherExpCat = true;
        } else {
        }
        this.setData(storedData);
      } else {
      }
      this.dark = await (localStorage.getItem("mode") === null
        ? false
        : localStorage.getItem("mode") === "false"
        ? false
        : true);
    } catch (e) {
      this.dark = true;
    }
    window.scrollTo(0, 0);
    this.api_updates_pending = true;
    const { demographics, budget, scores, lendingScore } =
      await this.callAPIs();

    this.barChart = this.mergeResponses(demographics, budget);
    const fullData = this.mergeResponses(demographics, budget);
    this.filtered_barchart = fullData.map((v) =>
      Object.assign(v, { isActive: true })
    );
    // let barArray= []
    // Object.keys(comparison).map(item=>{
    //   barArray.push({name:item.category,value1:item.peer_monthly,value2:item.user_monthly})
    // })
    // this.barChart =barArray

    const chart1Data = budget.map((item) => ({
      ...item,
      type: transformer_category[item.category_type].type,
    }));
    const chart2Data = demographics.map((item, k) => ({
      ...item,
      type: transformer_category[budget[k].category_type].type,
    }));
    const chart1 = this.getPieChartData(chart1Data);
    const chart2 = this.getPieChartData(chart2Data);
    this.getOccupation();
    this.chart3Data = chart1;
    this.chart4Data = chart2;
    this.pie_chart3 = this.createPieChart(chart1, "piechart3", "%");
    this.pie_chart4 = this.createPieChart(chart2, "piechart4", "%appsk");
    this.speed_chart = this.createSpeedChart(scores.breakeven);
    const standardChart = [
      {
        category: "Compassion Choice",
        monthly: 1.5,
      },
      {
        category: "Past Choice",
        monthly: 40,
      },
      {
        category: "Present Choice",
        monthly: 45,
      },
      {
        category: "Future Choice",
        monthly: 13.5,
      },
    ];

    this.pie_chart5 = this.createPieChart(standardChart, "piechart5", "%");

    // this.pie_chart5 = this.createPieChart(standardChart,'piechart5','%');

    this.bar_chart = this.createBarChart(this.barChart);
    // var that= this
    // setTimeout(() => {
    //   that.bar_chart.resize();
    // }, 300);
    this.pie_chart = this.createPieChart(budget, "piechart");
    // this.pie_chart2 = this.createPieChart(demographics,'piechart2');
    this.sortBy = "peer_monthly";
    this.changeFilter(false);
    this.scores = scores;
    this.lending_score = lendingScore;
    this.api_updates_pending = false;

    this.resetUserActivityTimeout();
    window.addEventListener("mousemove", this.resetUserActivityTimeout);
    window.addEventListener("scroll", this.resetUserActivityTimeout);
    window.addEventListener("keydown", this.resetUserActivityTimeout);
    window.addEventListener("resize", this.resetUserActivityTimeout);
  },
  destroyed() {
    window.removeEventListener("mousemove", this.resetUserActivityTimeout);
    window.removeEventListener("scroll", this.resetUserActivityTimeout);
    window.removeEventListener("keydown", this.resetUserActivityTimeout);
    window.removeEventListener("resize", this.resetUserActivityTimeout);
  },
  beforeDestroy() {
    if (this.pie_chart) {
      this.pie_chart.dispose();
    }
    if (this.pie_chart2) {
      this.pie_chart2.dispose();
    }
    if (this.pie_chart3) {
      this.pie_chart3.dispose();
    }
    if (this.pie_chart4) {
      this.pie_chart4.dispose();
    }
    if (this.pie_chart5) {
      this.pie_chart5.dispose();
    }
    if (this.bar_chart) {
      this.bar_chart.dispose();
    }
    if (this.speed_chart) {
      this.speed_chart.dispose();
    }
  },

  // destroyed: function () {
  //   window.removeEventListener('resize', this.resizeWindow)
  // },
  //   if(_this.mortgage_and_rent_input_value && target.dataItem.categories.categoryY === 'Rent or Mortgage Payment'){
  //   return am4core.color("#0267e8");
  // }
  // if(_this.vehicle_purchase_and_lease_input_value && target.dataItem.categories.categoryY === 'Car Payments'){
  //   return am4core.color("#0267e8");
  // }
  // if(_this.debt_input_value && target.dataItem.categories.categoryY === 'Other Debt Payments & Obligations'){
  //   return am4core.color("#0267e8");
  // }
  // if(_this.savings_value && target.dataItem.categories.categoryY === 'Target Amount to Savings Each Period'){
  //   return am4core.color("#0267e8");
  // }
  methods: {
    incomeChange(key, manual) {
      const inc = _.cloneDeep(this.net_amount);
      if (manual === "2") {
        inc[key] = {
          amount: "",
          freq: 12,
          manual: manual,
          occupation: null,
          level: null,
          grossOrNet: manual == "2" ? "net" : "gross",
          net: 0,
          gross: 0,
        };
      } else {
      }

      inc[key] = {
        amount: "",
        freq: 12,
        manual: manual,
        occupation: null,
        level: null,
        grossOrNet: "net",
        net: 0,
        gross: 0,
      };

      this.net_amount = inc;
    },
    async levelChange(key, level, occupation) {
      if (occupation && level) {
        const selectedOccupation = this.occupations.find(
          (item) => item.id == occupation
        );
        let occ = null;

        if (level == 1) {
          occ = `${selectedOccupation.low.toFixed(0)}`;
        } else if (level == 2) {
          occ = `${selectedOccupation.median.toFixed(0)}`;
        } else if (level == 3) {
          occ = `${selectedOccupation.high.toFixed(0)}`;
        }
        const inc = _.cloneDeep(this.net_amount);

        const url = "https://api.spendid.io/v1.0/calculators/net-income?gross=";
        const URI = `${url}${occ}&zip=${this.zip}`;
        const config = {
          headers: { "x-api-key": "HTDzMgEntXaBYVFZ6SSth2iosFRjVe7F8QtM4HBr" },
        };
        const net = await this.$http.get(URI, config);

        inc[key] = {
          amount: occ,
          freq: 1,
          manual: "1",
          occupation,
          level: level,
          grossOrNet: "gross",
          gross: parseInt(occ / 12),
          net: net.data.net_annual_income / 12,
        };

        this.net_amount = inc;
      } else {
        const inc = _.cloneDeep(this.net_amount);
        inc[key] = {
          ...inc[key],
          amount: "0",
          freq: 1,
          manual: "1",
          grossOrNet: "gross",
          gross: 0,
          net: 0,
        };
        this.net_amount = inc;
      }
    },
    onSeourceSelect: _.debounce(async function (i, input = true) {
      console.log(this.net_amount[i], "1");
      const value = await this.recalculateNetAsync(
        this.unmaskMoneyValue(this.net_amount[i].amount) *
          this.net_amount[i].freq,
        this.net_amount[i].grossOrNet
      );
      if (this.net_amount[i].grossOrNet === "gross") {
        this.net_amount[i].gross =
          (this.unmaskMoneyValue(this.net_amount[i].amount) *
            this.net_amount[i].freq) /
          12;
        this.net_amount[i].net = value;
      } else {
        this.net_amount[i].net =
          (this.unmaskMoneyValue(this.net_amount[i].amount) *
            this.net_amount[i].freq) /
          12;
        this.net_amount[i].gross = value;
      }
    }, 400),
    occupationSelect() {
      const val = this.occupations_val;
      if (val && this.annual_gross_salary_level_val) {
        const selectedOccupation = this.occupations.find(
          (item) => item.id == val
        );
        if (this.annual_gross_salary_level_val == 1) {
          console.log(selectedOccupation.low, "1");
          this.occupationGrossIncome = selectedOccupation.low;
          this.net_amount = [
            {
              amount: `$${selectedOccupation.low}`,
              freq: 1,
            },
          ];
        } else if (this.annual_gross_salary_level_val == 2) {
          this.occupationGrossIncome = selectedOccupation.median;
          this.net_amount = [
            {
              amount: `$${selectedOccupation.median}`,
              freq: 1,
            },
          ];
        } else if (this.annual_gross_salary_level_val == 3) {
          this.occupationGrossIncome = selectedOccupation.high;
          this.net_amount = [
            {
              amount: `$${selectedOccupation.high}`,
              freq: 1,
            },
          ];
        } else {
        }
      }
      const sum = this.net_amount.reduce(
        (partialSum, a) =>
          partialSum + parseFloat(this.unmaskMoneyValue(a.amount)) * a.freq,
        0
      );
      this.recalculateNet(Math.round(sum / 12));
    },
    income_method_val_change(event) {
      if (event) {
        this.occupations_val = null;
        this.annual_gross_salary_level_val = 0;
        this.occupationGrossIncome = "0";
      } else {
        this.net_amount = [
          {
            amount: "",
            freq: 12,
          },
        ];
      }
      this.netAmount = "a";
    },
    predictGrowthChange() {
      this.predictGrowth =
        this.predictGrowth &&
        parseFloat(this.predictGrowth).toFixed(1).toString();
    },
    generateNumbers(age) {
      const min = age;
      const max = 65;
      const totalNumbers = 5;
      const gap = (max - min) / (totalNumbers - 1); // Calculate the gap between numbers

      const numbers = [];

      for (let i = 0; i < totalNumbers; i++) {
        const number = min + i * gap;
        if (number <= 65) {
          numbers.push(Math.ceil(number));
        } else {
          break; // Stop if the next number exceeds 65
        }
      }

      return numbers;
    },
    increaseValueByPercentage(value, percentage) {
      // Ensure that both value and percentage are numbers
      if (typeof value !== "number" || typeof percentage !== "number") {
        return "Both the value and the percentage must be numbers.";
      }

      // Calculate the increase
      const increase = (value * percentage) / 100;

      // Calculate the new value
      const newValue = value + increase;

      return newValue;
    },
    generateGrowthChart(values) {
      // Initialize AmCharts
      am4core.useTheme(am4themes_animated);

      // Create a chart instance
      const chart = am4core.create("chartdiv", am4charts.XYChart);

      // Add data
      chart.data = values; // Make sure "values" is an array of objects with "age" and "value" properties

      // Add legend
      chart.legend = new am4charts.Legend();

      // Add bottom label
      var label = chart.chartContainer.createChild(am4core.Label);
      label.text = "Age";
      // label.marginTop = -50;
      label.align = "center";
      label.fontWeight = 600;

      // Create category axis
      const categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "age";
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.minGridDistance = 40;
      categoryAxis.renderer.labels.template.rotation = -60;
      categoryAxis.renderer.labels.template.verticalCenter = "middle";
      categoryAxis.renderer.labels.template.horizontalCenter = "right";

      // Create value axis
      const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.numberFormatter.numberFormat = "$#,###";

      // Create line series
      const series = chart.series.push(new am4charts.LineSeries());
      series.dataFields.valueY = "value";
      series.dataFields.categoryX = "age";
      series.name = "You";
      series.tooltipText = "{categoryX}: [bold]{valueY}[/]";
      series.fill = am4core.color("#0E6DE5");
      series.stroke = am4core.color("#0E6DE5");
      // Create bullet (marker) for tooltips
      const bullet = series.bullets.push(new am4charts.CircleBullet());
      bullet.fill = am4core.color("#0267e8");
      bullet.fill = am4core.color("#0E6DE5");
      bullet.circle.stroke = am4core.color("#0E6DE5");

      // Create second line series
      const series2 = chart.series.push(new am4charts.LineSeries());
      series2.dataFields.valueY = "value2"; // Replace with the property for the second series values in your data
      series2.dataFields.categoryX = "age";
      series2.name = "Peers";
      series2.tooltipText = "{categoryX}: [bold]{valueY}[/]";
      series2.fill = am4core.color("#2BA195");
      series2.stroke = am4core.color("#2BA195");
      // Create bullet (marker) for tooltips for the second series
      const bullet2 = series2.bullets.push(new am4charts.CircleBullet());
      bullet2.fill = am4core.color("#2BA195"); // Change marker color if needed
      bullet2.circle.stroke = am4core.color("#2BA195");

      // Enable zoom and pan (optional)
      chart.cursor = new am4charts.XYCursor();
      chart.cursor.behavior = "zoomXY";

      // Add a scrollbar (optional)
      // chart.scrollbarX = new am4core.Scrollbar();

      // Ensure the chart is properly disposed when no longer needed
      // chart.dispose();
    },
    calculateTotalReturn(initialAmount, years, annualPercentage) {
      if (years <= 0 || annualPercentage <= 0) {
        return "Invalid input. Please provide positive values for years and annual percentage.";
      }
      for (let i = 1; i <= years; i++) {
        initialAmount += initialAmount * (annualPercentage / 100);
      }
      return initialAmount.toFixed(2); // Return the total return rounded to 2 decimal places
    },
    calculateInvestment(
      endYears,
      returnRate,
      compoundFrequency,
      monthlyContribution
    ) {
      // Convert annual return rate to monthly rate
      const monthlyRate = returnRate / 100 / 12;
      const totalMonths = endYears * 12;

      let endBalance = 0;

      for (let month = 1; month <= totalMonths; month++) {
        // Calculate interest for the current month
        const interest = endBalance * monthlyRate;
        // Add the monthly contribution at the end of the month
        endBalance = endBalance + interest + monthlyContribution;
      }

      return endBalance.toFixed(0);
    },
    openProjectedGrowth() {
      let projectGrowth = localStorage.getItem("projectGrowth") || 6;
      if (projectGrowth) {
        projectGrowth = parseFloat(projectGrowth).toFixed(1);
        this.projectGrowthView(projectGrowth);
      }
    },
    projectGrowthView(percentageIncrease) {
      const monthly_cash_excess = parseInt(
        this.lending_score.elements.cash_excess / 12
      );
      const saving =
        this.filtered_barchart.length > 0 ? this.filtered_barchart[4] : null;
      const currentAge = parseInt(this.age);
      const diff = this.generateNumbers(currentAge);
      localStorage.setItem("projectGrowth", percentageIncrease);
      console.log(diff, currentAge, monthly_cash_excess);
      const values = diff.map((item) => {
        var gap = item - currentAge;
        return {
          age: `${item}yr`,
          value:
            gap > 0
              ? this.calculateInvestment(
                  gap,
                  percentageIncrease,
                  "monthly",
                  monthly_cash_excess
                )
              : monthly_cash_excess,
          value2:
            gap > 0
              ? this.calculateInvestment(
                  gap,
                  percentageIncrease,
                  "monthly",
                  saving.peer_monthly
                )
              : saving.peer_monthly,
        };
      });
      // const saving =
      //   this.filtered_barchart.length > 0 ? this.filtered_barchart[4] : null;
      console.log(values);
      this.predictGrowth = percentageIncrease;
      this.$refs["projectGrowth"].show();
      setTimeout(() => {
        this.generateGrowthChart(values);
      }, 500);
    },
    async getOccupation() {
      const URI = "https://api.spendid.io/v1.0/occupations";

      const config = {
        headers: { "x-api-key": "HTDzMgEntXaBYVFZ6SSth2iosFRjVe7F8QtM4HBr" },
      };
      const occu = await this.$http.get(URI, config);
      this.occupations = occu.data.occupations;
      if (this.income_method_val) {
        this.occupationSelect();
      }
      console.log(occu, "occu");
    },
    defaultActiveTabAction(event) {
      this.defaultActiveTab = event;
      console.log(event, "event");
    },
    async recalculateNetAsync(amount, grossOrNet) {
      if (typeof this.cancelToken != typeof undefined) {
        this.cancelToken.cancel("Operation canceled due to new request.");
      }
      this.cancelToken = axios.CancelToken.source();
      const url =
        grossOrNet === "gross"
          ? "https://api.spendid.io/v1.0/calculators/net-income?gross="
          : "https://api.spendid.io/v1.0/calculators/gross-income?net=";

      const URI = `${url}${amount}&zip=${this.zip}`;
      const config = {
        headers: { "x-api-key": "HTDzMgEntXaBYVFZ6SSth2iosFRjVe7F8QtM4HBr" },
        cancelToken: this.cancelToken.token,
      };
      const net = await this.$http.get(URI, config);
      return (
        (net.data.net_annual_income && net.data.net_annual_income / 12) ||
        (net.data.gross_annual_income && net.data.gross_annual_income / 12)
      );
    },
    async recalculateNet(amount) {
      if (typeof this.cancelToken != typeof undefined) {
        this.cancelToken.cancel("Operation canceled due to new request.");
      }
      this.cancelToken = axios.CancelToken.source();

      const url =
        this.grossOrNet === "gross"
          ? "https://api.spendid.io/v1.0/calculators/net-income?gross="
          : "https://api.spendid.io/v1.0/calculators/gross-income?net=";

      const URI = `${url}${amount * 12}&zip=${this.zip}`;
      const config = {
        headers: { "x-api-key": "HTDzMgEntXaBYVFZ6SSth2iosFRjVe7F8QtM4HBr" },
        cancelToken: this.cancelToken.token,
      };
      const net = await this.$http.get(URI, config);
      this.netAmount =
        (net.data.net_annual_income && net.data.net_annual_income / 12) ||
        (net.data.gross_annual_income && net.data.gross_annual_income / 12);

      if (this.checkForValidate()) {
        this.is_typing = true;
        this.api_updates_pending = true;
        await this.updateCharts();
      }
    },
    getAdvice() {
      const data = {
        title: "Income",
        predicted: 0,
        peer: 0,
        type: "Major",
        age: this.age,
        zip: this.zip,
      };
      this.uses = data;
      this.modalShow = true;
    },
    emailDownloadWithCss() {
      this.$refs["email-popup-pdf"].show();
    },
    pageReload() {
      window.location.href = "https://business.spendid.io/login";
    },
    // resetUserActivityTimeout() {
    //   if (
    //     this.$cookies.get("userDetail") &&
    //     this.$cookies.get("userDetail").data.access_token
    //   ) {
    //     clearTimeout(this.userActivityTimeout);
    //     this.userActivityTimeout = setTimeout(() => {
    //       this.inactiveUserAction();
    //     }, 900000);
    //   }
    // },
    inactiveUserAction() {
      this.$refs["logout-popup"].show();
      this.$cookies.remove("userDetail");
      localStorage.removeItem("storedData");
      this.$cookies.remove("assessmentId");
      localStorage.removeItem("accessToken");
    },
    async fillAutoData(data) {
      if (data.data.data.demographics) {
        const demog = data.data.data.demographics;
        const budget = data.data.data.budget;
        this.age = demog.age;
        this.zip = demog.zip;
        this.household_members = demog.household_members;
        this.is_homeowner = demog.is_homeowner === 1;
        this.net_amount = [
          { amount: (demog.net_annual_income / 12).toFixed(0), freq: 12 },
        ];
        this.stepEnable = false;

        const rest = {};
        const rest_data = {};

        if (budget.other_debt_payments != null) {
          this.debt_input_value = `$${(budget.other_debt_payments / 12).toFixed(
            0
          )}`;
          rest_data["other_debt_payments"] = budget.other_debt_payments;
        }

        if (budget.mortgage_and_rent != null) {
          this.mortgage_and_rent_input_value = `$${(
            budget.mortgage_and_rent / 12
          ).toFixed(0)}`;
          rest_data["mortgage_and_rent"] = budget.mortgage_and_rent;
        }

        if (budget.vehicle_purchase_and_lease != null) {
          this.vehicle_purchase_and_lease_input_value = `$${(
            budget.vehicle_purchase_and_lease / 12
          ).toFixed(0)}`;
          rest_data["vehicle_purchase_and_lease"] =
            budget.vehicle_purchase_and_lease;
        }

        if (budget.health_insurance != null) {
          this.health_insurance_input_value = `$${(
            budget.health_insurance / 12
          ).toFixed(0)}`;
          rest_data["health_insurance"] = budget.health_insurance;
        }

        if (data.data.data.isRequestBudget) {
          const otherData = Object.keys(transformer_38).filter(
            (item, k) => k > 4
          );
          await otherData.map((item) => {
            if (data.data.data.isRequestBudget[item]) {
              rest_data[item] = parseInt(data.data.data.isRequestBudget[item]);
              rest[item] = {
                value: (data.data.data.isRequestBudget[item] / 12).toFixed(0),
                freq: 12,
              };
            }
            return true;
          });
          this.changedValuesText = rest;
          this.changedValues = rest_data;
          //   this.updateCharts();
        }

        this.activeTab = "Your Result";
      } else {
        this.stepEnable = false;
        this.activeTab = "Your Profile";
      }

      // setTimeout(() => {
      //   this.updateCharts();
      // }, 2000);
    },
    onByPass() {},
    goto(activeTabTitle) {
      this.activeTab = activeTabTitle;
      window.scrollTo(0, 0);
    },
    async saveReport(arg) {
      const callBudgetAPI = this.callBudgetAPIRes;
      callBudgetAPI["budget"]["cash_contributions_gift"] =
        "cash_contributions_gift" in this.changedValues
          ? this.changedValues["cash_contributions_gift"]
          : (((this.grossOrNet === "gross"
              ? this.monthly_take_home
              : this.monthly_take_home_net) *
              this.monthly_take_home_input_value_freq) /
              12) *
            0.01 *
            12;
      callBudgetAPI["transformed"]["Gifts to Family & Friends"] =
        "cash_contributions_gift" in this.changedValues
          ? this.changedValues["cash_contributions_gift"]
          : (((this.grossOrNet === "gross"
              ? this.monthly_take_home
              : this.monthly_take_home_net) *
              this.monthly_take_home_input_value_freq) /
              12) *
            0.01 *
            12;

      callBudgetAPI["budget"]["cash_contributions"] =
        "cash_contributions" in this.changedValues
          ? this.changedValues["cash_contributions"]
          : callBudgetAPI["budget"]["cash_contributions"] -
            (((this.grossOrNet === "gross"
              ? this.monthly_take_home
              : this.monthly_take_home_net) *
              this.monthly_take_home_input_value_freq) /
              12) *
              0.01 *
              12;
      callBudgetAPI["transformed"]["Charitable Giving"] =
        "cash_contributions" in this.changedValues
          ? this.changedValues["cash_contributions"]
          : callBudgetAPI["budget"]["cash_contributions"] -
            (((this.grossOrNet === "gross"
              ? this.monthly_take_home
              : this.monthly_take_home_net) *
              this.monthly_take_home_input_value_freq) /
              12) *
              0.01 *
              12;

      const callDemographicsAPI = this.callDemographicsAPIRes;
      callDemographicsAPI["model"]["cash_contributions_gift"] =
        (((this.grossOrNet === "gross"
          ? this.monthly_take_home
          : this.monthly_take_home_net) *
          this.monthly_take_home_input_value_freq) /
          12) *
        0.01 *
        12;
      callDemographicsAPI["transformed"]["Gifts to Family & Friends"] =
        (((this.grossOrNet === "gross"
          ? this.monthly_take_home
          : this.monthly_take_home_net) *
          this.monthly_take_home_input_value_freq) /
          12) *
        0.01 *
        12;

      callDemographicsAPI["model"]["cash_contributions"] =
        callDemographicsAPI["model"]["cash_contributions"] -
        (((this.grossOrNet === "gross"
          ? this.monthly_take_home
          : this.monthly_take_home_net) *
          this.monthly_take_home_input_value_freq) /
          12) *
          0.01 *
          12;
      callDemographicsAPI["transformed"]["Charitable Giving"] =
        callDemographicsAPI["model"]["cash_contributions"] -
        (((this.grossOrNet === "gross"
          ? this.monthly_take_home
          : this.monthly_take_home_net) *
          this.monthly_take_home_input_value_freq) /
          12) *
          0.01 *
          12;

      const req = {
        apiReq: this.apiReq,
        callDemographicsAPIRes: callDemographicsAPI,
        callBudgetAPIRes: callBudgetAPI,
        callScoringAPIRes: this.callScoringAPIRes,
        callLendingScoreAPIRes: this.callLendingScoreAPIRes,
      };
      console.log(req);
      this.$http
        .post(
          "https://admin.spendid.io/api/store-user-info-for-report-download",
          req,
          {}
        )
        .then((response) => {
          const demographicsId = response.data.data.demographics.id;
          const previewUrl = arg
            ? `https://admin.spendid.io/preview/${demographicsId}?email=${this.user_email_pdf}&origin=mybudgetreport&iframe=7`
            : `https://admin.spendid.io/preview/${demographicsId}?mybudgetreport=true&iframe=7`;

          window.open(previewUrl, "_blank");

          if (arg) {
            this.user_email_pdf = "";
            this.$refs["email-popup-pdf"].hide();
          }
        })
        .catch((error) => {
          console.error("Error saving report:", error);
          // Handle errors from the POST request
        });
      // this.$toasted.success("Report Saved").goAway(3000);
      // this.dataSent = req;
    },
    handleFocusOut() {
      try {
        this.$refs.coreexp[0].hideMenus();
        this.$refs.coreexp[1].hideMenus();
        this.$refs.coreexp[2].hideMenus();
        this.$refs.coreexp[3].hideMenus();
      } catch (e) {}
    },
    submitStepForm(data) {
      console.log(data, "data");
      this.income_method_val = data.income_method === "2" ? false : true;
      this.stepEnable = false;
      this.age = data.age;
      this.household_members = parseInt(data.numberOfPeople);
      this.zip = data.zip;
      this.is_homeowner = data.rentOrOwn === "own";
      this.net_amount = data.incomes;
      this.user_email = data.finalEmail;
      this.user_name = data.finalEmail;
      this.grossOrNet = data.grossOrNet;
      (this.annual_gross_salary_level_val = data.annual_gross_salary_level_val),
        (this.occupations_val = data.occupations_val),
        // this.mortgage_and_rent_input_value = `$${data.monthlyRent}` || "0";
        (this.mortgage_and_rent_input_value_freq = 12);
      // this.vehicle_purchase_and_lease_input_value =
      //   `$${data.totalMonthly}` || "0";
      this.vehicle_purchase_and_lease_input_value_freq = 12;

      this.health_insurance_input_value_freq = 12;

      const rest_data = {};
      const rest = {};

      const debt = [
        data.otherDebtPayments,
        data.creditDebtPayment,
        data.studentLoan,
        data.alimonyPayments,
        data.homeEquityPayment,
        data.childSupportPayments,
      ]
        .filter(Number)
        .reduce((partialSum, a) => parseInt(partialSum) + parseInt(a), 0);

      if (data.healthPremiumAmount || data.age >= 26) {
        this.health_insurance_input_value =
          `$${data.healthPremiumAmount}` || "$0";

        rest["health_insurance"] = data.healthPremiumAmount
          ? parseInt(
              (data.healthPremiumAmount ? data.healthPremiumAmount : 0) * 12
            )
          : 0;
        rest["other_debt_payments"] = debt
          ? parseInt((debt ? debt : 0) * 12)
          : 0;

        rest_data["health_insurance"] = {
          value: (data.healthPremiumAmount
            ? data.healthPremiumAmount
            : 0
          ).toFixed(0),
          freq: 12,
        };

        rest_data["other_debt_payments"] = {
          value: debt ? parseInt(debt ? debt.toFixed(0) : 0) : 0,
          freq: 12,
        };
      } else {
        this.health_insurance_input_value = "0";

        rest["health_insurance"] = data.healthPremiumAmount
          ? parseInt(
              (data.healthPremiumAmount ? data.healthPremiumAmount : 0) * 12
            )
          : 0;
        rest["other_debt_payments"] = debt
          ? parseInt((debt ? debt : 0) * 12)
          : 0;

        rest_data["health_insurance"] = {
          value: (data.healthPremiumAmount
            ? data.healthPremiumAmount
            : 0
          ).toFixed(0),
          freq: 12,
        };

        rest_data["other_debt_payments"] = {
          value: debt ? parseInt(debt ? debt.toFixed(0) : 0) : 0,
          freq: 12,
        };
      }

      this.changedValuesText = rest_data;
      this.changedValues = rest;

      this.debt_input_value = `$${debt}` || "0";
      this.debt_input_value_freq = 12;
      this.visibleOtherExpCat = false;
      this.visibleCoreExpCat = false;
      if (window.innerWidth <= 800) {
        this.visibleProfileHousehold = false;
      } else {
        this.visibleProfileHousehold = true;
      }
      localStorage.setItem("firstSession", "1");
      // this.$bvModal.show('instructionModal');
      setTimeout(() => {
        this.goto("Your Result");
      }, 1000);
    },
    addIncome() {
      this.net_amount.push({
        amount: "",
        freq: 12,
        manual: "2",
        occupation: null,
        level: null,
        grossOrNet: "net",
        net: 0,
        gross: 0,
      });
    },
    deleteIncome(counter) {
      this.net_amount.splice(counter, 1);
    },
    onComparePeer() {
      this.visibleCoreExpCat = !this.visibleCoreExpCat;
      this.visibleCustCoreExp = false;
      this.visibleVhCustCoreExp = false;
      this.visibleDbtCustCoreExp = false;
    },
    firstScroll() {
      this.visibleCustCoreExp = true;
      this.visibleCoreExp = true;
      this.visibleYourHousehold = false;
      // setTimeout(() => {
      //   const el = document.getElementById(`your-core-expenses-new`)
      //     el.scrollIntoView({
      //       behavior: 'smooth',
      //       block: 'nearest',
      //       inline: 'nearest'
      //     });
      // }, 10)
    },

    showResultSection() {
      if (
        !(this.mortgage_and_rent_value >= 0) ||
        this.mortgage_and_rent_value == null
      ) {
        this.visibleCustCoreExp = true;
        // this.$toasted.error('Rent or Mortgage Payment is required.').goAway(3000);
      } else if (
        !(this.vehicle_purchase_and_lease_value >= 0) ||
        this.vehicle_purchase_and_lease_value == null
      ) {
        this.visibleVhCustCoreExp = true;
        // this.$toasted.error('Car Payments is required.').goAway(3000);
      } else if (!(this.debt_value >= 0) || this.debt_value == null) {
        this.visibleDbtCustCoreExp = true;
        // this.$toasted.error('Other Debt Payments & Obligations is required.').goAway(3000);
      } else if (
        !(this.health_insurance_value >= 0) ||
        this.health_insurance_value == null
      ) {
        this.visibleSvAmtCoreExp = true;
        // this.$toasted.error('Target amount to savings each period is required.').goAway(3000);
      } else {
        this.visibleCoreExpCat = false;
        this.visibleOtherExpCat = true;
        this.visibleYourHousehold = false;
        setTimeout(() => {
          const el = document.getElementById(`other-expense-accordion-1`);
          el.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }, 200);
      }
    },
    majorExpenceOpen() {
      if (
        this.debt_value !== null &&
        this.debt_value >= 0 &&
        this.vehicle_purchase_and_lease_value !== null &&
        this.vehicle_purchase_and_lease_value >= 0 &&
        this.mortgage_and_rent_value !== null &&
        this.mortgage_and_rent_value >= 0 &&
        this.health_insurance_value !== null &&
        this.health_insurance_value >= 0
      ) {
        this.visibleOtherExpCat = true;
        this.visibleCoreExpCat = false;
        this.visibleYourHousehold = false;
        this.visibleCoreExp = false;
        window.scrollTo(0, 0);
        // setTimeout(() => {
        // const el = document.getElementById(`list-view-grid-expense-new`);
        //   el.scrollIntoView({
        //     behavior: 'smooth',
        //     block: "start",
        //     inline: "nearest"
        //   });
        // }, 0)
      } else {
        if (
          !(this.mortgage_and_rent_value >= 0) ||
          this.mortgage_and_rent_value == null
        ) {
          this.visibleCustCoreExp = true;
          // this.$toasted.error('Rent or Mortgage Payment is required.').goAway(3000);
        } else if (
          !(this.vehicle_purchase_and_lease_value >= 0) ||
          this.vehicle_purchase_and_lease_value == null
        ) {
          this.visibleVhCustCoreExp = true;
          // this.$toasted.error('Car Payments is required.').goAway(3000);
        } else if (!(this.debt_value >= 0) || this.debt_value == null) {
          this.visibleDbtCustCoreExp = true;
          // this.$toasted.error('Other Debt Payments & Obligations is required.').goAway(3000);
        }
        //  else if(!(this.savings_value >= 0)|| this.savings_value==null){
        //   this.visibleSvAmtCoreExp = true
        //   // this.$toasted.error('Target amount to savings each period is required.').goAway(3000);
        //  }
      }
    },
    // async checkResultToggle(){
    //     if(!this.user_name || !this.user_email){
    //       this.verifyMsg = ''
    //       this.verifyEnable = true
    //       this.$refs['email-popup'].show();
    //       this.visibleCashHealthAnalysis=false;
    //     } else {
    //       this.visibleCashHealthAnalysis = !this.visibleCashHealthAnalysis

    //       const el = document.getElementById(`cash-flow-score`)
    //       var headerOffset = 280;
    //       var elementPosition = el.getBoundingClientRect().top;
    //       var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    //       setTimeout(() => {
    //         // window.scrollTo(0, 200);
    //             window.scrollTo({
    //                 top: offsetPosition,
    //                 behavior: "smooth"
    //             });
    //         }, 500)
    //     }
    // },
    async checkResultToggle() {
      // this.visibleCashHealthAnalysis = !this.visibleCashHealthAnalysis;
      // const el = document.getElementById(`result-flow-score`);
      // var headerOffset = 280;
      // var elementPosition = el.getBoundingClientRect().top;
      // var offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      // setTimeout(() => {
      //   window.scrollTo({
      //     top: offsetPosition,
      //     behavior: "smooth"
      //   });
      // }, 500);
    },
    sendOtp() {
      /* eslint-disable */
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.user_email)) {
        this.verifyMsg =
          '<p class="text-danger text-center">Email is required.</p>';
        return false;
      }

      this.$http
        .post(`${new_api}/send-otp`, {
          email: this.user_email,
        })
        .then(() => {
          this.verifyEnable = false;
          this.verifyMsg =
            '<p class="text-success  text-center">Code sent to entered email.</p>';
        });
    },
    verifyEmail() {},
    validateCheck() {
      if (!this.user_name) {
        // this.$toasted.error('Name is required.').goAway(1500);
        /* eslint-disable */
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.user_email)) {
        // this.$toasted.error('Email is required.').goAway(1500);
      } else if (!this.age || this.age < 18) {
        // this.$toasted.error('Age must be 18+').goAway(1500);
      }
    },
    changeEdu(arg) {
      this.defaultEducation = arg;
    },
    changeUseCase(arg) {
      this.useCase = arg;
      this.defaultUseCase = arg;
    },
    async loadUser() {
      // const URI = `https://${domain}/userinfo`;
      this.loginLoading = true;
      // const config = {
      //     headers: { "Content-Type": "application/json", Authorization: `Bearer ${this.access_token}` },
      // }
      try {
        // const result = await this.$http.get(URI, config);
        this.loginLoading = false;
        this.auth["user"] = {
          name: this.$route.query.name,
          email: this.$route.query.email,
        };
      } catch (err) {
        this.access_token = "";
        this.loginLoading = false;
      }
    },
    async registerUser() {
      // const form = new FormData();
      // form.append('email', this.$auth.user.email);
      // form.append('name', this.$auth.user.name);
      // form.append('user_id', this.$auth.user.sub);
      // form.append('portal', portal);
      // const result = await this.$http.post(URI, form);
    },
    // download() {
    //   const doc = new jsPDF();
    //   const contentHtml = this.$refs.content.innerHTML;
    //   doc.html(contentHtml);
    //   doc.save("sample.pdf");
    // },
    async downloadWithCSS(arg) {
      const state =
        zip_codes.find((item) => item["Zip Code"] === this.zip) &&
        state_gross.find(
          (it) =>
            it.abbreviation ===
            zip_codes.find((item) => item["Zip Code"] === this.zip)["State"]
        ).state;
      const city =
        zip_codes.find((item) => item["Zip Code"] === this.zip) &&
        zip_codes.find((item) => item["Zip Code"] === this.zip)["City"];
      const text = `You are to create a Report of age-appropriate things for a ${this.age}-year-old to enjoy near the US zip code ${this.zip}. 

        Begin with the following Report Title in large font and bold:     

        Enjoying Life in (the city and state of zip code ${this.zip})

        Then create five report sections showing a bold html <b> tag Title for each section. For each of these five sections, you are to offer five different places or activities that fit within the description of that section. 

        For each listed place or activity, include the name in bold  and a brief summary and the street address and phone number on the line below the name and summary.

        ·Five of the most popular outdoor activities popular in or near the area.
        ·Five of the largest houses of worship in or near the area.
        ·Five of the most famous theater, museum, art exhibit or similar venues in or near the area. 
        ·Five of the most popular yoga studios or other types of exercise facilities in or near the area. 
        ·Five popular bars or nightclubs in or near the area. 


        Finally, show a Conclusion section emphasizing that because GRADBUDGET is continually updating its data, users should plan to utilize GRADBUDGET for the long-term. This keeps budget awareness as a “front of mind” thought and is key to maintaining financial awareness and keeping your lifestyle aligned with your income. title should be in bold html tag inside <b>.
        `;

      // return true;
      // if(this.dark){
      //   this.$refs['themeColor'].show()
      //   return false
      // }
      //pie2, pie3, pie4

      if (!arg) {
        this.$refs["email-popup-pdf"].hide();
      }

      this.percentage = 0;

      this.isActive = false;
      const _this = this;
      const gridF = this.gridFirst;
      const visibleCoreExpCat = this.visibleCoreExpCat;
      const visibleDisabledCat = this.visibleDisabledCat;
      const visibleOtherExpCat = this.visibleOtherExpCat;
      const visibleProfileHousehold = this.visibleProfileHousehold;
      const visibleCashHealthAnalysis = this.visibleCashHealthAnalysis;
      const gridSecond = this.gridSecond;
      this.visibleCoreExpCat = true;
      this.visibleDisabledCat = true;
      this.visibleOtherExpCat = true;
      this.visibleCashHealthAnalysis = true;
      this.gridFirst = true;
      this.gridSecond = true;
      const doc = new jsPDF("p", "mm", "a4");
      let screenWidth = screen.width;
      document.createElement("canvas");

      setInterval(() => {
        if (this.percentage < 90) {
          this.percentage += 15;
        }
      }, 6000);

      const [imgData, bar, pie2, pie3, pie5] = await Promise.all([
        this.speed_chart.exporting.getImage("png"),
        // this.pie_chart.exporting.getImage("png"),
        this.bar_chart.exporting.getImage("png"),
        this.pie_chart3.exporting.getImage("png", 300, 300),
        this.pie_chart4.exporting.getImage("png", 300, 300),
        this.pie_chart5.exporting.getImage("png", 300, 300),
      ]);
      // eslint-disable-next-line no-console

      // fonts = [['Poppins','bold']]

      doc.autoTable({
        // styles: { fillColor: [255, 0, 0] },
        // columnStyles: { 0: { halign: 'center', fillColor: [0, 255, 0] } }, // Cells in first column centered and green
        margin: { top: 136, right: 10, left: 10 },
        styles: {
          overflow: "linebreak",
          columnWidth: "wrap",
          fontSize: 12,
          cellPadding: 3,
          overflowColumns: "linebreak",
        },
        body: [
          ["Net Take Home Pay", this.monthly_take_home_input_value],
          ["5-Digit Zip Code", this.zip],
          ["Age", this.age],
          ["# in Household", this.household_members],
          ["Housing Type", this.is_homeowner ? "Owner" : "Renter"],
        ],
      });

      // doc.save('Report.pdf');
      // doc.save('table.pdf')

      /** WITH CSS */

      // const dM=12 // default Margin
      // let pm =0 // Page Margin

      // pm+=dM // 12
      // pm +=dM // 24

      doc.setPage(1);
      //var img ='logov.png';
      var img = "spendid-logo.png";
      // doc.addImage(img, 'png', 10, 78, 12, 15)
      // doc.setFontSize(18)
      // doc.setTextColor(46, 43, 107);
      // doc.text(100, 20, 'SPENDiD Report', 'center');

      const monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];

      doc.addImage(img, "PNG", 62, 10, 75, 30); // Logo
      doc.setFontSize(14);
      doc.setTextColor(87, 181, 163);
      // doc.text(100, 50, 'Name', 'center'); // Name Label
      // doc.setFontSize(10)
      // doc.setTextColor(84, 84, 84);
      // doc.text(100, 55,  this.user_name, 'center'); // Name Value
      doc.setFontSize(14);
      doc.setTextColor(87, 181, 163);
      doc.text(100, 65, "Report Date", "center"); // Report Date Label
      doc.setFontSize(10);
      doc.setTextColor(84, 84, 84);
      doc.text(
        100,
        70,
        `${
          monthNames[new Date().getMonth()]
        } ${new Date().getDate()}, ${new Date().getFullYear()}`,
        "center"
      ); // Report Date Value
      doc.setFontSize(14);
      doc.setTextColor(87, 181, 163);
      // doc.text(100, 80, 'Email Address', 'center');
      // doc.setFontSize(10)
      // doc.setTextColor(84, 84, 84);
      // doc.text(100, 85, this.user_email, 'center');
      doc.setLineWidth(0.1);
      doc.line(0, 100, 500, 100); // horizontal line
      doc.setFontSize(18);
      doc.setTextColor(24, 15, 79);
      doc.setFont(undefined, "bold");
      doc.text(100, 115, "All Amounts Are Monthly", "center");
      doc.setFontSize(20);
      doc.setTextColor(87, 181, 163);
      doc.setFont(undefined, "bold");
      doc.text(10, 130, "About You");

      // var imgpie ='piechart.bmp';
      // // doc.addImage(img, 'png', 10, 78, 12, 15)
      // // doc.setFontSize(18)
      // // doc.setTextColor(46, 43, 107);
      // // doc.text(100, 20, 'SPENDiD Report', 'center');
      // doc.addImage(imgpie, 'bmp', 10, 20, 180, 10); // piechart
      doc.setFontSize(20);
      doc.setTextColor(87, 181, 163);
      doc.setFont(undefined, "bold");
      doc.text(100, 205, "Results", "center");
      // setTimeout(()=>{
      // html2canvas(_this.$refs.second_sec).then((canvas)=>{
      //   const img = canvas.toDataURL("image/jpeg", 0.8);
      //   doc.addImage(img,'JPEG',0,0,width, 250);
      // doc.setFontSize(17);
      // doc.setFillColor(58, 183, 164);
      // doc.rect(85, 16, 30, 14, 'F');
      // doc.setTextColor(256, 256, 256);
      // doc.text(100,25, 'USD.00', 'center');
      doc.setFontSize(15);
      doc.setTextColor(0, 0, 0);
      doc.setFont(undefined, "bold");
      doc.text(10, 220, "SPENDiD Score");
      doc.addImage(imgData, "JPEG", 10, 210, 55, 40);
      doc.setFontSize(14);
      doc.setTextColor(0, 0, 0);
      doc.setFont(undefined, "normal");
      doc.text(110, 232, `Predicted Saving Ability (PSA):`);
      doc.setTextColor(87, 181, 163);
      doc.setFont(undefined, "bold");
      doc.text(180, 232, `${this.lending_score_cash_excess_formatted}`);
      doc.setFontSize(10);
      doc.setTextColor(0, 0, 0);
      doc.setFont(undefined, "normal");
      // doc.text(75, 240, this.returnDefaultTextOnly().mainText);

      var splitText = doc.splitTextToSize(
        this.returnDefaultTextOnly().descriptiveText,
        100
      );
      doc.text(75, 240, splitText);

      doc.setFontSize(15);
      doc.setTextColor(0, 0, 0);
      doc.setFont(undefined, "bold");
      // doc.setFont(undefined, "normal");
      var splitTitle = doc.splitTextToSize(
        this.returnDefaultTextOnly().mainText,
        50
      );

      doc.text(35, 248, this.returnScore.toString());
      doc.text(35, 260, splitTitle);
      // doc.text(60, 55,);
      doc.addPage(2);
      // doc.setLineWidth(0.1);
      // doc.line(0, 80, 500, 80); // horizontal line
      // doc.setFontSize(15);
      // doc.setTextColor(0, 0, 0);
      // doc.setFont(undefined, "bold");
      // doc.text(35, 90, "Your Budget");
      doc.setFontSize(15);
      doc.setTextColor(0, 0, 0);
      doc.setFont(undefined, "bold");
      doc.text(10, 15, "Your Opportunities");
      // doc.addImage(pie1, "JPEG", 10, 110, 77, 65);
      doc.addImage(bar, "JPEG", 10, 35, 180, 65);
      doc.setFontSize(11);
      doc.setTextColor(0, 0, 0);
      doc.setFont(undefined, "normal");
      // doc.text(36, 98, "Proposed Budget");
      // doc.text(26, 103, "To Achieve Savings Goal of");
      // doc.text(42, 108, `${this.saving_display_value} Monthly`);
      doc.text(10, 23, "Versus Your Peers");
      // doc.text(60, 55,);
      // doc.setLineWidth(0.1);
      // doc.line(0, 190, 500, 190); // horizontal line
      doc.setFontSize(16);
      doc.setFont(undefined, "bold");
      doc.text(
        100,
        123,
        "50-30-20 Budget Modeling for : Needs / Wants / Financial Goals",
        "center"
      );
      doc.setFontSize(13);
      doc.setFont(undefined, "normal");
      doc.text("Model", 40, 132, "center");
      doc.text("Your Peers", 98, 132, "center");
      doc.text("You", 158, 132, "center");
      if (screenWidth > 767) {
        doc.addImage(pie2, "PNG", 131, 136, 57, 57);
        doc.addImage(pie3, "PNG", 70, 136, 57, 57);
        doc.addImage(pie5, "PNG", 10, 136, 57, 57);
      } else {
        doc.addImage(pie2, "PNG", 131, 136, 57, 57);
        doc.addImage(pie3, "PNG", 70, 136, 57, 57);
        doc.addImage(pie5, "PNG", 10, 136, 57, 57);
      }
      doc.addPage(3);
      doc.setFontSize(12);
      doc.setTextColor(0, 0, 0);
      doc.setFont(undefined, "bold");
      doc.text(40, 15, "= User Input", "center");

      doc.setLineWidth(0.5);
      doc.setDrawColor(0);
      doc.rect(10, 10, 16, 8);
      doc.stroke();
      doc.setFontSize(20);
      doc.setTextColor(87, 181, 163);
      doc.text(100, 15, "Major Expense Categories", "center");
      const firstFour =
        _this.filtered_barchart &&
        _this.filtered_barchart.slice(0, 4).map((item) => {
          const key = Object.keys(transformer_38).find(
            (ite) =>
              transformer_38[ite].toLowerCase() === item.category.toLowerCase()
          );

          return {
            ...item,
            user_monthly:
              key in this.changedValues
                ? `*$${item.user_monthly}`
                : `$${item.user_monthly}`,
            peer_monthly: `$${item.peer_monthly}`,
            difference: `$${item.user_monthly - item.peer_monthly}`,
          };
        });
      const savingData = {
        ...firstFour[3],
        user_monthly:
          _this.filtered_barchart[3].user_monthly == 0
            ? this.lending_score_cash_excess_formattedNon
            : `*$${_this.filtered_barchart[3].user_monthly}`,
      };
      // firstFour[3] = savingData;
      doc.autoTable({
        margin: { top: 20, right: 10, left: 10 },
        // theme: 'striped',
        columnStyles: {
          0: { cellWidth: 105 },
          1: { cellWidth: 30 },
          2: { cellWidth: 30 },
          3: { cellWidth: 25 },
        },
        styles: {
          overflow: "linebreak",
          columnWidth: "wrap",
          // fontSize: 12,
          cellPadding: 2,
          overflowColumns: "linebreak",
        },
        didParseCell: function (data, cell) {
          if (
            data.column.dataKey === "user_monthly" &&
            data.cell.text[0].includes("*")
          ) {
            data.cell.text = data.cell.raw.replace("*", "");
            var s = data.cell.styles;
            s.overflow = "linebreak";
            s.lineColor = [0, 0, 0];
            s.lineWidth = 0.5;
          }
        },
        // headStyles: {
        //   fillColor: [256, 256, 256],
        // },
        columns: [
          { title: "Name", dataKey: "category" },
          { title: "Your Amount", dataKey: "user_monthly" },
          { title: "Your Peers", dataKey: "peer_monthly" },
          { title: "Difference", dataKey: "difference" },
        ],
        body: firstFour,
      });
      doc.setFontSize(20);
      doc.setTextColor(87, 181, 163);
      doc.setFont(undefined, "bold");
      doc.text(100, 75, "Other Expense Categories", "center");
      doc.autoTable({
        margin: { top: 80, right: 10, left: 10 },
        startY: 80,
        styles: {
          overflow: "linebreak",
          columnWidth: "wrap",
          // fontSize: 12,
          cellPadding: 2,
          overflowColumns: "linebreak",
        },
        columnStyles: {
          0: { cellWidth: 105 },
          1: { cellWidth: 30 },
          2: { cellWidth: 30 },
          3: { cellWidth: 25 },
        },
        columns: [
          { title: "Name", dataKey: "category" },
          { title: "Your Amount", dataKey: "user_monthly" },
          { title: "Your Peers", dataKey: "peer_monthly" },
          { title: "Difference", dataKey: "difference" },
        ],
        didParseCell: function (data, cell) {
          if (
            data.column.dataKey === "user_monthly" &&
            data.cell.text[0].includes("*")
          ) {
            data.cell.text = data.cell.raw.replace("*", "");
            var s = data.cell.styles;
            s.overflow = "linebreak";
            s.lineColor = [0, 0, 0];
            s.lineWidth = 0.5;
          }
        },
        body:
          _this.filtered_barchart &&
          _this.filtered_barchart
            .filter((item, i) => i > 4 && item.isActive)
            .map((item) => {
              const key = Object.keys(transformer_38).find(
                (ite) =>
                  transformer_38[ite].toLowerCase() ===
                  item.category.toLowerCase()
              );
              return {
                ...item,
                user_monthly:
                  key in this.changedValues
                    ? `*$${item.user_monthly}`
                    : `$${item.user_monthly}`,
                peer_monthly: `$${item.peer_monthly}`,
                difference: `$${item.user_monthly - item.peer_monthly}`,
              };
            }),
      });
      // Or use javascript directly:
      doc.addPage(4);
      doc.setFontSize(20);
      doc.setTextColor(87, 181, 163);
      doc.setFont(undefined, "bold");
      doc.text(100, 15, "Removed Categories", "center");
      doc.autoTable({
        margin: { top: 20, right: 10, left: 10 },
        styles: {
          overflow: "linebreak",
          columnWidth: "wrap",
          // fontSize: 12,
          cellPadding: 2,
          overflowColumns: "linebreak",
        },
        columnStyles: {
          0: { cellWidth: 110 },
          1: { cellWidth: 40 },
          2: { cellWidth: 40 },
        },
        columns: [
          { title: "Name", dataKey: "category" },
          { title: "Your Amount", dataKey: "user_monthly" },
          { title: "Your Peers", dataKey: "peer_monthly" },
        ],
        body:
          _this.filtered_barchart &&
          _this.filtered_barchart
            .filter((item, i) => i > 3 && !item.isActive)
            .map((item) => {
              return {
                ...item,
                user_monthly: `$0`,
                peer_monthly: `$${item.peer_monthly}`,
              };
            }),
      });
      const formDatas = new FormData();
      formDatas.append("task", "plain");
      formDatas.append("text", text);
      const result = await this.$http.post(
        "https://editor.creativebuffer.com/get_response/",
        formDatas
      );
      const msgAi = result.data.data;
      doc.addPage(5);
      doc.setFont(undefined, "normal");
      doc.setFontSize(10);
      doc.setTextColor(0, 0, 0);
      var lines = doc.splitTextToSize(msgAi, 180);
      // // doc.setFontWeight("bold");
      const chunkSize = 50;
      let pageAct = 0;
      const totalChunks = Math.ceil(lines.length / chunkSize);
      for (let i = 0; i < lines.length; i += chunkSize) {
        const chunk = lines.slice(i, i + chunkSize);
        // doc.text(chunk, 15, 15);
        let margin = 15;
        let lineHeigt = 5;
        chunk.forEach((ite) => {
          if (ite.includes("<b>")) {
            doc.setFont(undefined, "bold");
          } else {
            doc.setFont(undefined, "normal");
          }

          doc.text(10, margin, ite.replace(/(<([^>]+)>)/gi, ""));
          margin = margin + lineHeigt;
        });
        // doc.text(10, 15, "Your Opportunities");

        pageAct++;
        if (totalChunks > pageAct) {
          doc.addPage(5 + pageAct);
        }
      }

      // setTimeout(()=>{
      //   html2canvas(_this.$refs.third_sec).then(function (canvas) {
      //   const img = canvas.toDataURL("image/jpeg", 0.8);
      //   doc.addImage(img,'JPEG',0,0,width, 200);
      //   doc.addPage();

      //     html2canvas(_this.$refs.first_sec).then(function (canvas) {
      //       const img = canvas.toDataURL("image/jpeg", 0.8);
      //       doc.addImage(img,'JPEG',0,0,width, height);
      //       doc.addPage();

      // doc.addImage(imgData,'JPEG',0,0,85, 70);
      if (arg) {
        doc.save("SPENDiD Report.pdf");
      } else {
        var blob = doc.output("blob");

        var formData = new FormData();
        formData.append("file", blob);
        formData.append("email", this.user_email_pdf);

        const result = await this.$http.post(
          "https://business.spendid.io/api/send-report-pdf",
          formData
        );
        this.$toasted.success("Report sent by Email").goAway(3000);
      }
      _this.gridFirst = gridF;
      _this.gridSecond = gridSecond;
      _this.visibleCoreExpCat = visibleCoreExpCat;
      _this.visibleDisabledCat = visibleDisabledCat;
      _this.visibleOtherExpCat = visibleOtherExpCat;
      _this.visibleCashHealthAnalysis = visibleCashHealthAnalysis;
      _this.isActive = true;
      // })
      //     });

      // //   });
      // },100)
    },
    onSubmit(e) {
      e.preventDefault();
    },
    setData(data) {
      if (data.net_amount) this.net_amount = data.net_amount;

      if (data.monthly_take_home)
        if (data.monthly_take_home_feq)
          // this.monthly_take_home_input_value = `${data.monthly_take_home}`;

          this.monthly_take_home_input_value_freq = `${data.monthly_take_home_feq}`;

      if (data.age) this.age = parseInt(data.age);

      if (data.household_members)
        this.household_members = parseInt(data.household_members);

      if (data.zip) this.zip = data.zip;

      if (data.is_homeowner) this.is_homeowner = data.is_homeowner;

      if (data.saving.value != null)
        this.savings_input_value = `$${data.saving.value}`;

      if (data.saving.freq) this.savings_input_value_freq = data.saving.freq;

      if (data.other_debt_payments.value != null)
        this.debt_input_value = `$${data.other_debt_payments.value}`;

      if (data.other_debt_payments.freq)
        this.debt_input_value_freq = data.other_debt_payments.freq;

      if (data.mortgage_and_rent.value != null)
        this.mortgage_and_rent_input_value = `$${data.mortgage_and_rent.value}`;

      if (data.mortgage_and_rent.freq)
        this.mortgage_and_rent_input_value_freq = data.mortgage_and_rent.freq;

      if (data.vehicle_purchase_and_lease.value != null)
        this.vehicle_purchase_and_lease_input_value = `$${data.vehicle_purchase_and_lease.value}`;

      if (data.vehicle_purchase_and_lease.freq)
        this.vehicle_purchase_and_lease_input_value_freq =
          data.vehicle_purchase_and_lease.freq;

      if (data.health_insurance.value != null)
        this.health_insurance_input_value = `$${data.health_insurance.value}`;

      if (data.health_insurance.freq)
        this.health_insurance_input_value_freq = data.health_insurance.freq;

      if (data.rest) this.changedValuesText = data.rest;

      if (data.income_method && data.income_method.income_method_val)
        this.income_method_val = data.income_method.income_method_val;

      if (data.income_method && data.income_method.occupations_val)
        this.occupations_val = data.income_method.occupations_val;

      if (
        data.income_method &&
        data.income_method.annual_gross_salary_level_val
      )
        this.annual_gross_salary_level_val =
          data.income_method.annual_gross_salary_level_val;

      if (data.rest2) this.changedValues = data.rest2;

      if (data.user_name) this.user_name = data.user_name;

      if (data.user_email) this.user_email = data.user_email;

      if (
        data.eliminated &&
        typeof data.eliminated === "object" &&
        Object.keys(data.eliminated).length > 0
      )
        this.eliminated = data.eliminated;
    },
    numberValueChange(arg, arg2) {
      var self = this;
      self[arg2] = arg;
      const short_code = arg2.replace("_input_value", "");
      const short_code_detail = transformer_38[short_code];
      const short_code_freq = this[`${arg2}_freq`];
      this.changeValue(
        short_code_detail,
        arg * short_code_freq,
        arg,
        short_code_freq
      );
    },
    resizeWindow() {
      // var newWidth = window.innerWidth;
      // if(newWidth<=992){
      //   this.visibleCoreExp=false
      // } else{
      //   this.visibleCoreExp=true
      // }
    },
    login() {
      this.$router.push("/login");
      // this.$auth.loginWithRedirect();
    },
    myFeedbackFunction: function () {
      // window.open("https://mailchi.mp/c47d1d6038ab/qgec2bqgzd",'_blank','toolbar=0,location=0,directories=0,status=1,menubar=0,titlebar=0,scrollbars=1,resizable=1,width=700,height=500');
      window.open(
        "https://us6.list-manage.com/contact-form?u=f2fea7141aa820d753ab5bba7&form_id=07b279872cb57f402b544735d96bb820",
        "_blank",
        "toolbar=0,location=0,directories=0,status=1,menubar=0,titlebar=0,scrollbars=1,resizable=1,width=650,height=750"
      );
    },
    getPieChartData(objects) {
      const needs = _.sumBy(objects, function (o) {
        return o.type === "needs" && o.monthly > 0 ? o.monthly : 0;
      });
      const wants = _.sumBy(objects, function (o) {
        return o.type === "wants" && o.monthly > 0 ? o.monthly : 0;
      });
      const saving = _.sumBy(objects, function (o) {
        return o.type === "saving" && o.monthly > 0 ? o.monthly : 0;
      });
      const future = _.sumBy(objects, function (o) {
        return o.type === "future" && o.monthly > 0 ? o.monthly : 0;
      });

      const needsPercent = (needs / (needs + wants + saving + future)) * 100;
      const wantsPercent = (wants / (needs + wants + saving + future)) * 100;
      const savingPercent = (saving / (needs + wants + saving + future)) * 100;
      const futurePercent = (future / (needs + wants + saving + future)) * 100;

      return [
        {
          category: "Compassion Choice",
          monthly: savingPercent.toFixed(2),
        },
        {
          category: "Past Choice",
          monthly: wantsPercent.toFixed(2),
        },
        {
          category: "Present Choice",
          monthly: needsPercent.toFixed(2),
        },
        {
          category: "Future Choice",
          monthly: futurePercent.toFixed(2),
        },
      ];
    },
    changeMode(e) {
      this.dark = e;
      try {
        localStorage.setItem("mode", e);
      } catch (e) {
        // eslint-disable-next-line no-console
      }
      this.updateChartsCached();
    },
    changePage(arg) {
      this.page = arg;
    },
    checkForValidate() {
      /* eslint-disable */
      if (
        this.zip.length === 5 &&
        this.age > 17
        // &&
        // this.household_members > 0
      ) {
        return true;
      }
      return false;
    },
    returnDefaultTextOnly() {
      const score =
        this.scores &&
        this.scores.breakeven &&
        parseFloat(this.scores.breakeven);
      var data = {};
      if (score === 0 || score < 0) {
        data[
          "mainText"
        ] = `Tell SPENDiD a little about your Household Profile, Income and Major Fixed Expenses`;
        data["descriptiveText"] = "";
      } else if (score <= 59 && score > 0) {
        // data['mainText']='F'
        data["mainText"] = "";
        data[
          "descriptiveText"
        ] = `Looks like it may be difficult to make ends meet. First, ensure all your Profile and Major Fixed Expense inputs are correct. Then look at the Potential Focus Areas below to see where you can make changes for the biggest impact.`;
      } else if (score > 59 && score < 70) {
        // data['mainText']='D'
        data["mainText"] = "";
        data[
          "descriptiveText"
        ] = `Your budget situation probably causes a high stress level as you try to make ends meet. Looking at your Potential Focus Areas below, what major expenses can you potentially reduce to raise your SPENDiD Score and lower your financial stress?`;
      } else if (score >= 70 && score < 80) {
        // data['mainText']='C'
        data["mainText"] = "";
        data[
          "descriptiveText"
        ] = `You may find it hard to make ends meet during most months, but you're not far away from being able to start a real savings strategy. Can you reduce spending anywhere in the list of Potential Focus Areas below, or "side-gig" for more income?`;
      } else if (score >= 80 && score < 85) {
        data["mainText"] = "B";
        data[
          "descriptiveText"
        ] = `Your budget situation looks to be pretty good! Hopefully you’re saving at least ${this.lending_score_cash_excess_formatted} or more each month. Can you reduce expenses in categories where your spending is higher than your peers so you can save even more?`;
      } else if (score >= 85 && score < 90) {
        data["mainText"] = "B +";
        data[
          "descriptiveText"
        ] = `You appear to be doing really well vs your peers and hopefully are setting aside at least ${this.lending_score_cash_excess_formatted} monthly from your take-home income to a separate savings account. TIP:  If you haven’t already, consider automating a savings transfer each pay period before you can spend it!`;
      } else if (score >= 90 && score <= 99) {
        data["mainText"] = "A";
        data[
          "descriptiveText"
        ] = `Congratulations on a strong cash-flow situation! You definitely have the ability to set aside at least ${this.lending_score_cash_excess_formatted} each month to a separate savings or investment account. Keep your specific goals in mind as to what you’re saving for, and you’ll make it happen. Make 100 or higher your SPENDiD Score goal!`;
      } else if (score > 99) {
        data["mainText"] = "A +";

        data[
          "descriptiveText"
        ] = `It looks like you're doing all the right things budget-wise. Do you have an active strategy for growing your savings, and investing for the future? Be sure to sweep at least ${this.lending_score_cash_excess_formatted} into investments appropriate for your age and risk tolerance. Do this, and your financial future looks bright!`;
      }
      return data;
    },
    returnDefaultText() {
      const score =
        this.scores &&
        this.scores.breakeven &&
        parseFloat(this.scores.breakeven);
      var data = {};
      if (score === 0 || score < 0) {
        data[
          "mainText"
        ] = `Tell SPENDiD a little about your Household Profile, Income and Major Fixed Expenses`;
        data["descriptiveText"] = "";
      } else if (score <= 59 && score > 0) {
        data["mainText"] = "(Let's see how we can improve your score)";
        data[
          "descriptiveText"
        ] = `Looks like it may be difficult to make ends meet. First, ensure all your Profile and Major Fixed Expense inputs are correct. Then look at the Potential Focus Areas below to see where you can make changes for the biggest impact.`;
      } else if (score > 59 && score < 70) {
        data["mainText"] = "(Let's see how we can improve your score)";
        data[
          "descriptiveText"
        ] = `Your budget situation probably causes a high stress level as you try to make ends meet. Looking at your Potential Focus Areas below, what major expenses can you potentially reduce to raise your SPENDiD Score and lower your financial stress?`;
      } else if (score >= 70 && score < 80) {
        data["mainText"] = "C";
        data[
          "descriptiveText"
        ] = `You may find it hard to make ends meet during most months, but you're not far away from being able to start a real savings strategy. Can you reduce spending anywhere in the list of Potential Focus Areas below, or "side-gig" for more income?`;
      } else if (score >= 80 && score < 85) {
        data["mainText"] = "B";
        data[
          "descriptiveText"
        ] = `Your budget situation looks to be pretty good! Hopefully you’re saving at least ${this.lending_score_cash_excess_formatted} or more each month. Can you reduce expenses in categories where your spending is higher than your peers so you can save even more?`;
      } else if (score >= 85 && score < 90) {
        data["mainText"] = "B +";
        data[
          "descriptiveText"
        ] = `You appear to be doing really well vs your peers and hopefully are setting aside at least ${this.lending_score_cash_excess_formatted} monthly from your take-home income to a separate savings account. TIP:  If you haven’t already, consider automating a savings transfer each pay period before you can spend it!`;
      } else if (score >= 90 && score <= 99) {
        data["mainText"] = "A";
        data[
          "descriptiveText"
        ] = `Congratulations on a strong cash-flow situation! You definitely have the ability to set aside at least ${this.lending_score_cash_excess_formatted} each month to a separate savings or investment account. Keep your specific goals in mind as to what you’re saving for, and you’ll make it happen. Make 100 or higher your SPENDiD Score goal!`;
      } else if (score > 99) {
        data["mainText"] = "A +";

        data[
          "descriptiveText"
        ] = `It looks like you're doing all the right things budget-wise. Do you have an active strategy for growing your savings, and investing for the future? Be sure to sweep at least ${this.automatically.lending_score_cash_excess_formatted} into investments appropriate for your age and risk tolerance. Do this, and your financial future looks bright!`;
      }
      return `<h4 class="font-weight-bold">${data.mainText}</h4><p>${data.descriptiveText}</p>`;
    },
    async restoreEliminate(arg) {
      this.filtered_barchart = this.filtered_barchart.map((item) => {
        if (item.category === arg) {
          return { ...item, isActive: true };
        }
        return item;
      });
      const key = Object.keys(transformer_38).find(
        (item) => transformer_38[item] === arg
      );
      delete this.eliminated[key];
      const that = this;
      await this.updateCharts().then(function () {
        setTimeout(() => {
          that.changeFilter(that.sortDefault);
        }, 3000);
      });
    },
    async runElimination() {
      this.filtered_barchart = this.filtered_barchart.map((item) => {
        if (item.category === this.defaultSelectedEliminationName) {
          return { ...item, isActive: false };
        }
        return item;
      });
      const key = Object.keys(transformer_38).find(
        (item) => transformer_38[item] === this.defaultSelectedEliminationName
      );
      delete this.changedValues[key];
      this.eliminated[key] = 0;
      this.$bvModal.hide("eliminated");
      await this.updateCharts();
    },
    openModelEliminate(arg) {
      this.defaultSelectedEliminationName = arg;
      // this.$bvModal.show('eliminated')
      this.runElimination();
    },
    resetDefault(bBypassDiv) {
      this.income_method_val = false;
      if (bBypassDiv) {
        this.byPass = bBypassDiv;
        this.stepEnable = bBypassDiv;
        return true;
      }
      this.net_amount = [
        {
          amount: "",
          freq: 12,
          manual: "2",
          occupation: null,
          level: null,
          grossOrNet: "net",
          net: 0,
          gross: 0,
        },
      ];
      // this.StartOverModal= false;
      this.$bvModal.hide("startover");
      this.visibleResultsSummary = false;
      this.visibleYourHousehold = false;
      this.visibleCoreExp = false;
      this.visibleCustCoreExp = false;
      this.visibleVhCustCoreExp = false;
      this.visibleDbtCustCoreExp = false;
      this.visibleSvAmtCoreExp = false;
      this.visiblePersComp = false;
      this.visibleCoreExpCat = false;
      this.visibleProfileHousehold = true;
      this.visibleOtherExpCat = false;
      this.visibleCommonBillsCat = true;
      this.visibleMonthlyBillsCat = true;
      this.visibleDisabledCat = false;
      this.visibleResultDetails = false;
      this.visibleYourBudget = false;
      this.visibleYourPeers = false;
      this.visibleCashHealthAnalysis = true;
      this.visibleFAQ = false;
      this.visibleFaqOne = false;
      this.visibleFaqTwo = false;
      this.visibleFaqThree = false;
      this.visibleFaqFour = false;
      this.visibleFaqFive = false;
      this.visibleFaqSix = false;
      this.visibleFaqSeven = false;
      this.visibleFaqEight = false;
      this.visibleFaqNine = false;
      this.visibleFaqTen = false;
      this.visibleFaqEleven = false;
      this.visibleFaqTwelve = false;
      this.visibleFaqThirteen = false;
      this.visibleFaqFourteen = false;
      this.visibleFaqFifteen = false;
      this.visibleModalPieChart = false;
      // this.monthly_take_home_input_value= "0";
      this.monthly_take_home_input_value_freq = 12;
      this.age = "22";
      this.household_members = 1;
      this.zip = "";
      this.is_homeowner = false;
      this.filter_cateory = "";
      this.selected_category = Math.random().toString();
      this.sortBy = "peer_monthly";
      this.sortDefault = false;
      this.sortType = "";
      this.isHidden = true;
      (this.zipcodeId = ""), (this.checked = true);
      this.chart = null;
      this.chart_range = "month";
      this.is_typing = false;
      this.api_updates_pending = false;
      this.active_persona_index = 0;
      this.budget = null;
      this.demographics_response = null;
      this.scores = null;
      this.lending_score = null;
      this.peers_input_value = null;
      this.filtered_barchart = null;
      this.savings_input_value = null;
      this.savings_input_value_freq = 12;
      this.mortgage_and_rent_input_value = null;
      this.mortgage_and_rent_input_value_freq = 12;
      this.vehicle_purchase_and_lease_input_value = null;
      this.vehicle_purchase_and_lease_input_value_freq = 12;
      this.health_insurance_input_value = null;
      this.health_insurance_input_value_freq = 12;
      this.debt_input_value = null;
      this.debt_input_value_freq = 12;
      this.peer_income = "--";
      this.budgetFilter = null;
      this.peerFilter = null;
      this.differenceFilter = null;
      this.changedValues = {};
      this.changedValuesText = {};
      this.eliminated = {};
      this.byPass = bBypassDiv;
      this.netAmount = 0;
      // window.scrollTo(0,0);
      try {
        localStorage.removeItem("storedData");
        localStorage.removeItem("projectGrowth");
      } catch (e) {
        // eslint-disable-next-line no-console
      }
      this.useCase = null;
      this.defaultUseCase = null;
      this.defaultEducation = null;
      this.user_name = "";
      this.user_email = "";
      this.otp = "";
      this.stepEnable = bBypassDiv;

      window.scrollTo(0, 0);
      this.goto("Your Profile");
    },
    resetlogout() {
      this.stepEnable = true;
    },
    async changeValue(type, value, amount, freq) {
      const key = Object.keys(transformer_38).filter(
        (item) => transformer_38[item] === type
      );

      key.forEach((item) => {
        if (amount) {
          this.changedValues[item] = value ? value / key.length : value;
          this.changedValuesText[key] = {
            value: amount,
            freq,
          };
        } else if (!value) {
          delete this.changedValues[item];
          delete this.changedValuesText[key];
        }

        switch (item) {
          case "other_debt_payments":
            this.debt_input_value = amount ? `${amount.toString()}` : null;
            this.debt_input_value_freq = freq;
            break;
          case "mortgage_and_rent":
            this.mortgage_and_rent_input_value = amount
              ? `${amount.toString()}`
              : null;
            // this.mortgage_and_rent_value = this.mortgage_and_rent_input_value ? parseFloat(this.unmaskMoneyValue(this.mortgage_and_rent_input_value)) : null;
            this.mortgage_and_rent_input_value_freq = freq;
            break;
          case "vehicle_purchase_and_lease":
            this.vehicle_purchase_and_lease_input_value = amount
              ? `${amount.toString()}`
              : null;
            this.vehicle_purchase_and_lease_input_value_freq = freq;
            break;
          case "health_insurance":
            this.health_insurance_input_value = amount
              ? `${amount.toString()}`
              : null;
            this.health_insurance_input_value_freq = freq;
            break;
          case "savings":
            this.savings_input_value = amount ? `${amount.toString()}` : null;
            this.savings_input_value_freq = freq;
            break;
          default:
            // if (amount) {
            //   this.changedValues[item] = value ? value / key.length : value;
            //   this.changedValuesText[key] = {
            //     value: amount,
            //     freq,
            //   };
            // } else if(!value){
            //   delete this.changedValues[item];
            //   delete this.changedValuesText[key];
            // }
            break;
        }
      });
      await this.updateCharts();
    },
    selectedSavingFreq() {
      return this.frequencyOptions.find(
        (item) => item.value === this.savings_input_value_freq
      ).text;
    },
    changeFilter(asc) {
      this.sortDefault = asc;
      const mainData = this.filtered_barchart;
      const firstFour = mainData && mainData.slice(0, 5);
      const restData = mainData && mainData.filter((item, i) => i > 4);
      if (this.sortBy === "category") {
        restData.sort(function (a, b) {
          if (a.category < b.category) {
            return asc ? -1 : 1;
          }
          if (a.category > b.category) {
            return asc ? 1 : -1;
          }
          return 0;
        });
      } else if (this.sortBy === "user_monthly") {
        restData.sort(function (a, b) {
          if (a.user_monthly < b.user_monthly) {
            return asc ? -1 : 1;
          }
          if (a.user_monthly > b.user_monthly) {
            return asc ? 1 : -1;
          }
          return 0;
        });
      } else if (this.sortBy === "peer_monthly") {
        restData.sort(function (a, b) {
          if (a.peer_monthly < b.peer_monthly) {
            return asc ? -1 : 1;
          }
          if (a.peer_monthly > b.peer_monthly) {
            return asc ? 1 : -1;
          }
          return 0;
        });
      } else if (this.sortBy === "difference") {
        restData.sort(function (a, b) {
          if (
            a.user_monthly - a.peer_monthly <
            b.user_monthly - b.peer_monthly
          ) {
            return asc ? -1 : 1;
          }
          if (
            a.user_monthly - a.peer_monthly >
            b.user_monthly - b.peer_monthly
          ) {
            return asc ? 1 : -1;
          }
          return 0;
        });
      }

      this.filtered_barchart = [...firstFour, ...restData];
    },
    focusOut() {
      // if(parseInt(this.age)<18){
      //   this.age=18
      // }
    },
    score_to_grade(score) {
      let grade = "F";

      if (score >= 96) {
        grade = "A+";
      } else if (score >= 90 && score < 96) {
        grade = "A-";
      } else if (score >= 86 && score < 90) {
        grade = "B+";
      } else if (score >= 80 && score < 86) {
        grade = "B";
      } else if (score >= 70 && score < 80) {
        grade = "C";
      } else if (score >= 60 && score < 70) {
        grade = "D";
      }
      return grade;
    },
    grade_to_css_class(grade) {
      return {
        "is-grade-a-plus": grade == "A+",
        "is-grade-a": grade == "A",
        "is-grade-a-minus": grade == "A-",
        "is-grade-b-plus": grade == "B+",
        "is-grade-b": grade == "B",
        "is-grade-b-minus": grade == "B-",
        "is-grade-c": grade == "C",
        "is-grade-d": grade == "D",
        "is-grade-f": grade == "F",
      };
    },
    filterCategory() {
      // if(this.filter_cateory !== "all")
      //   this.filtered_barchart = this.barChart.filter(product => !product.category.indexOf(this.filter_cateory))
      // else
      //   this.filtered_barchart = this.barChart;
      // if(!!this.budgetFilter)
      //   this.filtered_barchart = this.filtered_barchart.filter(product => product.user_monthly==this.budgetFilter)
      // if(!!this.peerFilter)
      //   this.filtered_barchart = this.filtered_barchart.filter(product => product.peer_monthly==this.peerFilter)
      // if(!!this.differenceFilter)
      //   this.filtered_barchart = this.filtered_barchart.filter(product => (product.user_monthly - product.peer_monthly)==this.differenceFilter )
    },
    unmaskMoneyValue(val) {
      return val.replace("$", "").replace(",", "");
    },
    createSpeedChart(breakEven) {
      // Themes begin
      am4core.useTheme(am4themes_animated);
      // Themes end

      // create chart
      let chart = am4core.create("speedometer", am4charts.GaugeChart);
      chart.innerRadius = am4core.percent(70);

      /*** Normal axis*/
      let axis = chart.xAxes.push(new am4charts.ValueAxis());
      axis.min = 0;
      axis.max = 100;
      axis.strictMinMax = true;
      axis.renderer.grid.template.stroke =
        new am4core.InterfaceColorSet().getFor("background");
      axis.renderer.grid.template.strokeOpacity = 0.3;
      axis.renderer.minGridDistance = 500;
      axis.renderer.labels.template.fontSize = "0.5em";
      axis.renderer.labels.template.fill = am4core.color(
        this.dark ? "#fff" : "#000"
      );

      // hand.fill = am4core.color("#2D93AD");
      // hand.stroke = am4core.color("#2D93AD");
      axis.renderer.labels.template.adapter.add("text", function (text) {
        return text;
      });

      /*** Axis for ranges*/
      let colorSet = new am4core.ColorSet();

      let axis2 = chart.xAxes.push(new am4charts.ValueAxis());
      axis2.min = 0;
      axis2.max = 100;
      axis2.strictMinMax = true;
      axis2.renderer.labels.template.disabled = true;
      axis2.renderer.ticks.template.disabled = true;
      axis2.renderer.grid.template.disabled = true;

      let range3 = axis2.axisRanges.create();
      range3.value = 0;
      range3.endValue = 50;
      range3.axisFill.fillOpacity = 1;
      range3.axisFill.fill = colorSet.getIndex(0);

      var gradient1 = new am4core.LinearGradient();
      gradient1.addColor(am4core.color("#ff0000"));
      gradient1.addColor(am4core.color("#5868eb"));

      range3.axisFill.fill = gradient1;

      // let range0 = axis2.axisRanges.create();
      // range0.value = 0;
      // range0.endValue = 100;
      // range0.axisFill.fillOpacity = 1;
      // range0.axisFill.fill = colorSet.getIndex(0);
      // range0.axisFill.fill = am4core.color("#00d1b2");

      let range1 = axis2.axisRanges.create();
      range1.value = 50;
      range1.endValue = 100;
      range1.axisFill.fillOpacity = 1;
      range1.axisFill.fill = colorSet.getIndex(2);

      var gradient = new am4core.LinearGradient();
      gradient.addColor(am4core.color("#5868eb"));
      gradient.addColor(am4core.color("#235d37"));
      // gradient.addColor(am4core.color("#3e399b"));
      // gradient.addColor(am4core.color("#3e399b"));
      // gradient.addColor(am4core.color("#3e399b"));
      // gradient.addColor(am4core.color("#90F5D7"));
      // gradient.addColor(am4core.color("#90F5D7"));
      // gradient.addColor(am4core.color("#00d1b2"));
      // gradient.addColor(am4core.color("#00d1b2"));

      gradient.rotation = 0;

      range1.axisFill.fill = gradient;

      /*** Label*/
      let label = chart.radarContainer.createChild(am4core.Label);
      label.isMeasured = false;
      label.fontSize = 32;
      label.fontWeight = 600;
      // label.fontColor = am4core.color("#2E2B6B");
      label.x = am4core.percent(50);
      label.y = am4core.percent(100);
      label.horizontalCenter = "middle";
      label.verticalBottom = "bottom";
      label.text = "";
      label.fill = am4core.color(this.dark ? "#fff" : "#000");
      // label.textColor.Color = am4core.color("#235d37");

      /*** Hand*/
      let hand = chart.hands.push(new am4charts.ClockHand());
      hand.axis = axis2;
      // hand.innerRadius = am4core.percent(20);
      // hand.startWidth = 14;
      // hand.pin.disabled = true;

      hand.value = this.roundSpeedValue(parseFloat(breakEven));
      hand.fill = am4core.color("#a7ff83");
      hand.stroke = am4core.color("#a7ff83");
      hand.events.on("propertychanged", function () {
        // range0.endValue = ev.target.value;
        // range1.value = ev.target.value;
        // label.text = axis2.positionToValue(hand.currentPosition).toFixed(1);
        axis2.invalidate();
      });
      // setInterval(() => {
      //   var value = Math.round(Math.random() * 100);
      //   label.text = value + "%";
      //   var animation = new am4core.Animation(hand, {
      //     property: "value",
      //     to: value
      //   }, 1000, am4core.ease.cubicOut).start();
      // }, 2000);
      return chart;
    },
    roundSpeedValue(val) {
      if (val > 100) {
        return 100;
      } else if (val < 0) {
        return -0;
      } else {
        return val;
      }
    },
    createPieChart(data, ref, type = "$") {
      var _this = this;
      let chart = am4core.create(this.$refs[ref], am4charts.PieChart);
      let options = chart.exporting.getFormatOptions("png");
      options.minWidth = 1000;
      options.minHeight = 1000;
      options.maxWidth = 2000;
      options.maxHeight = 2000;
      chart.exporting.setFormatOptions("png", options);
      let mainData = data;
      if (type !== "$") {
        /* eslint-disable */
        mainData = data.map((item) => ({
          ...item,
          monthly:item.monthly>=0?item.monthly:0,
          dol: Math.trunc(
            (_this.monthly_take_home_input_value.replace(/[^\d\.\-]/g, "") *
              item.monthly) /
              100
          ),
        }));
      }
      chart.data = mainData;
      chart.padding(0, 0, 0, 0);
      chart.margin(0, 0, 0, 0);
      chart.paddingRight = 0;
      chart.paddingLeft = 0;
      chart.responsive.enabled = true;
      chart.maintainAspectRatio = false;

      // Pie Chart legends
      // if(type!=='$'){

      //   chart.legend = new am4charts.Legend();
      //   chart.legend.useDefaultMarker = true;
      //   var markerTemplate = chart.legend.markers.template;
      //   markerTemplate.width = 14;
      //   markerTemplate.height = 14;
      //   markerTemplate.stroke = am4core.color("#ccc");

      //   chart.legend.labels.template.fill = am4core.color(_this.dark?"#fff":"#000");
      //   chart.legend.valueLabels.template.fill = am4core.color(_this.dark?"#fff":"#000");
      //   chart.legend.valueLabels.template.align = "center";
      //   chart.legend.valueLabels.template.textAlign = "left";
      //   chart.legend.valueLabels.template.fontSize = 13;
      //   chart.legend.labels.template.fontSize = 13;

      // // Position legend
      //   chart.legend.position = "top";
      //   chart.legend.contentAlign = "center";
      // }

      // Let's cut a hole in our Pie chart the size of 40% the radius
      //chart.innerRadius = am4core.percent(50);

      // Add and configure Series
      var series = chart.series.push(new am4charts.PieSeries());
      series.dataFields.value = "monthly";
      series.dataFields.category = "category";

      if (type != "$") {
        series.dataFields.dol = "dol";
        series.slices.template.tooltipText =
          type == "$" ? "{category}: ${value}" : `{category}: {value}%`;
        // $ {dol}`;
      } else {
        series.slices.template.tooltipText =
          type == "$" ? "{category}: ${value}" : "{category}: {value}%";
      }

      // series.slices.template.cornerRadius = 6;

      series.legendSettings.labelText = "{category}";
      series.legendSettings.valueText = type == "$" ? "${value}" : "{value}%";

      chart.radius = am4core.percent(100);
      chart.innerRadius = am4core.percent(60);

      // Disabling labels and ticks on inner circle
      series.labels.template.disabled = true;
      series.ticks.template.disabled = true;

      series.colors.list = [
        am4core.color("#987e4c"),
        am4core.color("#235d37"),
        am4core.color("#D45159"),
        am4core.color("#0267e8"),
        am4core.color("#235d37"),
        am4core.color("#8c2b86"),
        am4core.color("#73c03c"),
        am4core.color("#ffb31f"),
        am4core.color("#235d37"),
      ];
      // Value labels inside the pie slice
      // series.ticks.template.disabled = true;
      // series.alignLabels = false;
      // series.labels.template.text = "{value.percent.formatNumber('#')}%";
      // series.labels.template.radius = am4core.percent(-24);
      // series.labels.template.fill = am4core.color("white");

      chart.numberFormatter.numberFormat = "#,###";
      let label = series.createChild(am4core.Label);
      label.text = type == "$" ? "${values.value.sum}" : "";
      // label.text = type=='$'? _this.monthly_take_home_input_value : '100%';
      label.horizontalCenter = "middle";
      label.verticalCenter = "middle";
      label.fontSize = 24;
      label.fill = am4core.color(_this.dark ? "#fff" : "#000");
      chart.responsive.enabled = true;

      // chart.legend = new am4charts.Legend();
      // chart.legend.valueLabels.template.align = "right";
      // chart.legend.valueLabels.template.textAlign = "start";
      // chart.legend.useDefaultMarker = true;
      // let marker = chart.legend.markers.template.children.getIndex(0);
      // marker.cornerRadius(12, 12, 12, 12);

      // chart.legend.itemContainers.template.togglable = false;
      // chart.legend.itemContainers.template.events.on("hit", function (ev) {
      //   var slice = ev.target.dataItem.dataContext.slice;
      //   slice.isActive = !slice.isActive;
      // });

      return chart;
    },
    createBarChart(comparison) {
      var _this = this;
      var chart = am4core.create("barchart", am4charts.XYChart);
      chart.paddingRight = 40;
      chart.paddingLeft = 10;
      chart.paddingBottom = 40;
      chart.colors.list = [am4core.color("#235d37")];
      let options = chart.exporting.getFormatOptions("png");
      options.minWidth = 1000;
      options.minHeight = 1000;
      options.maxWidth = 2000;
      options.maxHeight = 2000;
      chart.exporting.setFormatOptions("png", options);
      // chart.colors.list = [
      //   am4core.color("#845EC2"),
      //   am4core.color("#D65DB1"),
      //   am4core.color("#FF6F91"),
      //   am4core.color("#FF9671"),
      //   am4core.color("#FFC75F"),
      //   am4core.color("#000000")
      // ];
      // Make each column to be of a different color
      // chart.columns.template.adapters.add("fill", function (fill, target) {
      //   return chart.get("colors").getIndex(chart.columns.indexOf(target ));
      // });

      const gapData = comparison.map((item) => {
        return { ...item, gap: item.user_monthly - item.peer_monthly };
      });
      // sort by biggest difference first
      var dataArray = Object.keys(_this.changedValues).map(function (k) {
        if (_this.changedValues[k]) {
          return k;
        }
      });

      const mainData = gapData
        .filter((item) => item.category !== "Amount to Savings Each Period")
        .sort((a, b) => (a.gap > b.gap ? -1 : b.gap > a.gap ? 1 : 0))
        .filter(
          (item) => item.gap > 0 && dataArray.includes(item.category_type)
        )
        .splice(0, 5);

      this.hideBarChart = mainData.length === 0;
      chart.data = mainData;
      // console.log(gapData.filter(item=>item.category!=="Amount to Savings").sort((a,b) => (a.gap > b.gap) ? -1 : ((b.gap > a.gap) ? 1 : 0)).filter(item=>item.gap>=25).splice(0,5),'2');
      // Create axes
      var categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "category";
      categoryAxis.numberFormatter.numberFormat = "$#,###";
      categoryAxis.renderer.inversed = true;
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.cellStartLocation = 0.9;
      categoryAxis.renderer.cellEndLocation = 0.7;
      categoryAxis.renderer.labels.template.rotation = 0;
      categoryAxis.renderer.labels.template.fill = am4core.color(
        _this.dark ? "#fff" : "#000"
      );
      categoryAxis.renderer.labels.template.verticalTop = "top";
      categoryAxis.renderer.labels.template.wrap = false;
      categoryAxis.renderer.labels.template.truncate = false;
      // categoryAxis.renderer.labels.template.maxWidth = 120;
      categoryAxis.renderer.inside = true;
      categoryAxis.renderer.labels.template.valign = "top";
      categoryAxis.renderer.labels.template.dy = -8;
      categoryAxis.renderer.labels.template.dx = -10;

      var valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
      valueAxis.min = 0;
      let maxValue = 0;
      if (chart.data.length > 0) {
        maxValue = chart.data[0].gap;
        maxValue = Math.ceil(maxValue / 100) * 100;
      }
      valueAxis.renderer.opposite = false;
      valueAxis.renderer.labels.template.fill = am4core.color(
        _this.dark ? "#fff" : "#000"
      );
      // Create series
      function createSeries(field, name) {
        var series = chart.series.push(new am4charts.ColumnSeries());
        series.dataFields.valueX = field;
        series.dataFields.categoryY = "category";
        series.name = name;
        // series.columns.template.tooltipText = "{name}: [bold]{valueX}[/]";
        series.columns.template.tooltipText = "{name}:[bold]{valueX}[/]";

        series.columns.template.events.on(
          "hit",
          (ev) => {
            const topCat = [
              "mortgage_and_rent",
              "vehicle_purchase_and_lease",
              "other_debt_payments",
              "savings",
              "health_insurance",
            ];
            if (
              common_monthly_short_2.includes(
                ev.target._dataItem._dataContext.category_type
              )
            ) {
              console.log("1");
              setTimeout(() => {
                _this.activeTab = "Your Major Expenses";
              }, 400);
              _this.visibleCoreExp = true;
              _this.visibleCoreExpCat = true;
            } else if (
              common_monthly_short.includes(
                ev.target._dataItem._dataContext.category_type
              )
            ) {
              console.log("2");
              setTimeout(() => {
                _this.activeTab = "Common Monthly Bills";
              }, 400);
              _this.visibleOtherExpCat = true;
            } else {
              setTimeout(() => {
                _this.activeTab = "Other Discretionary Expenses";
              }, 400);
              _this.visiblePersComp = true;
            }
            setTimeout(() => {
              scrollIntoView(
                document.getElementById(
                  `${ev.target._dataItem._dataContext.category_type}_card`
                ),
                { behavior: "smooth", block: "center", inline: "center" }
              );

              // const el = document.getElementById(`${ev.target._dataItem._dataContext.category_type}_card`)
              // el.scrollIntoView({
              //   behavior: 'smooth',
              //   block: 'center'
              // });
              var element = document.getElementById(
                `${ev.target._dataItem._dataContext.category_type}_card_click`
              );
              element.classList.remove("d-none");

              // var el = document.getElementById(`${ev.target._dataItem._dataContext.category_type}_card_click`);
              // el.onclick();
            }, 500);
          },
          this
        );
        // series.columns.template.width = am4core.percent(100);
        series.columns.template.height = am4core.percent(200);
        series.sequencedInterpolation = true;
        var valueLabel = series.bullets.push(new am4charts.LabelBullet());
        valueLabel.label.text = "[bold]{valueX}[/]";
        valueLabel.label.horizontalLeft = "left";
        if (window.innerWidth < 767) {
          valueLabel.label.dx = -15;
          valueLabel.label.fontSize = 13;
        } else {
          valueLabel.label.dx = 20;
        }
        valueLabel.label.hideOversized = false;
        valueLabel.label.truncate = false;
        // valueLabel.label.maxWidth  = 100;
        valueLabel.label.tooltipText = "{valueX}";
        valueLabel.label.fill = am4core.color(_this.dark ? "#fff" : "#000");
        if (window.innerWidth < 767) {
          valueLabel.label.fill = am4core.color(_this.dark ? "#fff" : "#fff");
        } else {
          valueLabel.label.fill = am4core.color(_this.dark ? "#fff" : "#000");
        }
        series.legendSettings.labelText = name;

        // let categoryLabel = series.bullets.push(new am4charts.LabelBullet());
        // categoryLabel.label.dy = -20;
        // as by default columns of the same series are of the same color, we add adapter which takes colors from chart.colors color set
        series.columns.template.adapter.add("fill", (fill, target) => {
          if (
            _this.mortgage_and_rent_input_value &&
            target.dataItem.categories.categoryY === "Rent or Mortgage Payment"
          ) {
            return am4core.color("#0267e8");
          }
          if (
            _this.vehicle_purchase_and_lease_input_value &&
            target.dataItem.categories.categoryY === "Car Payments"
          ) {
            return am4core.color("#0267e8");
          }
          if (
            _this.health_insurance_input_value &&
            target.dataItem.categories.categoryY === "Health Insurance"
          ) {
            return am4core.color("#0267e8");
          }
          if (
            _this.debt_input_value &&
            target.dataItem.categories.categoryY ===
              "Other Debt Payments & Obligations"
          ) {
            return am4core.color("#0267e8");
          }
          if (
            _this.savings_value &&
            target.dataItem.categories.categoryY ===
              "Amount to Savings Each Period"
          ) {
            return am4core.color("#0267e8");
          }

          return dataArray.includes(
            Object.keys(transformer_38).find(
              (item) =>
                transformer_38[item] === target.dataItem.categories.categoryY
            )
          )
            ? am4core.color("#0267e8")
            : am4core.color("#235d37");
        });
      }
      createSeries("gap", "Difference");
      // let marker = chart.legend.markers.template.children.getIndex(0);
      // marker.cornerRadius(12, 12, 12, 12);
      chart.responsive.enabled = true;
      chart.maintainAspectRatio = false;

      return chart;
    },
    sumBudgetValues(obj) {
      var sum = 0;
      for (var el in obj) {
        if (obj.hasOwnProperty(el)) {
          sum += parseFloat(obj[el].monthly);
        }
      }
      return sum;
    },
    checkStatus() {},
    updateChartsCached: _.debounce(async function () {
      if (this.age < 18 || this.household_members < 1) {
        this.is_typing = false;
        this.api_updates_pending = false;
        return false;
      }
      this.api_updates_pending = true;
      const demographics = this.demographicsCached;
      const budget = this.budgetCached;
      const scores = this.scoresCached;
      const lendingScore = this.lendingScoreCached;
      this.peer_income = this.sumBudgetValues(demographics);
      const comparison = this.mergeResponses(demographics, budget);
      const fullData = this.mergeResponses(demographics, budget);
      // console.log(fullData)
      this.filtered_barchart = fullData.map((v) => Object.assign(v));
      const peerSaving = demographics.find(
        (item) => item.category === "Amount to Savings Each Period"
      );
      // console.log(demographics,peerSaving)
      this.peers_input_value = peerSaving.monthly;

      const chart1Data = budget.map((item) => ({
        ...item,
        type: transformer_category[item.category_type].type,
      }));
      const chart2Data = demographics.map((item, k) => ({
        ...item,
        type: transformer_category[budget[k].category_type].type,
      }));
      const chart1 = this.getPieChartData(chart1Data);
      const chart2 = this.getPieChartData(chart2Data);
      this.chart3Data = chart1;
      this.chart4Data = chart2;

      // console.log(chart1,chart2);

      const standardChart = [
        {
          category: "Needs",
          monthly: 50,
        },
        {
          category: "Wants",
          monthly: 30,
        },
        {
          category: "Financial Goals",
          monthly: 20,
        },
      ];
      this.updatePieChart(chart1, this.pie_chart3);
      this.updatePieChart(chart2, this.pie_chart4);
      this.updatePieChart(standardChart, this.pie_chart5);
      this.updateSpeedChart(scores.breakeven);
      const _this = this;
      if (this.pie_chart) {
        this.pie_chart.dispose();
      }
      this.pie_chart = this.createPieChart(budget, "piechart");
      // this.updatePieChart2(demographics);
      this.updateBarChart(comparison);
      this.scores = scores;
      this.lending_score = lendingScore;
      this.is_typing = false;
      this.api_updates_pending = false;
      this.changeFilter(this.sortDefault);
    }, 500),
    updateCharts: _.debounce(async function () {
      if (this.age < 18 || this.household_members < 1) {
        this.is_typing = false;
        this.api_updates_pending = false;
        return false;
      }
      this.api_updates_pending = true;
      const { demographics, budget, scores, lendingScore } =
        await this.callAPIs();

      this.demographicsCached = demographics;
      this.budgetCached = budget;
      this.scoresCached = scores;
      this.lendingScoreCached = lendingScore;
      this.peer_income = this.sumBudgetValues(demographics);
      const comparison = this.mergeResponses(demographics, budget);
      const fullData = this.mergeResponses(demographics, budget);
      // console.log(fullData)
      this.filtered_barchart = fullData.map((v) => Object.assign(v));
      const peerSaving = demographics.find(
        (item) => item.category === "Amount to Savings Each Period"
      );
      // console.log(demographics,peerSaving)
      this.peers_input_value = peerSaving.monthly;

      const chart1Data = budget.map((item) => ({
        ...item,
        type: transformer_category[item.category_type].type,
      }));
      const chart2Data = demographics.map((item, k) => ({
        ...item,
        type: transformer_category[budget[k].category_type].type,
      }));
      const chart1 = this.getPieChartData(chart1Data);
      const chart2 = this.getPieChartData(chart2Data);
      this.chart3Data = chart1;
      this.chart4Data = chart2;

      // console.log(chart1,chart2);

      const standardChart = [
        {
          category: "Compassion Choice",
          monthly: 1.5,
        },
        {
          category: "Past Choice",
          monthly: 40,
        },
        {
          category: "Present Choice",
          monthly: 45,
        },
        {
          category: "Future Choice",
          monthly: 13.5,
        },
      ];
      this.updatePieChart(chart1, this.pie_chart3);
      this.updatePieChart(chart2, this.pie_chart4);
      this.updatePieChart(standardChart, this.pie_chart5);
      this.updateSpeedChart(scores.breakeven);
      this.updatePieChart(budget, this.pie_chart);
      // this.updatePieChart2(demographics);
      this.updateBarChart(comparison);
      this.scores = scores;
      this.lending_score = lendingScore;
      this.is_typing = false;
      this.api_updates_pending = false;
      this.changeFilter(this.sortDefault);
    }, 1000),

    recategorizeCharts: _.debounce(async function () {
      this.api_updates_pending = true;
      const { demographics, budget } = await this.callAPIs();

      this.peer_income = this.sumBudgetValues(demographics);
      const comparison = this.mergeResponses(demographics, budget);
      this.recategorizePieChart(budget);
      // this.recategorizePieChart2(demographics);
      this.recategorizeBarChart(comparison);
      this.is_typing = false;
      this.api_updates_pending = false;
    }, 1000),

    mergeResponses(demographics, budget) {
      let comparison = [];
      const keys = demographics.map((x) => x.category);
      keys.forEach((key) => {
        comparison.push({
          category: key,
          category_type: budget.find((x) => x.category == key).category_type,
          isActive: budget.find((x) => x.category == key).isActive,
          peer_monthly: demographics.find((x) => x.category == key).monthly,
          user_monthly: budget.find((x) => x.category == key).monthly,
        });
      });
      return comparison;
    },

    async callAPIs() {
      let [lendingScore] = await Promise.all([this.callLendingScoreAPI()]);
      if (lendingScore) {
        const classs = lendingScore
          ? this.grade_to_css_class(
              this.score_to_grade(lendingScore.elements.cash_excess / 12)
            )
          : {};
        this.grade_class = Object.keys(classs).find(
          (item) => classs[item] === true
        );

        var monthly_cash_excess =
          (lendingScore && lendingScore.elements.cash_excess) || 0;
        this.lending_score_cash_excess_formattedNonFormat =
          parseInt(monthly_cash_excess) < 0 ? 0 : parseInt(monthly_cash_excess);
      }
      let [demographics, budget, scores] = await Promise.all([
        this.callDemographicsAPI(),
        this.callBudgetAPI(),
        this.callScoringAPI(),
      ]);
      return {
        demographics: demographics,
        budget: budget,
        scores: scores,
        lendingScore: lendingScore,
      };
    },
    async updatePieChart2(newData) {
      this.pie_chart2.series.values[0].children.values[5].hide(0, 0);
      setTimeout(() => {
        this.pie_chart2.series.values[0].children.values[5].show();
      }, 1000);
      // let newData = await this.callBudgetAPI();
      this.pie_chart2.data.map((x) => {
        let updated = R.find(R.propEq("category", x.category), newData);
        x.weekly = updated.weekly;
        x.monthly = updated.monthly;
        x.annual = updated.annual;
        return x;
      });
      this.pie_chart2.invalidateRawData();
    },
    async updateSpeedChart(value) {
      // this.speed_chart.radarContainer._children._values[5].text =
      //   parseFloat(value);
      this.speed_chart.radarContainer._children._values[5].fill = am4core.color(
        this.dark ? "#fff" : "#000"
      );
      let hand = this.speed_chart.hands._values[0];
      new am4core.Animation(
        hand,
        {
          property: "value",
          to: this.roundSpeedValue(parseFloat(value)),
        },
        1000,
        am4core.ease.cubicOut
      ).start();
    },
    async updatePieChart(newData, pie_chart_type) {
      const _this = this;
      pie_chart_type.series.values[0].children.values[5].hide(0, 0);
      setTimeout(() => {
        pie_chart_type.series.values[0].children.values[5].show();
      }, 1000);
      // console.log(this.pie_chart.series);
      pie_chart_type.series.values[0].children.values[5].fill = am4core.color(
        this.dark ? "#fff" : "#000"
      );
      /* eslint-disable */
      let da = newData.map((item) => ({
        ...item,
        dol: Math.trunc(
          (_this.monthly_take_home_input_value.replace(/[^\d\.\-]/g, "") *
            item.monthly) /
            100
        ),
      }));
      // let newData = await this.callBudgetAPI();
      pie_chart_type.data.map((x) => {
        let updated = R.find(R.propEq("category", x.category), da);
        x.weekly = updated.weekly;
        x.monthly = updated.monthly>=0?updated.monthly:0;;
        x.annual = updated.annual;
        x.dol = updated.dol;
        return x;
      });

      pie_chart_type.invalidateRawData();
    },
    changePeer(event) {
      this.showPeer = event;
    },
    async updateBarChart(newData) {
      // console.log(newData)
      // const nw = newData.sort((a,b) => (a.peer_monthly > b.peer_monthly) ? -1 : ((b.peer_monthly > a.peer_monthly) ? 1 : 0)).splice(0,5)
      // console.log(nw)

      this.bar_chart.dispose();
      this.bar_chart = this.createBarChart(newData);
      // this.bar_chart.data.map((x) => {
      //   let updated = R.find(R.propEq("category", x.category), nw);
      //   x.user_weekly = updated.user_weekly;
      //   x.user_monthly = updated.user_monthly;
      //   x.user_annual = updated.user_annual;
      //   x.peer_weekly = updated.peer_weekly;
      //   x.peer_monthly = updated.peer_monthly;
      //   x.peer_annual = updated.peer_annual;
      //   return x;
      // });
      // this.bar_chart.invalidateRawData();
    },
    async updateChart() {
      this.chart.series.values[0].children.values[5].hide(0, 0);
      setTimeout(() => {
        this.chart.series.values[0].children.values[5].show();
      }, 1000);
      let newData = await this.callBudgetAPI();
      this.chart.data.map((x) => {
        let updated = R.find(R.propEq("category", x.category), newData);
        x.weekly = updated.weekly;
        x.monthly = updated.monthly;
        x.annual = updated.annual;
        return x;
      });
      this.chart.invalidateRawData();
    },
    async recategorizePieChart(data) {
      this.pie_chart.data = data;
    },
    async recategorizePieChart2(data) {
      this.pie_chart2.data = data;
    },
    async recategorizeBarChart() {
      // this.bar_chart.data = data.sort(function (a, b) {
      //   let a_diff = Math.abs(a.peer_monthly - a.user_monthly);
      //   let b_diff = Math.abs(b.peer_monthly - b.user_monthly);
      //   if (a_diff < b_diff) {
      //     return 1;
      //   }
      //   if (a_diff > b_diff) {
      //     return -1;
      //   } else return 0;
      // });
    },
    async callBudgetAPI() {
      // console.log(this.mortgage_and_rent_input_value,this.mortgage_and_rent_value,'bete');
      const changed = _.cloneDeep(this.changedValues);
      const URI = "https://api.spendid.io/v1.0/budgets/generate";
      const config = {
        headers: { "x-api-key": "HTDzMgEntXaBYVFZ6SSth2iosFRjVe7F8QtM4HBr" },
      };
      // console.log(this.mortgage_and_rent_value,'value to be check');

      let demograph;
      if (this.checkForValidate()) {
        demograph = {
          net_annual_income:
            (this.grossOrNet === "gross"
              ? this.monthly_take_home_net
              : this.monthly_take_home) *
            this.monthly_take_home_input_value_freq,
          age: parseInt(this.age),
          household_members: parseInt(this.household_members),
          zip: this.zip,
          is_homeowner: this.is_homeowner_value,
        };
      } else {
        demograph = {
          net_annual_income: 5000 * 12,
          age: 35,
          household_members: 1,
          zip: "35210",
          is_homeowner: false,
        };
      }

      let trasformer = _.cloneDeep(this.selected_transformer);
      // delete trasformer.cash_contributions_gift;

      if (
        "cash_contributions" in changed &&
        !("cash_contributions_gift" in changed) &&
        this.filtered_barchart &&
        this.filtered_barchart.length > 0
      ) {
        changed["cash_contributions"] =
          changed["cash_contributions"] +
          this.filtered_barchart.find(
            (item) => item.category_type == "cash_contributions_gift"
          ).user_monthly *
            12;
      }

      if (
        !("cash_contributions" in changed) &&
        "cash_contributions_gift" in changed &&
        this.filtered_barchart &&
        this.filtered_barchart.length > 0
      ) {
        changed["cash_contributions"] =
          changed["cash_contributions_gift"] +
          this.filtered_barchart.find(
            (item) => item.category_type == "cash_contributions"
          ).user_monthly *
            12;
      }

      if (
        "cash_contributions" in changed &&
        "cash_contributions_gift" in changed &&
        this.filtered_barchart &&
        this.filtered_barchart.length > 0
      ) {
        changed["cash_contributions"] =
          changed["cash_contributions"] + changed["cash_contributions_gift"];
      }

      const post_data = {
        demographics: demograph,
        transformer: trasformer,
        budget: {
          ...changed,
          savings:
            this.savings_value !== null
              ? this.savings_value * this.savings_input_value_freq
              : this.lending_score_cash_excess_formattedNonFormat
              ? parseInt(this.lending_score_cash_excess_formattedNonFormat)
              : null,
          other_debt_payments:
            this.debt_value !== null
              ? this.debt_value * this.debt_input_value_freq
              : null,
          health_insurance:
            this.health_insurance_value !== null
              ? parseInt(this.health_insurance_value) *
                this.health_insurance_input_value_freq
              : null,
          mortgage_and_rent:
            this.mortgage_and_rent_value !== null
              ? parseInt(this.mortgage_and_rent_value) *
                this.mortgage_and_rent_input_value_freq
              : null,
          vehicle_purchase_and_lease:
            this.vehicle_purchase_and_lease_value !== null
              ? this.vehicle_purchase_and_lease_value *
                this.vehicle_purchase_and_lease_input_value_freq
              : null,
          ...this.eliminated,
        },
      };

      const mainData = {
        net_amount: this.net_amount,
        monthly_take_home: this.monthly_take_home,
        monthly_take_home_feq: this.monthly_take_home_input_value_freq,
        age: parseInt(this.age),
        income_method: {
          income_method_val: this.income_method_val,
          occupations_val: this.occupations_val,
          annual_gross_salary_level_val: this.annual_gross_salary_level_val,
        },
        household_members: parseInt(this.household_members),
        user_name: this.user_name,
        user_email: this.user_email,
        zip: this.zip,
        is_homeowner: this.is_homeowner_value,
        saving: {
          value: this.savings_value,
          freq: this.savings_input_value_freq,
        },
        other_debt_payments: {
          value: this.debt_value,
          freq: this.debt_input_value_freq,
        },
        mortgage_and_rent: {
          value: this.mortgage_and_rent_value,
          freq: this.mortgage_and_rent_input_value_freq,
        },
        vehicle_purchase_and_lease: {
          value: this.vehicle_purchase_and_lease_value,
          freq: this.vehicle_purchase_and_lease_input_value_freq,
        },
        health_insurance: {
          value: this.health_insurance_value,
          freq: this.health_insurance_input_value_freq,
        },
        rest: this.changedValuesText,
        rest2: this.changedValues,
        eliminated: this.eliminated,
      };
      try {
        localStorage.setItem("storedData", JSON.stringify(mainData));
      } catch {
        // eslint-disable-next-line no-console
        console.log("storedData");
      }

      const result = await this.$http.post(URI, post_data, config);
      this.apiReq = post_data;
      this.callBudgetAPIRes = result.data;
      // hack to add a debt payment option
      const api_model = Object.entries(result.data.transformed).map(
        ([category, annual]) => ({
          category,
          annual,
        })
      );

      const bud = Object.entries(result.data.budget).map(
        ([category, annual]) => ({
          category,
          annual,
          bud,
        })
      );

      // console.log(api_model,bud,'sssss')

      const eliminated = Object.entries(this.eliminated).map(
        ([category]) => category
      );
      api_model.push({
        annual:
          "cash_contributions_gift" in this.changedValues
            ? this.changedValues["cash_contributions_gift"]
            : (((this.grossOrNet === "gross"
                ? this.monthly_take_home
                : this.monthly_take_home_net) *
                this.monthly_take_home_input_value_freq) /
                12) *
              0.01 *
              12,
        category: "Gifts to Family & Friends",
      });
      const budget = api_model.map((x) => {
        if (x.category === "Charitable Giving") {
          x = {
            ...x,
            annual: !("cash_contributions" in this.changedValues)
              ? x.annual -
                (((this.grossOrNet === "gross"
                  ? this.monthly_take_home
                  : this.monthly_take_home_net) *
                  this.monthly_take_home_input_value_freq) /
                  12) *
                  0.01 *
                  12
              : this.changedValues["cash_contributions"],
          };
        }
        const key = Object.keys(transformer_38).find(
          (item) => transformer_38[item] === x.category
        );
        return {
          category: x.category,
          category_type:
            x.category === "Gifts to Family & Friends"
              ? "cash_contributions_gift"
              : key,
          annual: Math.round(x.annual),
          monthly: Math.round(x.annual / 12),
          weekly: Math.round(x.annual / 52),
          isActive: !eliminated.includes(key),
        };
      });
      console.log(budget, "22");
      return budget;
    },
    async callScoringAPI() {
      // console.log(this.mortgage_and_rent_value,'no');
      const changed = _.cloneDeep(this.changedValues);
      const URI = "https://api.spendid.io/v1.0/scores/generate";
      const config = {
        headers: { "x-api-key": "HTDzMgEntXaBYVFZ6SSth2iosFRjVe7F8QtM4HBr" },
      };

      let demograph;
      if (this.checkForValidate()) {
        demograph = {
          net_annual_income:
            (this.grossOrNet === "gross"
              ? this.monthly_take_home_net
              : this.monthly_take_home) *
            this.monthly_take_home_input_value_freq,
          age: parseInt(this.age),
          household_members: parseInt(this.household_members),
          zip: this.zip,
          is_homeowner: this.is_homeowner_value,
        };
      } else {
        demograph = {
          net_annual_income: 5000 * 12,
          age: 35,
          household_members: 1,
          zip: "35210",
          is_homeowner: false,
        };
      }
      if (
        "cash_contributions" in changed &&
        !("cash_contributions_gift" in changed) &&
        this.filtered_barchart &&
        this.filtered_barchart.length > 0
      ) {
        changed["cash_contributions"] =
          changed["cash_contributions"] +
          this.filtered_barchart.find(
            (item) => item.category_type == "cash_contributions_gift"
          ).user_monthly *
            12;
      }

      if (
        !("cash_contributions" in changed) &&
        "cash_contributions_gift" in changed &&
        this.filtered_barchart &&
        this.filtered_barchart.length > 0
      ) {
        changed["cash_contributions"] =
          changed["cash_contributions_gift"] +
          this.filtered_barchart.find(
            (item) => item.category_type == "cash_contributions"
          ).user_monthly *
            12;
      }

      if (
        "cash_contributions" in changed &&
        "cash_contributions_gift" in changed &&
        this.filtered_barchart &&
        this.filtered_barchart.length > 0
      ) {
        changed["cash_contributions"] =
          changed["cash_contributions"] + changed["cash_contributions_gift"];
      }
      const post_data = {
        demographics: demograph,
        budget: {
          ...changed,
          savings:
            this.savings_value !== null
              ? this.savings_value * this.savings_input_value_freq
              : this.lending_score_cash_excess_formattedNonFormat
              ? parseInt(this.lending_score_cash_excess_formattedNonFormat)
              : null,
          other_debt_payments:
            this.debt_value !== null
              ? this.debt_value * this.debt_input_value_freq
              : null,
          health_insurance:
            this.health_insurance_value !== null
              ? this.health_insurance_value *
                this.health_insurance_input_value_freq
              : null,
          // mortgage_and_rent:
          //   this.mortgage_and_rent_value !== null
          //     ? parseInt(this.mortgage_and_rent_value) *
          //       this.mortgage_and_rent_input_value_freq
          //     : 0,
          // vehicle_purchase_and_lease:
          //   this.vehicle_purchase_and_lease_value !== null
          //     ? this.vehicle_purchase_and_lease_value *
          //       this.vehicle_purchase_and_lease_input_value_freq
          //     : 0,
          ...this.eliminated,
        },
      };
      if (this.mortgage_and_rent_value !== null) {
        post_data.budget["mortgage_and_rent"] =
          parseInt(this.mortgage_and_rent_value) *
          this.mortgage_and_rent_input_value_freq;
      }
      if (this.vehicle_purchase_and_lease_value !== null) {
        post_data.budget["vehicle_purchase_and_lease"] =
          this.vehicle_purchase_and_lease_value *
          this.vehicle_purchase_and_lease_input_value_freq;
      }

      const result = await this.$http.post(URI, post_data, config);
      this.callScoringAPIRes = result.data;
      const val = {
        breakeven: (
          Math.round((result.data.breakeven || 0) * 100) / 100
        ).toFixed(1),
        saving: (Math.round((result.data.saving || 0) * 100) / 100).toFixed(1),
        lending: (Math.round((result.data.lending || 0) * 100) / 100).toFixed(
          1
        ),
      };
      return val;
    },
    async callLendingScoreAPI() {
      // console.log(this.mortgage_and_rent_value,'ssss')
      const changed = _.cloneDeep(this.changedValues);
      const URI = "https://api.spendid.io/v1.0/scores/lending";
      const config = {
        headers: { "x-api-key": "HTDzMgEntXaBYVFZ6SSth2iosFRjVe7F8QtM4HBr" },
      };

      let demograph;
      if (this.checkForValidate()) {
        demograph = {
          net_annual_income:
            (this.grossOrNet === "gross"
              ? this.monthly_take_home_net
              : this.monthly_take_home) *
            this.monthly_take_home_input_value_freq,
          age: parseInt(this.age),
          household_members: parseInt(this.household_members),
          zip: this.zip,
          is_homeowner: this.is_homeowner_value,
        };
      } else {
        demograph = {
          net_annual_income: 5000 * 12,
          age: 35,
          household_members: 1,
          zip: "35210",
          is_homeowner: false,
        };
      }

      console.log(this.filtered_barchart, "this.filtered_barchart[7]");
      if (
        "cash_contributions" in changed &&
        !("cash_contributions_gift" in changed) &&
        this.filtered_barchart &&
        this.filtered_barchart.length > 0
      ) {
        changed["cash_contributions"] =
          changed["cash_contributions"] +
          this.filtered_barchart.find(
            (item) => item.category_type == "cash_contributions_gift"
          ).user_monthly *
            12;
      }

      if (
        !("cash_contributions" in changed) &&
        "cash_contributions_gift" in changed &&
        this.filtered_barchart &&
        this.filtered_barchart.length > 0
      ) {
        changed["cash_contributions"] =
          changed["cash_contributions_gift"] +
          this.filtered_barchart.find(
            (item) => item.category_type == "cash_contributions"
          ).user_monthly *
            12;
      }

      if (
        "cash_contributions" in changed &&
        "cash_contributions_gift" in changed &&
        this.filtered_barchart &&
        this.filtered_barchart.length > 0
      ) {
        changed["cash_contributions"] =
          changed["cash_contributions"] + changed["cash_contributions_gift"];
      }
      const post_data = {
        demographics: demograph,
        budget: {
          ...changed,
          savings:
            this.savings_value !== null
              ? this.savings_value * this.savings_input_value_freq
              : this.lending_score_cash_excess_formattedNonFormat
              ? parseInt(this.lending_score_cash_excess_formattedNonFormat)
              : null,
          other_debt_payments:
            this.debt_value !== null ? this.debt_value * 12 : null,
          health_insurance:
            this.health_insurance_value !== null
              ? this.health_insurance_value *
                this.health_insurance_input_value_freq
              : null,
          // mortgage_and_rent:
          //   this.mortgage_and_rent_value !== null
          //     ? parseInt(this.mortgage_and_rent_value) *
          //       this.mortgage_and_rent_input_value_freq
          //     : 0,
          // vehicle_purchase_and_lease:
          //   this.vehicle_purchase_and_lease_value !== null
          //     ? this.vehicle_purchase_and_lease_value *
          //       this.vehicle_purchase_and_lease_input_value_freq
          //     : 0,
          ...this.eliminated,
        },
      };

      if (this.mortgage_and_rent_value !== null) {
        post_data.budget["mortgage_and_rent"] =
          parseInt(this.mortgage_and_rent_value) *
          this.mortgage_and_rent_input_value_freq;
      }
      if (this.vehicle_purchase_and_lease_value !== null) {
        post_data.budget["vehicle_purchase_and_lease"] =
          this.vehicle_purchase_and_lease_value *
          this.vehicle_purchase_and_lease_input_value_freq;
      }

      const result = await this.$http.post(URI, post_data, config);
      this.callLendingScoreAPIRes = result.data;
      return result.data;
    },
    async callDemographicsAPI() {
      let trasformer = _.cloneDeep(this.selected_transformer);
      // delete trasformer.cash_contributions_gift;
      const URI = "https://api.spendid.io/v1.0/demographics/models/generate";

      const config = {
        headers: { "x-api-key": "HTDzMgEntXaBYVFZ6SSth2iosFRjVe7F8QtM4HBr" },
      };
      let demograph;
      if (this.checkForValidate()) {
        demograph = {
          net_annual_income:
            (this.grossOrNet === "gross"
              ? this.monthly_take_home_net
              : this.monthly_take_home) *
            this.monthly_take_home_input_value_freq,
          age: parseInt(this.age),
          household_members: parseInt(this.household_members),
          zip: this.zip,
          is_homeowner: this.is_homeowner_value,
        };
      } else {
        demograph = {
          net_annual_income: 5000 * 12,
          age: 35,
          household_members: 1,
          zip: "35210",
          is_homeowner: false,
        };
      }

      const post_data = {
        demographics: demograph,
        transformer: trasformer,
      };

      const result = await this.$http.post(URI, post_data, config);
      this.callDemographicsAPIRes = result.data;
      // hack to add a debt payment option
      const api_model = Object.entries(result.data.transformed).map(
        ([category, annual]) => ({
          category,
          annual,
        })
      );

      api_model.push({
        annual:
          (((this.grossOrNet === "gross"
            ? this.monthly_take_home
            : this.monthly_take_home_net) *
            this.monthly_take_home_input_value_freq) /
            12) *
          0.01 *
          12,
        category: "Gifts to Family & Friends",
      });

      const demographics = api_model.map((x) => {
        if (x.category === "Charitable Giving") {
          x = {
            ...x,
            annual:
              x.annual -
              (((this.grossOrNet === "gross"
                ? this.monthly_take_home
                : this.monthly_take_home_net) *
                this.monthly_take_home_input_value_freq) /
                12) *
                0.01 *
                12,
          };
        }
        return {
          category: x.category,
          // category_type: bud[i].category,
          annual: Math.round(x.annual),
          monthly: Math.round(x.annual / 12),
          weekly: Math.round(x.annual / 52),
          isActive: false,
        };
      });
      console.log(this.changedValues, "demographics");
      this.demographics_response = demographics;
      return demographics;
    },
  },
};
</script>

<template>
  <div
    :class="{
      darkmode: dark,
      'no-result':
        !checkForValidate() ||
        debt_value === null ||
        !(debt_value >= 0) ||
        vehicle_purchase_and_lease_value === null ||
        !(vehicle_purchase_and_lease_value >= 0) ||
        mortgage_and_rent_value === null ||
        !(mortgage_and_rent_value >= 0) ||
        health_insurance_value === null ||
        !(health_insurance_value >= 0),
    }"
  >
    <div :class="{ 'd-none': page != 'main' }">
      <b-modal
        id="instructionModal"
        size="lg"
        hide-footer
        hide-header
        class="customInstructionModal text-center p-5"
      >
        <div class="d-block text-center p-4">
          <h3>Final Step Instruction:</h3>
          <p>
            If an expense category doesn't apply to you at all,<br />click the
            red <i class="fa fa-remove"></i> to remove it (such as
            <strong>Pets,</strong> or
            <strong><br />Babysitting/Preschool/Eldercare</strong> for example).
          </p>
          <p>
            Or if you know that an expense category is usually a<br />certain
            amount, like <strong>Phone services</strong> for example, click on
            it<br />and enter that amount.
          </p>
          <p>
            Taking a minute to do these simple things will make your<br />DoneForYouBudget
            <strong>Results</strong> even more accurate.
          </p>
        </div>
        <div class="w-100 d-flex justify-content-center">
          <b-button
            class="mt-3 w-auto"
            block
            @click="$bvModal.hide('instructionModal')"
            >Continue</b-button
          >
        </div>
      </b-modal>

      <router-view />
      <Navbar
        :showPeer="showPeer"
        :stepEnable="stepEnable"
        :dataLoading="api_updates_pending || !checkForValidate()"
        :showResult="checkForValidate()"
        v-on:fillAutoData="fillAutoData"
      />
      <div class="position-relative login-popup">
        <!-- <div id="login-page" v-if="!access_token">
          <div class="login-modal">
            <div v-if="$route.query.page=='login'">
              <h4 class="mb-4">Please wait... While we are redirecting to login page</h4>
            </div>
            <div v-else-if="!auth['user']">
              <h4 class="mb-4">Login to Predict, Compare and Score Your Cash Flow Health</h4>
              <button class="btn btn-theme" @click="login">Login</button>
            </div>
            <div v-else-if="$route.query.page=='login'">
              <h4 class="mb-4">Please wait... While we are redirecting to login page</h4>
            </div>
          </div>
       </div> -->
        <!-- <Redirection  v-if="!access_token"/> -->
        <b-table style="display: none" id="printtable" striped hover></b-table>

        <div v-if="!isActive" class="print-loader">
          <div class="print-loader-message">
            <div>
              <h3 style="margin-bottom: 40px">
                <span class="visible-md"> Downloading </span>
                <span class="hidden-md"> Preparing </span>
                Report
              </h3>
              <vue-ellipse-progress :progress="percentage" />
              <h5 style="margin-top: 40px">Preparing your report</h5>
              <h5>
                It will take some time to prepare and
                <span class="visible-md"> download </span>
                <span class="hidden-md"> email </span>
                your statement, Please be patient
              </h5>
            </div>
          </div>
        </div>
        <b-form @submit="onSubmit" id="gtm-tag">
          <section id="live-demo">
            <div class="toggle-wrap">
              <a href="#">
                <img
                  alt="thumbs-up"
                  width="150"
                  src="toggle.png"
                  class="img-fluid"
                />
              </a>
            </div>

            <stepform
              v-if="stepEnable"
              :byPass="byPass"
              v-on:submitStepForm="submitStepForm"
              v-on:fillAutoData="fillAutoData"
              v-on:stepEnable="stepEnable = false"
            />
            <b-container fluid ref="third_sec" class="custom-container">
              <b-row>
                <!-- new-styling-start -->
                <b-col sm="12" xl="12">
                  <div class="stepdiv">
                    <b-row>
                      <b-col sm="12" lg="6" xl="3">
                        <b-card
                          class="no-border new-frame-first-card mb-1 mb-lg-3"
                        >
                          <template #title>
                            <div class="d-flex justify-content-between w-100">
                              <!-- <span>Profile <i class="fa fa-check-circle text-light" :class="{'bright': checkForNext1}"></i></span> -->
                              <span>Profile</span>
                              <div class="hover-info-box d-none">
                                <span class="hover-icon ml-2">
                                  <i
                                    class="far fa-question-circle text-light"
                                  ></i>
                                </span>
                                <div class="hover-info position-left">
                                  <p class="m-0 hover-info-text">
                                    You can edit your Onboarding inputs in the
                                    Profile and Mojor Expenses section at any
                                    time
                                  </p>
                                </div>
                              </div>
                            </div>
                          </template>

                          <div
                            class="new-accordin-frame"
                            :class="{ printbg: !isActive }"
                            ref="element"
                          >
                            <div class="newframe-card-title d-none d-xl-block">
                              <h4 class="title-result">Profile</h4>
                            </div>
                            <div class="newframe-card-title d-block d-xl-none">
                              <b-button
                                @click="
                                  visibleProfileHousehold =
                                    !visibleProfileHousehold
                                "
                                block
                                :class="
                                  visibleProfileHousehold ? null : 'collapsed'
                                "
                                variant="primary"
                              >
                                <div class="newcatgory-header">
                                  <h5 class="newcatgory-title m-0">Profile</h5>
                                </div>
                              </b-button>
                            </div>
                            <b-collapse
                              visible
                              id="ProfileHouseold"
                              v-model="visibleProfileHousehold"
                              class="mt-2"
                            >
                              <b-card class="mb-3 new-frame-card no-shadow">
                                <div class="address_sec">
                                  <b-form-group class="has-icons-right">
                                    <b-row>
                                      <b-col md="12">
                                        <label>5-Digit Zip Code</label>
                                      </b-col>
                                      <b-col md="12">
                                        <b-form-input
                                          placeholder="Enter your zip code"
                                          v-model="zip"
                                          pattern="\d*"
                                          type="text"
                                          maxlength="5"
                                          autocomplete="on"
                                          class="position-relative input-capitalize"
                                        >
                                        </b-form-input>
                                        <span
                                          class="check icon is-small is-right"
                                        >
                                          <i
                                            v-if="is_typing"
                                            class="fas fa-cog fa-spin"
                                            style="opacity: 0.5"
                                          ></i>
                                        </span>
                                      </b-col>
                                    </b-row>
                                  </b-form-group>
                                  <b-form-group>
                                    <b-row>
                                      <b-col md="12">
                                        <label class="font-style-itatic"
                                          ><i>City</i></label
                                        >
                                      </b-col>
                                      <b-col md="12">
                                        <b-form-input
                                          placeholder=""
                                          :class="{
                                            asa:
                                              zip_codes.find(
                                                (item) =>
                                                  item['Zip Code'] === zip
                                              ) &&
                                              zip_codes.find(
                                                (item) =>
                                                  item['Zip Code'] === zip
                                              ),
                                          }"
                                          disabled
                                          :value="
                                            zip_codes.find(
                                              (item) => item['Zip Code'] === zip
                                            ) &&
                                            zip_codes.find(
                                              (item) => item['Zip Code'] === zip
                                            )['City']
                                          "
                                          type="text"
                                          class="position-relative dis no-border-input"
                                        >
                                        </b-form-input>
                                      </b-col>
                                    </b-row>
                                  </b-form-group>
                                  <b-form-group>
                                    <b-row>
                                      <b-col md="12">
                                        <label lass="font-style-itatic"
                                          ><i>State</i></label
                                        >
                                      </b-col>
                                      <b-col md="12">
                                        <b-form-input
                                          placeholder=""
                                          disabled
                                          :class="{
                                            asa:
                                              zip_codes.find(
                                                (item) =>
                                                  item['Zip Code'] === zip
                                              ) &&
                                              state_gross.find(
                                                (it) =>
                                                  it.abbreviation ===
                                                  zip_codes.find(
                                                    (item) =>
                                                      item['Zip Code'] === zip
                                                  )['State']
                                              ),
                                          }"
                                          :value="
                                            zip_codes.find(
                                              (item) => item['Zip Code'] === zip
                                            ) &&
                                            state_gross.find(
                                              (it) =>
                                                it.abbreviation ===
                                                zip_codes.find(
                                                  (item) =>
                                                    item['Zip Code'] === zip
                                                )['State']
                                            ).state
                                          "
                                          type="text"
                                          class="position-relative dis no-border-input"
                                        >
                                        </b-form-input>
                                      </b-col>
                                    </b-row>
                                  </b-form-group>
                                </div>
                              </b-card>
                              <div
                                class="result-profile-innercard-outer mb-3 mb-lg-0"
                                v-if="!income_method_val"
                              >
                                <b-card
                                  no-header
                                  no-body
                                  class="result-profile-innercard profile-innercard no-box-shadow border-radius-10 mb-3"
                                  v-for="(amt_freq, counter) in net_amount"
                                  :key="counter"
                                >
                                  <div
                                    class="result-profile-innercard-header d-flex align-items-center justify-content-between"
                                  >
                                    <h4 class="profile-innercard-title">
                                      Income Source {{ counter + 1 }}
                                    </h4>
                                    <span
                                      v-if="net_amount.length > 1"
                                      @click="deleteIncome(counter)"
                                      class="text-danger cursor-pointer d-inline-block font-weight-bold far fa-times-circle"
                                    >
                                    </span>
                                  </div>
                                  <div class="result-profile-innercard-body">
                                    <b-form-group
                                      class="custom-form-control"
                                      has-icons-right
                                    >
                                      <!-- <label>Income Method</label> -->
                                      <b-form-radio-group
                                        v-model="net_amount[counter].manual"
                                        :options="income_method"
                                        @change="
                                          incomeChange(
                                            counter,
                                            net_amount[counter].manual
                                          )
                                        "
                                        :name="`income_source_method${counter}`"
                                        class="mt-0"
                                      ></b-form-radio-group>
                                    </b-form-group>
                                    <template v-if="amt_freq.manual != '2'">
                                      <div class="income-method-inner">
                                        <b-form-group
                                          label="Occupation Selector"
                                          class="custom-form-control"
                                        >
                                          <Multiselect
                                            placeholder="Search"
                                            v-model="
                                              net_amount[counter].occupation
                                            "
                                            @select="
                                              levelChange(
                                                counter,
                                                net_amount[counter].level,
                                                net_amount[counter].occupation
                                              )
                                            "
                                            @remove="
                                              levelChange(
                                                counter,
                                                net_amount[counter].level,
                                                net_amount[counter].occupation
                                              )
                                            "
                                            :options="
                                              occupations.map((item) => item.id)
                                            "
                                          >
                                          </Multiselect>
                                        </b-form-group>
                                        <b-form-group
                                          label="Annual Gross Salary Level"
                                          class="custom-form-control annual-gross-input"
                                        >
                                          <b-form-radio-group
                                            :disabled="
                                              !net_amount[counter].occupation
                                            "
                                            v-model="net_amount[counter].level"
                                            :options="annual_gross_salary_level"
                                            @change="
                                              levelChange(
                                                counter,
                                                net_amount[counter].level,
                                                net_amount[counter].occupation
                                              )
                                            "
                                            :name="`gross-salary-radio-${counter}`"
                                            class="mt-0"
                                            stacked
                                          ></b-form-radio-group>
                                        </b-form-group>
                                        <b-form-group
                                          label="Amount (Annual Gross)"
                                          class="custom-form-control mb-0"
                                        >
                                          <b-form-input
                                            v-model.lazy="amt_freq.amount"
                                            v-money="money"
                                            disabled
                                            type="text"
                                            pattern="\d*"
                                            autocomplete="on"
                                            class="position-relative"
                                          >
                                          </b-form-input>
                                        </b-form-group>
                                      </div>
                                    </template>
                                    <template v-else>
                                      <div class="income-method-inner">
                                        <b-form-group
                                          label="Amount"
                                          class="custom-form-control"
                                        >
                                          <b-form-input
                                            v-model.lazy="amt_freq.amount"
                                            v-money="money"
                                            @blur="onSeourceSelect(counter)"
                                            type="text"
                                            pattern="\d*"
                                            autocomplete="on"
                                            class="position-relative"
                                            placeholder="Type your answer here..."
                                          >
                                          </b-form-input>
                                        </b-form-group>
                                        <b-form-group
                                          label="Frequency"
                                          class="custom-form-control"
                                        >
                                          <b-form-select
                                            v-on:keyup.once="
                                              amt_freq.freq =
                                                $event.target.value
                                            "
                                            @change="onSeourceSelect(counter)"
                                            v-model.lazy="amt_freq.freq"
                                            :options="frequencyOptionsNew"
                                            :value="null"
                                          >
                                          </b-form-select>
                                        </b-form-group>

                                        <div class="gross-net-home-radios mt-2">
                                          <div class="inputGroup mb-2">
                                            <input
                                              type="radio"
                                              :name="`radio-inline-${counter}`"
                                              value="gross"
                                              @click="
                                                onSeourceSelect(counter, false)
                                              "
                                              v-model="
                                                net_amount[counter].grossOrNet
                                              "
                                              :id="`incomeradioOption-${counter}`"
                                            />
                                            <label
                                              :for="`incomeradioOption-${counter}`"
                                            >
                                              <span class="">Gross</span>
                                            </label>
                                          </div>
                                          <div class="inputGroup mb-2">
                                            <input
                                              type="radio"
                                              :name="`radio-inline-${counter}`"
                                              value="net"
                                              @click="
                                                onSeourceSelect(counter, false)
                                              "
                                              v-model="
                                                net_amount[counter].grossOrNet
                                              "
                                              :id="`grossradioOption-${counter}`"
                                            />
                                            <label
                                              :for="`grossradioOption-${counter}`"
                                            >
                                              Net "Take Home"
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                    </template>
                                  </div>
                                </b-card>
                                <div
                                  class="result-profile-innercard-actions mb-3"
                                >
                                  <b-button
                                    @click="addIncome()"
                                    type="button"
                                    class="w-100 my-1 btn-green"
                                  >
                                    <i class="fas fa-plus-circle"></i>
                                    Add Income Source
                                  </b-button>
                                  <b-button
                                    @click="getAdvice()"
                                    type="button"
                                    class="w-100 my-1 btn-purple"
                                  >
                                  Ideas
                                  </b-button>
                                </div>
                              </div>

                              <b-card
                                no-header
                                no-body
                                class="result-profile-innercard profile-innercard no-box-shadow border-radius-10 mb-3 mb-lg-0"
                              >
                                <div class="result-profile-innercard-header">
                                  <h4
                                    class="profile-innercard-title m-0 text-center"
                                  >
                                    Monthly Gross Amount
                                  </h4>
                                </div>
                                <div class="result-profile-innercard-body">
                                  <p
                                    class="mb-0 text-center monthly-net-amount"
                                  >
                                    <b>{{ monthly_take_home_input_value }}</b>
                                  </p>
                                </div>
                              </b-card>
                              <b-card
                                no-header
                                no-body
                                class="result-profile-innercard profile-innercard no-box-shadow border-radius-10 mb-3 mb-lg-0 mt-2"
                              >
                                <div class="result-profile-innercard-header">
                                  <h4
                                    class="profile-innercard-title m-0 text-center"
                                  >
                                    Monthly Net Amount to Budget
                                  </h4>
                                </div>
                                <div class="result-profile-innercard-body">
                                  <p
                                    class="mb-0 text-center monthly-net-amount"
                                  >
                                    <b>{{ netAmountInput }}</b>
                                  </p>
                                </div>
                              </b-card>
                              <b-card class="mb-3 new-frame-card mt-2">
                                <div class="address_sec">
                                  <b-form-group class="has-icons-right">
                                    <b-row>
                                      <b-col md="12">
                                        <label
                                          >Age
                                          <span
                                            class="text-danger mb-3 small ml-2"
                                            v-if="age < 18"
                                            >(Your age must be 18+.)</span
                                          ></label
                                        >
                                      </b-col>
                                      <b-col md="12">
                                        <b-form-input
                                          placeholder="Enter your age"
                                          v-model="age"
                                          type="text"
                                          pattern="\d*"
                                          @blur="focusOut($event)"
                                          autocomplete="on"
                                          class="position-relative input-capitalize"
                                        >
                                        </b-form-input>
                                        <span
                                          class="check icon is-small is-right"
                                        >
                                          <i
                                            v-if="age < 18"
                                            class="fas fa-times text-danger"
                                          ></i>
                                          <i
                                            v-else-if="is_typing"
                                            class="fas fa-cog fa-spin"
                                            style="opacity: 0.5"
                                          ></i>
                                        </span>
                                      </b-col>
                                    </b-row>
                                  </b-form-group>
                                  <b-form-group class="has-icons-right">
                                    <label
                                      ># in Household
                                      <span
                                        class="text-danger small ml-2"
                                        v-if="household_members < 1"
                                        >(Your household must be min 1.)</span
                                      ></label
                                    >
                                    <div class="d-block mb-4 mt-2 step-slider">
                                      <vue-slider
                                        v-model="household_members"
                                        :data="data"
                                        :marks="true"
                                        :data-value="'id'"
                                        :data-label="'name'"
                                        :dot-options="dotOptions"
                                      ></vue-slider>
                                    </div>
                                  </b-form-group>
                                  <b-form-group
                                    v-slot="{ ariaDescribedby }"
                                    class="mb-2 mt-4"
                                  >
                                    <label>Housing Type</label>
                                    <b-form-radio-group
                                      v-model="is_homeowner"
                                      :options="home_options"
                                      :aria-describedby="ariaDescribedby"
                                      name="radio-inline"
                                      class="mt-0"
                                      size="lg"
                                    ></b-form-radio-group>
                                  </b-form-group>
                                </div>
                              </b-card>
                            </b-collapse>
                          </div>
                        </b-card>
                      </b-col>
                      <b-col sm="12" lg="6" xl="3" class="pr-xl-0">
                        <b-card
                          class="no-border shadow-none new-frame-second-card mb-1 mb-lg-3"
                        >
                          <template #title>
                            <div
                              class="d-flex justify-content-between align-items-center w-100"
                            >
                              <!-- <span>Major Expenses <i class="fa fa-check-circle text-light" :class="{'bright': checkForNext2}"></i></span> -->
                              <span>Compassion Choice </span>
                              <div class="hover-info-box d-none">
                                <span class="hover-icon ml-2">
                                  <i
                                    class="far fa-question-circle text-light"
                                  ></i>
                                </span>
                                <div class="hover-info position-left">
                                  <p class="m-0 hover-info-text">
                                    Input these few major expenses which are
                                    usually the largest
                                  </p>
                                </div>
                              </div>
                            </div>
                          </template>
                          <div class="major-expenseform" ref="element">
                            <div
                              class="cust-core-expense-accordion accordion-collapsed"
                              role="tablist"
                            >
                              <!-- <div class="newframe-card-title">
                                <h4>Major Expenses </h4>
                               </div> -->
                              <b-card
                                no-body
                                class="no-border shadow-none new-frame-second-card"
                              >
                                <div
                                  class="new-accordin-frame new-accordin-frame"
                                >
                                  <b-button
                                    @click="
                                      visibleCoreExpCat = !visibleCoreExpCat;
                                      visibleOtherExpCat = false;
                                      visiblePersComp = false;
                                      visibleFutureExpCat = false;
                                    "
                                    block
                                    :class="
                                      visibleCoreExpCat ? null : 'collapsed'
                                    "
                                    variant="primary"
                                  >
                                    <div class="newcatgory-header">
                                      <h5 class="newcatgory-title m-0">
                                        Compassion Choice
                                      </h5>
                                      <!-- <h5 class="newcatgory-num m-0 mr-3">5</h5> -->
                                    </div>
                                  </b-button>
                                  <b-collapse
                                    visible
                                    id="MajorExpenses"
                                    v-model="visibleCoreExpCat"
                                    class="mt-2"
                                  >
                                    <b-card
                                      no-body
                                      class="no-shadow no-border"
                                      :class="{ 'd-none': !checkForNext1 }"
                                    >
                                      <b-row class="align-items-center">
                                        <b-col xs="12" md="4" lg="4">
                                          <div class="legends py-2 mb-0">
                                            <!-- <p>
                                            <span
                                              class="commmon-circle predict"
                                            >
                                              <b-button
                                                size="sm"
                                                class="btn questionsize"
                                                v-b-popover.hover.top="
                                                  'Predicted by SPENDiD is our estimate of the amount required in order for the User to achieve the Predicted Saving Ability or Custom Amount to Savings (but not worse than break-even)'
                                                "
                                                variant="primary"
                                              >
                                                <i
                                                  class="
                                                    fas
                                                    fa-question
                                                    text-light
                                                  "
                                                ></i></b-button></span
                                            >Predicted
                                          </p> -->
                                            <div class="hover-info-box">
                                              <p class="commmon-circle predict">
                                                <b-button
                                                  size="sm"
                                                  class="btn questionsize"
                                                  variant="primary"
                                                >
                                                  <i
                                                    class="fas fa-question text-light"
                                                  ></i
                                                ></b-button>
                                                Predicted
                                              </p>
                                              <div
                                                class="hover-info position-left"
                                              >
                                                <p class="m-0 hover-info-text">
                                                  Predicted by SPENDiD is our
                                                  estimate of the amount
                                                  required in order for the User
                                                  to achieve the Predicted
                                                  Saving Ability or Custom
                                                  Amount to Savings (but not
                                                  worse than break-even)
                                                </p>
                                              </div>
                                            </div>
                                            <p>
                                              <span class="input-btn"></span>
                                              input
                                            </p>
                                            <!-- <p>
                                            <span
                                              class="commmon-circle your-peers"
                                            >
                                              <b-button
                                                size="sm"
                                                class="btn questionsize"
                                                v-b-popover.hover.top="
                                                  'Peer amounts for each expense category are calculated by SPENDiD based on the user’s demographic profile information including income, zip code, age, etc…'
                                                "
                                                variant="primary"
                                              >
                                                <i
                                                  class="
                                                    fas
                                                    fa-question
                                                    text-light
                                                  "
                                                ></i></b-button></span
                                            >Peers
                                          </p> -->
                                            <div class="hover-info-box">
                                              <p
                                                class="commmon-circle your-peers"
                                              >
                                                <b-button
                                                  size="sm"
                                                  class="btn questionsize"
                                                  variant="primary"
                                                >
                                                  <i
                                                    class="fas fa-question text-light"
                                                  ></i
                                                ></b-button>
                                                Peers
                                              </p>
                                              <div
                                                class="hover-info position-left"
                                              >
                                                <p class="m-0 hover-info-text">
                                                  Peer amounts for each expense
                                                  category are calculated by
                                                  SPENDiD based on the user’s
                                                  demographic profile
                                                  information including income,
                                                  zip code, age, etc…
                                                </p>
                                              </div>
                                            </div>
                                          </div>
                                          <div
                                            class="cat-edit-disable d-flex align-itemas-center justify-content-md-end"
                                          >
                                            <!-- <div class="d-inline-block mr-2">
                                                  <i class="fas fa-info-circle"></i>
                                              </div> -->
                                            <div
                                              class="w-100 text-center d-none m_white"
                                            >
                                              Remove
                                              <i
                                                class="far fa-times-circle text-danger"
                                                aria-hidden="true"
                                              ></i>
                                              or Edit
                                              <i class="fas fa-edit small"></i>
                                            </div>
                                          </div>
                                        </b-col>
                                      </b-row>
                                      <div class="budget-tables-header mb-3">
                                        <b-row class="align-items-center">
                                          <b-col
                                            xs="12"
                                            md="12"
                                            lg="12"
                                            class="text-center expense"
                                          >
                                            <h6
                                              style="font-size: 14px"
                                              class="font-weight-bold mb-0"
                                            >
                                              Click to Edit Any Expense Category
                                            </h6>
                                          </b-col>
                                        </b-row>
                                      </div>

                                      <div
                                        class="budget-tables"
                                        :class="{ listview: !gridSecond }"
                                      >
                                        <b-row
                                          v-click-outsides="handleFocusOut"
                                          :class="{
                                            'd-none': !checkForValidate(),
                                          }"
                                        >
                                          <budgetComponent
                                            :zip="zip"
                                            :age="age"
                                            :crossDisable="true"
                                            :defaultValues="changedValuesText"
                                            :grid="gridSecond"
                                            :showPeer="showPeer"
                                            :defaultActiveTab="defaultActiveTab"
                                            @defaultActiveTabAction="
                                              defaultActiveTabAction
                                            "
                                            @event="openModelEliminate"
                                            @changeValue="changeValue"
                                            class="cat-comps"
                                            v-for="chart in filtered_barchart &&
                                            filtered_barchart.filter(
                                              (item, i) =>
                                                i != 4 &&
                                                item.isActive &&
                                                common_monthly_2.includes(
                                                  item.category
                                                )
                                            )"
                                            :key="chart.category"
                                            :title="chart.category"
                                            :value1="chart.peer_monthly"
                                            :value2="chart.user_monthly"
                                            :frequencyOptions="frequencyOptions"
                                          />

                                          <!-- <CoreExpenseCategories
                                            :zip="zip"
                                            :age="age"
                                            :grid="gridSecond"
                                            :showPeer="showPeer"
                                            @changeValue="changeValue"
                                            :defaultActiveTab="defaultActiveTab"
                                            @defaultActiveTabAction="
                                              defaultActiveTabAction
                                            "
                                            class="cat-comps"
                                            v-for="(chart,
                                            i) in filtered_barchart &&
                                              filtered_barchart.slice(0, 4)"
                                            ref="coreexp"
                                            :key="i"
                                            :title="chart.category"
                                            :value1="chart.peer_monthly"
                                            :value2="chart.user_monthly"
                                            :frequencyOptions="frequencyOptions"
                                            :changedValues="changedValues"
                                            :newValueMorgage="{
                                              val: mortgage_and_rent_input_value,
                                              freq: mortgage_and_rent_input_value_freq
                                            }"
                                            :newValueVahicle="{
                                              val: vehicle_purchase_and_lease_input_value,
                                              freq: vehicle_purchase_and_lease_input_value_freq
                                            }"
                                            :newValueDebt="{
                                              val: debt_input_value,
                                              freq: debt_input_value_freq
                                            }"
                                            :newValueSaving="{
                                              val: savings_input_value,
                                              freq: savings_input_value_freq
                                            }"
                                            :newValueHealth="{
                                              val: health_insurance_input_value,
                                              freq: health_insurance_input_value_freq
                                            }"
                                          /> -->
                                        </b-row>
                                      </div>
                                    </b-card>
                                  </b-collapse>
                                </div>
                              </b-card>
                            </div>
                          </div>
                        </b-card>
                        <b-card
                          class="no-border shadow-none new-frame-second-card mb-1 mb-lg-3"
                        >
                          <div class="new-accordin-frame new-accordin-frame">
                            <b-button
                              @click="
                                visibleCoreExpCat = false;
                                visiblePersComp = false;
                                visibleFutureExpCat = false;
                                visibleFutureExpCat = false;
                                visibleOtherExpCat = !visibleOtherExpCat;
                              "
                              block
                              :class="visibleOtherExpCat ? null : 'collapsed'"
                              variant="primary"
                            >
                              <div class="newcatgory-header">
                                <h5 class="newcatgory-title m-0">
                                  Past Choice
                                </h5>
                                <!-- <h5 class="newcatgory-num m-0 mr-3">5</h5> -->
                              </div>
                            </b-button>
                            <b-collapse
                              id="MonthlyBills"
                              v-model="visibleOtherExpCat"
                              class="mt-2"
                            >
                              <b-card
                                no-body
                                class="border-none shadow-none"
                                :class="{ 'd-none': !checkForNext1 }"
                              >
                                <template #title>
                                  <div
                                    class="d-flex justify-content-between align-items-center w-100"
                                  >
                                    <!-- <span>Common Monthly Bills </span> -->
                                    <!-- <span>Monthly Bills </span> -->
                                    <div class="hover-info-box d-none">
                                      <span class="hover-icon ml-2">
                                        <i
                                          class="far fa-question-circle text-light"
                                        ></i>
                                      </span>
                                      <div class="hover-info position-right">
                                        <p class="m-0 hover-info-text">
                                          Then you can customize expenses in
                                          these two sections to make your
                                          Results even more personalized
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </template>

                                <div
                                  class="budget-tables"
                                  :class="{ listview: !gridSecond }"
                                  ref="element"
                                >
                                  <div
                                    class="other-expense-accordion accordion-collapsed"
                                    role="tablist"
                                  >
                                    <b-card
                                      no-body
                                      class="border-none shadow-none mb-0"
                                    >
                                      <b-collapse
                                        id="other-expense-accordion-2"
                                        v-model="visibleOtherExpCat"
                                        accordion="other-expense-accordion"
                                        role="tabpanel"
                                      >
                                        <b-row class="mb-2">
                                          <b-col>
                                            <div class="legends py-2 mb-0">
                                              <!-- <p>
                                            <span
                                              class="commmon-circle predict"
                                            >
                                              <b-button
                                                size="sm"
                                                class="btn questionsize"
                                                v-b-popover.hover.top="
                                                  'Predicted by SPENDiD is our estimate of the amount required in order for the User to achieve the Predicted Saving Ability or Custom Amount to Savings (but not worse than break-even)'
                                                "
                                                variant="primary"
                                              >
                                                <i
                                                  class="
                                                    fas
                                                    fa-question
                                                    text-light
                                                  "
                                                ></i></b-button></span
                                            >Predicted
                                          </p> -->
                                              <div class="hover-info-box">
                                                <p
                                                  class="commmon-circle predict"
                                                >
                                                  <b-button
                                                    size="sm"
                                                    class="btn questionsize"
                                                    variant="primary"
                                                  >
                                                    <i
                                                      class="fas fa-question text-light"
                                                    ></i
                                                  ></b-button>
                                                  Predicted
                                                </p>
                                                <div
                                                  class="hover-info position-left"
                                                >
                                                  <p
                                                    class="m-0 hover-info-text"
                                                  >
                                                    Predicted by SPENDiD is our
                                                    estimate of the amount
                                                    required in order for the
                                                    User to achieve the
                                                    Predicted Saving Ability or
                                                    Custom Amount to Savings
                                                    (but not worse than
                                                    break-even)
                                                  </p>
                                                </div>
                                              </div>
                                              <p>
                                                <span class="input-btn"></span>
                                                input
                                              </p>
                                              <!-- <p>
                                            <span
                                              class="commmon-circle your-peers"
                                            >
                                              <b-button
                                                size="sm"
                                                class="btn questionsize"
                                                v-b-popover.hover.top="
                                                  'Peer amounts for each expense category are calculated by SPENDiD based on the user’s demographic profile information including income, zip code, age, etc…'
                                                "
                                                variant="primary"
                                              >
                                                <i
                                                  class="
                                                    fas
                                                    fa-question
                                                    text-light
                                                  "
                                                ></i></b-button></span
                                            >Peers
                                          </p> -->
                                              <div class="hover-info-box">
                                                <p
                                                  class="commmon-circle your-peers"
                                                >
                                                  <b-button
                                                    size="sm"
                                                    class="btn questionsize"
                                                    variant="primary"
                                                  >
                                                    <i
                                                      class="fas fa-question text-light"
                                                    ></i
                                                  ></b-button>
                                                  Peers
                                                </p>
                                                <div
                                                  class="hover-info position-left"
                                                >
                                                  <p
                                                    class="m-0 hover-info-text"
                                                  >
                                                    Peer amounts for each
                                                    expense category are
                                                    calculated by SPENDiD based
                                                    on the user’s demographic
                                                    profile information
                                                    including income, zip code,
                                                    age, etc…
                                                  </p>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="budget-tables-header">
                                              <b-row class="align-items-center">
                                                <b-col
                                                  xs="12"
                                                  md="12"
                                                  lg="12"
                                                  class="text-center expense"
                                                >
                                                  <h6
                                                    style="font-size: 14px"
                                                    class="font-weight-bold"
                                                  >
                                                    Click to Remove or Edit Any
                                                    Expense Category
                                                  </h6>
                                                  <div
                                                    class="cat-edit-disable d-flex align-items-center justify-content-md-end"
                                                  >
                                                    <!-- <div class="d-inline-block mr-2">
                                                            <i class="fas fa-info-circle"></i>
                                                        </div> -->
                                                    <div
                                                      class="w-100 text-center d-none d-md-block d-lg-block line-text"
                                                      style="font-size: 14px"
                                                    >
                                                      Remove
                                                      <span class="cross-icon">
                                                        <i
                                                          class="far fa-minus text-danger"
                                                          aria-hidden="true"
                                                        ></i
                                                      ></span>
                                                      or Edit
                                                      <i
                                                        class="fas fa-edit small"
                                                      ></i>
                                                    </div>
                                                  </div>
                                                </b-col>
                                              </b-row>
                                            </div>
                                          </b-col>
                                        </b-row>
                                        <b-row
                                          class="align-items-center mt-3 d-none"
                                        >
                                          <b-col md="12" lg="12" cols="12">
                                          </b-col>
                                          <!-- <b-col md="12" lg="4" cols="3" class="text-center text-md-right">
                                              <b-button @click="gridSecond=false" :variant="!gridSecond?'info':'dark'" class="mr-md-2 mb-2 mb-md-0">
                                                <i class="fas fa-list"></i>
                                              </b-button>
                                              <b-button @click="gridSecond=true" :variant="gridSecond?'info':'dark'" >
                                                <i class="fas fa-th"></i>
                                              </b-button>
                                          </b-col> -->
                                          <b-col xs="12" md="4" lg="4">
                                            <div
                                              class="cat-edit-disable d-flex align-itemas-center justify-content-md-end"
                                            >
                                              <!-- <div class="d-inline-block mr-2">
                                                  <i class="fas fa-info-circle"></i>
                                              </div> -->
                                              <div
                                                class="d-inline-block w-100 text-center d-block d-md-none d-lg-none m_white"
                                              >
                                                Remove
                                                <i
                                                  class="far fa-times-circle text-danger"
                                                  aria-hidden="true"
                                                ></i>
                                                or Edit
                                                <i
                                                  class="fas fa-edit small"
                                                ></i>
                                              </div>
                                            </div>
                                          </b-col>
                                        </b-row>
                                        <b-row
                                          class="mb-3 el-card"
                                          :class="{
                                            'd-none': !checkForValidate(),
                                          }"
                                        >
                                          <budgetComponent
                                            :zip="zip"
                                            :age="age"
                                            :defaultValues="changedValuesText"
                                            :grid="gridSecond"
                                            :showPeer="showPeer"
                                            :defaultActiveTab="defaultActiveTab"
                                            @defaultActiveTabAction="
                                              defaultActiveTabAction
                                            "
                                            @event="openModelEliminate"
                                            @changeValue="changeValue"
                                            class="cat-comps"
                                            v-for="chart in filtered_barchart &&
                                            filtered_barchart.filter(
                                              (item, i) =>
                                                i != 4 &&
                                                item.isActive &&
                                                common_monthly.includes(
                                                  item.category
                                                )
                                            )"
                                            :key="chart.category"
                                            :title="chart.category"
                                            :value1="chart.peer_monthly"
                                            :value2="chart.user_monthly"
                                            :frequencyOptions="frequencyOptions"
                                          />
                                        </b-row>

                                        <div
                                          class="eliminate-category-accordion accordion-collapsed mt-2"
                                          role="tablist"
                                        >
                                          <b-card
                                            no-body
                                            class="card-shadow border-none"
                                            style="
                                              max-width: 600px;
                                              margin: auto;
                                            "
                                          >
                                            <b-card-header
                                              header-tag="header"
                                              class="p-0"
                                              role="tab"
                                            >
                                              <b-button
                                                block
                                                @click="
                                                  visibleDisabledCat =
                                                    !visibleDisabledCat
                                                "
                                                :class="
                                                  visibleDisabledCat
                                                    ? null
                                                    : 'collapsed'
                                                "
                                                :aria-expanded="
                                                  visibleDisabledCat
                                                    ? 'true'
                                                    : 'false'
                                                "
                                                aria-controls="accordion-1"
                                              >
                                                Removed Categories
                                              </b-button>
                                            </b-card-header>
                                            <b-collapse
                                              id="accordion-1"
                                              v-model="visibleDisabledCat"
                                              accordion="eliminate-category-accordion"
                                              role="tabpanel"
                                            >
                                              <b-card-body
                                                class="px-0 w-100"
                                                :class="{ printbg: !isActive }"
                                              >
                                                <div
                                                  class="budget-tables w-100"
                                                  :class="{
                                                    listview: !gridThird,
                                                  }"
                                                >
                                                  <b-row
                                                    class="el-card"
                                                    :class="{
                                                      'd-none':
                                                        !checkForValidate(),
                                                    }"
                                                  >
                                                    <EliminateCategory
                                                      class="cat-comps"
                                                      @event="restoreEliminate"
                                                      v-for="(
                                                        chart, i
                                                      ) in filtered_barchart &&
                                                      filtered_barchart.filter(
                                                        (item, i) =>
                                                          i != 4 &&
                                                          !item.isActive &&
                                                          common_monthly.includes(
                                                            item.category
                                                          )
                                                      )"
                                                      :key="i"
                                                      :title="chart.category"
                                                      :value1="
                                                        chart.peer_monthly
                                                      "
                                                      :value2="
                                                        chart.user_monthly
                                                      "
                                                      :frequencyOptions="
                                                        frequencyOptions
                                                      "
                                                    />
                                                  </b-row>
                                                </div>
                                              </b-card-body>
                                            </b-collapse>
                                          </b-card>
                                        </div>
                                      </b-collapse>
                                    </b-card>
                                  </div>
                                </div>
                              </b-card>
                            </b-collapse>
                          </div>
                        </b-card>
                        <b-card
                          class="no-border shadow-none new-frame-second-card mb-1 mb-lg-3"
                        >
                          <div class="other-expenses new-accordin-frame">
                            <b-button
                              block
                              @click="
                                visibleCoreExpCat = false;
                                visibleOtherExpCat = false;
                                visibleFutureExpCat = false;
                                visiblePersComp = !visiblePersComp;
                              "
                              :class="visiblePersComp ? null : 'collapsed'"
                              :aria-expanded="
                                visiblePersComp ? 'true' : 'false'
                              "
                              variant="primary"
                            >
                              <div class="newcatgory-header">
                                <h5 class="newcatgory-title m-0">
                                  Present Choice
                                </h5>
                                <!-- <h5 class="newcatgory-num m-0 mr-3">5</h5> -->
                              </div>
                            </b-button>
                            <b-collapse v-model="visiblePersComp" class="mt-2">
                              <b-card
                                no-body
                                class="border-none shadow-none"
                                :class="{ 'd-none': !checkForNext1 }"
                              >
                                <template #title>
                                  <div
                                    class="d-flex justify-content-between align-items-center w-100"
                                  >
                                    <!-- <span>Food and Other Expenses </span> -->
                                    <span>Other Expenses </span>
                                    <div class="hover-info-box d-none">
                                      <span class="hover-icon ml-2">
                                        <i
                                          class="far fa-question-circle text-light"
                                        ></i>
                                      </span>
                                      <div class="hover-info position-right">
                                        <p class="m-0 hover-info-text">
                                          These are all remaining expense
                                          categories you can Edit or Remove if
                                          you want to get even mode detailed
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </template>

                                <div
                                  class="budget-tables"
                                  :class="{ listview: !gridSecond }"
                                  ref="element"
                                >
                                  <div
                                    class="other-expense-accordion accordion-collapsed"
                                    role="tablist"
                                  >
                                    <b-card
                                      no-body
                                      class="border-none shadow-none"
                                    >
                                      <b-row class="mb-2">
                                        <b-col>
                                          <div class="legends py-2 mb-0">
                                            <!-- <p>
                                            <span
                                              class="commmon-circle predict"
                                            >
                                              <b-button
                                                size="sm"
                                                class="btn questionsize"
                                                v-b-popover.hover.top="
                                                  'Predicted by SPENDiD is our estimate of the amount required in order for the User to achieve the Predicted Saving Ability or Custom Amount to Savings (but not worse than break-even)'
                                                "
                                                variant="primary"
                                              >
                                                <i
                                                  class="
                                                    fas
                                                    fa-question
                                                    text-light
                                                  "
                                                ></i></b-button></span
                                            >Predicted
                                          </p> -->
                                            <div class="hover-info-box">
                                              <p class="commmon-circle predict">
                                                <b-button
                                                  size="sm"
                                                  class="btn questionsize"
                                                  variant="primary"
                                                >
                                                  <i
                                                    class="fas fa-question text-light"
                                                  ></i
                                                ></b-button>
                                                Predicted
                                              </p>
                                              <div
                                                class="hover-info position-left"
                                              >
                                                <p class="m-0 hover-info-text">
                                                  Predicted by SPENDiD is our
                                                  estimate of the amount
                                                  required in order for the User
                                                  to achieve the Predicted
                                                  Saving Ability or Custom
                                                  Amount to Savings (but not
                                                  worse than break-even)
                                                </p>
                                              </div>
                                            </div>
                                            <p>
                                              <span class="input-btn"></span>
                                              input
                                            </p>
                                            <!-- <p>
                                            <span
                                              class="commmon-circle your-peers"
                                            >
                                              <b-button
                                                size="sm"
                                                class="btn questionsize"
                                                v-b-popover.hover.top="
                                                  'Peer amounts for each expense category are calculated by SPENDiD based on the user’s demographic profile information including income, zip code, age, etc…'
                                                "
                                                variant="primary"
                                              >
                                                <i
                                                  class="
                                                    fas
                                                    fa-question
                                                    text-light
                                                  "
                                                ></i></b-button></span
                                            >Peers
                                          </p> -->
                                            <div class="hover-info-box">
                                              <p
                                                class="commmon-circle your-peers"
                                              >
                                                <b-button
                                                  size="sm"
                                                  class="btn questionsize"
                                                  variant="primary"
                                                >
                                                  <i
                                                    class="fas fa-question text-light"
                                                  ></i
                                                ></b-button>
                                                Peers
                                              </p>
                                              <div
                                                class="hover-info position-left"
                                              >
                                                <p class="m-0 hover-info-text">
                                                  Peer amounts for each expense
                                                  category are calculated by
                                                  SPENDiD based on the user’s
                                                  demographic profile
                                                  information including income,
                                                  zip code, age, etc…
                                                </p>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="budget-tables-header">
                                            <b-row class="align-items-center">
                                              <b-col xs="12" md="12" lg="12">
                                                <div class="category-filter">
                                                  <div
                                                    class="d-flex m_fullwidth"
                                                  >
                                                    <div class="sortby">
                                                      <label for="sort_by"
                                                        >Sort By</label
                                                      >
                                                      <b-form-select
                                                        v-model="sortBy"
                                                      >
                                                        <b-form-select-option
                                                          value="category"
                                                        >
                                                          Category
                                                        </b-form-select-option>
                                                        <b-form-select-option
                                                          value="user_monthly"
                                                        >
                                                          Your Amount
                                                        </b-form-select-option>
                                                        <b-form-select-option
                                                          v-if="showPeer"
                                                          value="peer_monthly"
                                                        >
                                                          Your Peers
                                                        </b-form-select-option>
                                                        <b-form-select-option
                                                          value="difference"
                                                        >
                                                          Difference
                                                        </b-form-select-option>
                                                      </b-form-select>
                                                    </div>
                                                    <div class="orderby ml-2">
                                                      <label
                                                        for="order_by"
                                                        class="d-block"
                                                        >Order By</label
                                                      >
                                                      <div class="d-flex">
                                                        <b-button
                                                          @click="
                                                            changeFilter(true)
                                                          "
                                                          type="button"
                                                          class="mr-1"
                                                          :class="{
                                                            active: sortDefault,
                                                          }"
                                                          title="Ascending"
                                                        >
                                                          <i
                                                            class="fas fa-sort-alpha-up"
                                                          ></i>
                                                        </b-button>
                                                        <b-button
                                                          @click="
                                                            changeFilter(false)
                                                          "
                                                          type="button"
                                                          class="mr-1"
                                                          :class="{
                                                            active:
                                                              sortDefault ===
                                                              false,
                                                          }"
                                                          title="Descending "
                                                        >
                                                          <i
                                                            class="fas fa-sort-alpha-down-alt"
                                                          ></i>
                                                        </b-button>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </b-col>
                                              <b-col
                                                xs="12"
                                                md="12"
                                                lg="12"
                                                class="text-center expense mt-2 d-none"
                                              >
                                                <h6
                                                  style="font-size: 14px"
                                                  class="font-weight-bold"
                                                >
                                                  Click to Remove or Edit Any
                                                  Expense Category
                                                </h6>
                                                <div
                                                  class="cat-edit-disable d-flex align-items-center justify-content-md-end"
                                                >
                                                  <!-- <div class="d-inline-block mr-2">
                                                            <i class="fas fa-info-circle"></i>
                                                        </div> -->
                                                  <div
                                                    class="w-100 text-center d-none line-text"
                                                    style="font-size: 14px"
                                                  >
                                                    Remove
                                                    <span class="cross-icon">
                                                      <i
                                                        class="far fa-times text-danger"
                                                        aria-hidden="true"
                                                      ></i
                                                    ></span>
                                                    or Edit
                                                    <i
                                                      class="fas fa-edit small"
                                                    ></i>
                                                  </div>
                                                </div>
                                              </b-col>
                                            </b-row>
                                          </div>
                                        </b-col>
                                      </b-row>
                                      <b-row class="align-items-center d-none">
                                        <b-col
                                          md="12"
                                          lg="12"
                                          sm="12"
                                          cols="12"
                                          class="text-center mb-3 order-filter"
                                        >
                                          <b-button
                                            @click="gridSecond = false"
                                            :variant="
                                              !gridSecond ? 'info' : 'dark'
                                            "
                                            class="mr-md-2 mb-2 mb-md-0"
                                          >
                                            <i class="fas fa-list"></i>
                                          </b-button>
                                          <b-button
                                            @click="gridSecond = true"
                                            :variant="
                                              gridSecond ? 'info' : 'dark'
                                            "
                                          >
                                            <i class="fas fa-th"></i>
                                          </b-button>
                                        </b-col>
                                        <b-col xs="12" md="4" lg="4">
                                          <div
                                            class="cat-edit-disable d-flex align-itemas-center justify-content-md-end"
                                          >
                                            <!-- <div class="d-inline-block mr-2">
                                                  <i class="fas fa-info-circle"></i>
                                              </div> -->
                                            <div
                                              class="d-inline-block w-100 text-center d-block d-md-none d-lg-none m_white"
                                            >
                                              Remove
                                              <i
                                                class="far fa-times-circle text-danger"
                                                aria-hidden="true"
                                              ></i>
                                              or Edit
                                              <i class="fas fa-edit small"></i>
                                            </div>
                                          </div>
                                        </b-col>
                                      </b-row>
                                      <b-row
                                        class="el-card"
                                        :class="{
                                          'd-none': !checkForValidate(),
                                        }"
                                      >
                                        <budgetComponent
                                          :zip="zip"
                                          :age="age"
                                          :defaultValues="changedValuesText"
                                          :grid="gridSecond"
                                          :showPeer="showPeer"
                                          @event="openModelEliminate"
                                          @changeValue="changeValue"
                                          :defaultActiveTab="defaultActiveTab"
                                          @defaultActiveTabAction="
                                            defaultActiveTabAction
                                          "
                                          class="cat-comps"
                                          v-for="chart in filtered_barchart &&
                                          filtered_barchart.filter(
                                            (item, i) =>
                                              i != 4 &&
                                              item.isActive &&
                                              !common_monthly.includes(
                                                item.category
                                              ) &&
                                              !common_monthly_2.includes(
                                                item.category
                                              )
                                          )"
                                          :key="chart.category"
                                          :title="chart.category"
                                          :value1="chart.peer_monthly"
                                          :value2="chart.user_monthly"
                                          :frequencyOptions="frequencyOptions"
                                        />
                                      </b-row>
                                      <div
                                        class="eliminate-category-accordiona accordion-collapsed mt-2 mb-3"
                                        role="tablist"
                                      >
                                        <b-card
                                          no-body
                                          class="card-shadow border-none"
                                          style="max-width: 600px; margin: auto"
                                        >
                                          <b-card-header
                                            header-tag="header"
                                            class="p-0"
                                            role="tab"
                                          >
                                            <b-button
                                              block
                                              @click="
                                                visibleDisabledCat =
                                                  !visibleDisabledCat
                                              "
                                              :class="
                                                visibleDisabledCat
                                                  ? null
                                                  : 'collapsed'
                                              "
                                              :aria-expanded="
                                                visibleDisabledCat
                                                  ? 'true'
                                                  : 'false'
                                              "
                                              aria-controls="accordion-rm"
                                            >
                                              Removed Categories
                                            </b-button>
                                          </b-card-header>
                                          <b-collapse
                                            id="accordion-rm"
                                            v-model="visibleDisabledCat"
                                            accordion="eliminate-category-accordiona"
                                            role="tabpanel"
                                          >
                                            <b-card-body
                                              class="px-0 w-100"
                                              :class="{ printbg: !isActive }"
                                            >
                                              <div
                                                class="budget-tables w-100"
                                                :class="{
                                                  listview: !gridThird,
                                                }"
                                              >
                                                <b-row
                                                  class="el-card"
                                                  :class="{
                                                    'd-none':
                                                      !checkForValidate(),
                                                  }"
                                                >
                                                  <EliminateCategory
                                                    class="cat-comps"
                                                    @event="restoreEliminate"
                                                    v-for="(
                                                      chart, i
                                                    ) in filtered_barchart &&
                                                    filtered_barchart.filter(
                                                      (item, i) =>
                                                        i != 4 &&
                                                        !item.isActive &&
                                                        !common_monthly.includes(
                                                          item.category
                                                        ) &&
                                                        !common_monthly_2.includes(
                                                          item.category
                                                        )
                                                    )"
                                                    :key="i"
                                                    :title="chart.category"
                                                    :value1="chart.peer_monthly"
                                                    :value2="chart.user_monthly"
                                                    :frequencyOptions="
                                                      frequencyOptions
                                                    "
                                                  />
                                                </b-row>
                                              </div>
                                            </b-card-body>
                                          </b-collapse>
                                        </b-card>
                                      </div>
                                    </b-card>
                                  </div>
                                </div>
                              </b-card>
                            </b-collapse>
                          </div>
                        </b-card>
                        <b-card
                          class="no-border shadow-none new-frame-second-card mb-1 mb-lg-3"
                        >
                          <div class="other-expenses new-accordin-frame">
                            <b-button
                              block
                              @click="
                                visibleCoreExpCat = false;
                                visibleOtherExpCat = false;
                                visiblePersComp = false;
                                visibleFutureExpCat = !visibleFutureExpCat;
                              "
                              :class="visibleFutureExpCat ? null : 'collapsed'"
                              :aria-expanded="
                                visibleFutureExpCat ? 'true' : 'false'
                              "
                              variant="primary"
                            >
                              <div class="newcatgory-header">
                                <h5 class="newcatgory-title m-0">
                                  Future Choice
                                </h5>
                                <!-- <h5 class="newcatgory-num m-0 mr-3">5</h5> -->
                              </div>
                            </b-button>
                            <b-collapse
                              v-model="visibleFutureExpCat"
                              class="mt-2"
                            >
                              <b-card
                                no-body
                                class="border-none shadow-none"
                                :class="{ 'd-none': !checkForNext1 }"
                              >
                                <template #title>
                                  <div
                                    class="d-flex justify-content-between align-items-center w-100"
                                  >
                                    <!-- <span>Food and Other Expenses </span> -->
                                    <span>Other Expenses </span>
                                    <div class="hover-info-box d-none">
                                      <span class="hover-icon ml-2">
                                        <i
                                          class="far fa-question-circle text-light"
                                        ></i>
                                      </span>
                                      <div class="hover-info position-right">
                                        <p class="m-0 hover-info-text">
                                          These are all remaining expense
                                          categories you can Edit or Remove if
                                          you want to get even mode detailed
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </template>

                                <div
                                  class="budget-tables"
                                  :class="{ listview: !gridSecond }"
                                  ref="element"
                                >
                                  <div
                                    class="other-expense-accordion accordion-collapsed"
                                    role="tablist"
                                  >
                                    <b-card
                                      no-body
                                      class="border-none shadow-none"
                                    >
                                      <b-row class="mb-2">
                                        <b-col>
                                          <div class="legends py-2 mb-0">
                                            <!-- <p>
                                            <span
                                              class="commmon-circle predict"
                                            >
                                              <b-button
                                                size="sm"
                                                class="btn questionsize"
                                                v-b-popover.hover.top="
                                                  'Predicted by SPENDiD is our estimate of the amount required in order for the User to achieve the Predicted Saving Ability or Custom Amount to Savings (but not worse than break-even)'
                                                "
                                                variant="primary"
                                              >
                                                <i
                                                  class="
                                                    fas
                                                    fa-question
                                                    text-light
                                                  "
                                                ></i></b-button></span
                                            >Predicted
                                          </p> -->
                                            <div class="hover-info-box">
                                              <p class="commmon-circle predict">
                                                <b-button
                                                  size="sm"
                                                  class="btn questionsize"
                                                  variant="primary"
                                                >
                                                  <i
                                                    class="fas fa-question text-light"
                                                  ></i
                                                ></b-button>
                                                Predicted
                                              </p>
                                              <div
                                                class="hover-info position-left"
                                              >
                                                <p class="m-0 hover-info-text">
                                                  Predicted by SPENDiD is our
                                                  estimate of the amount
                                                  required in order for the User
                                                  to achieve the Predicted
                                                  Saving Ability or Custom
                                                  Amount to Savings (but not
                                                  worse than break-even)
                                                </p>
                                              </div>
                                            </div>
                                            <!-- <p>
                                              <span class="input-btn"></span>
                                              input
                                            </p> -->
                                            <!-- <p>
                                            <span
                                              class="commmon-circle your-peers"
                                            >
                                              <b-button
                                                size="sm"
                                                class="btn questionsize"
                                                v-b-popover.hover.top="
                                                  'Peer amounts for each expense category are calculated by SPENDiD based on the user’s demographic profile information including income, zip code, age, etc…'
                                                "
                                                variant="primary"
                                              >
                                                <i
                                                  class="
                                                    fas
                                                    fa-question
                                                    text-light
                                                  "
                                                ></i></b-button></span
                                            >Peers
                                          </p> -->
                                            <div class="hover-info-box">
                                              <p
                                                class="commmon-circle your-peers"
                                              >
                                                <b-button
                                                  size="sm"
                                                  class="btn questionsize"
                                                  variant="primary"
                                                >
                                                  <i
                                                    class="fas fa-question text-light"
                                                  ></i
                                                ></b-button>
                                                Peers
                                              </p>
                                              <div
                                                class="hover-info position-left"
                                              >
                                                <p class="m-0 hover-info-text">
                                                  Peer amounts for each expense
                                                  category are calculated by
                                                  SPENDiD based on the user’s
                                                  demographic profile
                                                  information including income,
                                                  zip code, age, etc…
                                                </p>
                                              </div>
                                            </div>
                                          </div>
                                        </b-col>
                                      </b-row>
                                      <b-row class="align-items-center d-none">
                                        <b-col
                                          md="12"
                                          lg="12"
                                          sm="12"
                                          cols="12"
                                          class="text-center mb-3 order-filter"
                                        >
                                          <b-button
                                            @click="gridSecond = false"
                                            :variant="
                                              !gridSecond ? 'info' : 'dark'
                                            "
                                            class="mr-md-2 mb-2 mb-md-0"
                                          >
                                            <i class="fas fa-list"></i>
                                          </b-button>
                                          <b-button
                                            @click="gridSecond = true"
                                            :variant="
                                              gridSecond ? 'info' : 'dark'
                                            "
                                          >
                                            <i class="fas fa-th"></i>
                                          </b-button>
                                        </b-col>
                                        <b-col xs="12" md="4" lg="4">
                                          <div
                                            class="cat-edit-disable d-flex align-itemas-center justify-content-md-end"
                                          >
                                            <!-- <div class="d-inline-block mr-2">
                                                  <i class="fas fa-info-circle"></i>
                                              </div> -->
                                            <div
                                              class="d-inline-block w-100 text-center d-block d-md-none d-lg-none m_white"
                                            >
                                              Remove
                                              <i
                                                class="far fa-times-circle text-danger"
                                                aria-hidden="true"
                                              ></i>
                                              or Edit
                                              <i class="fas fa-edit small"></i>
                                            </div>
                                          </div>
                                        </b-col>
                                      </b-row>
                                      <b-row
                                        class="el-card"
                                        :class="{
                                          'd-none': !checkForValidate(),
                                        }"
                                      >
                                        <budgetComponent
                                          :zip="zip"
                                          :age="age"
                                          :crossDisable="true"
                                          :closeEdit="true"
                                          :defaultValues="changedValuesText"
                                          :grid="gridSecond"
                                          :showPeer="showPeer"
                                          @event="openModelEliminate"
                                          @changeValue="changeValue"
                                          :defaultActiveTab="defaultActiveTab"
                                          @defaultActiveTabAction="
                                            defaultActiveTabAction
                                          "
                                          class="cat-comps"
                                          v-for="chart in filtered_barchart &&
                                          filtered_barchart.filter(
                                            (item, i) => i == 4
                                          )"
                                          :key="chart.category"
                                          :title="chart.category"
                                          :value1="chart.peer_monthly"
                                          :value2="chart.user_monthly"
                                          :frequencyOptions="frequencyOptions"
                                        />
                                      </b-row>
                                    </b-card>
                                  </div>
                                </div>
                              </b-card>
                            </b-collapse>
                          </div>
                        </b-card>
                      </b-col>
                      <b-col sm="12" lg="12" xl="6">
                        <b-card
                          class="no-border new-frame-second-card mb-1 mb-lg-3"
                        >
                          <!-- <div class="newframe-card-title px-0">
                                <h4>MyBudgetReport</h4>
                               </div> -->
                          <b-row>
                            <!-- two-times-result-display -->
                            <b-col sm="12" xl="12" id="result-flow-score">
                              <div class="spacediv mb-4">
                                <b-row
                                  class="mt-0"
                                  id="your-result-flow "
                                  ref="element"
                                >
                                  <b-col sm="12" xl="12">
                                    <div class="title-result mb-2">
                                      <!-- <span class=""></span> -->
                                      Your Results
                                    </div>
                                  </b-col>
                                </b-row>
                                <b-row :class="{ 'd-none': !checkForNext1 }">
                                  <b-col lg="4">
                                    <b-card
                                      no-body
                                      class="min-height-100 new-frame-card-inner p-1"
                                    >
                                      <b-card-header
                                        header-tag="header"
                                        class="border-none shadow-none p-0"
                                        role="tab"
                                      >
                                        <b-button
                                          block
                                          placeholder="Enter a value"
                                          class="font-md budgetblock d-flex align-items-center justify-content-between"
                                        >
                                          <span> Money Vehicle Plan Grade</span>
                                          <div class="hover-info-box">
                                            <span class="hover-icon ml-2">
                                              <i
                                                class="far fa-question-circle"
                                              ></i>
                                            </span>
                                            <div
                                              class="hover-info position-left"
                                            >
                                              <p class="m-0 hover-info-text">
                                                This is a simple 'grade' of your
                                                budget. You want an 80(B) or
                                                higher to consistently be able
                                                to grow savings or reduce debt
                                              </p>
                                            </div>
                                          </div>
                                          <!-- <span class="d-block popstyle">
                                <b-button
                                  size="sm"
                                  class="btn questionsize"
                                  v-b-popover.hover.right="
                                    'This is a simple \'grade\' of your budget. You want an 80(B) or higher to consistently be able to grow savings or reduce debt'
                                  "
                                  variant="primary"
                                >
                                  <i
                                    class="far fa-question-circle"
                                  ></i>
                                </b-button>
                              </span> -->
                                          <!-- <span class="helps-text">This helps us define your Peers</span> -->
                                        </b-button>
                                      </b-card-header>
                                      <b-card-text class="">
                                        <div
                                          class="score-info text-center big-font"
                                        >
                                          <h4
                                            class="font-weight-bold"
                                            :class="{
                                              'text-small':
                                                returnDefaultTextOnly()
                                                  .descriptiveText === '',
                                            }"
                                          >
                                            {{
                                              returnDefaultTextOnly().mainText
                                            }}
                                          </h4>
                                        </div>
                                        <div
                                          class="text-center w-100"
                                          :class="{
                                            printbg: !isActive,
                                            'd-none': !scores_ready,
                                          }"
                                        >
                                          <div id="speedometer"></div>
                                          <p class="returnScore">
                                            {{ returnScore }}
                                          </p>
                                          <div class="grade-score-info mt-3">
                                            <div class="hover-info-box">
                                              <span class="hover-icon ml-2">
                                                <i
                                                  class="far fa-info-circle teal-color"
                                                ></i>
                                              </span>
                                              <div
                                                class="hover-info position-left"
                                              >
                                                <p class="m-0 hover-info-text">
                                                  {{
                                                    returnDefaultTextOnly()
                                                      .descriptiveText
                                                  }}
                                                </p>
                                              </div>
                                            </div>
                                          </div>
                                          <p>
                                            <b
                                              >Peer's Score =
                                              {{ returnScoreLending }}</b
                                            >
                                          </p>
                                        </div>
                                        <p
                                          class="title is-4 mb-0 abst"
                                          v-if="!scores_ready"
                                        >
                                          <i class="fas fa-cog fa-spin"></i>
                                        </p>
                                      </b-card-text>
                                    </b-card>
                                  </b-col>

                                  <b-col lg="4">
                                    <b-card
                                      no-body
                                      class="min-height-100 new-frame-card-inner"
                                    >
                                      <b-card-header
                                        header-tag="header"
                                        class="border-none shadow-none p-0 m-1"
                                        role="tab"
                                      >
                                        <b-button
                                          block
                                          placeholder="Enter a value"
                                          class="font-md budgetblock d-flex align-items-center justify-content-between"
                                        >
                                          <span>Your Monthly Future Choice</span>
                                          <div class="hover-info-box">
                                            <span class="hover-icon ml-2">
                                              <i
                                                class="far fa-question-circle"
                                              ></i>
                                            </span>
                                            <div
                                              class="hover-info position-right"
                                            >
                                              <p class="m-0 hover-info-text">
                                                SPENDiD's estimate of the
                                                average monthly amount you
                                                likely can save or use to reduce
                                                debt
                                              </p>
                                            </div>
                                          </div>
                                          <!-- <span class="d-block popstyle">
                                <b-button
                                  size="sm"
                                  class="btn questionsize"
                                  v-b-popover.hover.right="
                                    'SPENDiD\'s estimate of the average monthly amount you likely can save or use to reduce debt'
                                  "
                                  variant="primary"
                                >
                                  <i
                                    class="far fa-question-circle"
                                  ></i>
                                </b-button>
                              </span>-->
                                          <!-- <span class="helps-text">This helps us define your Peers</span> -->
                                        </b-button>
                                      </b-card-header>
                                      <b-card-text class="p-1 result-speedo">
                                        <div class="mt-0">
                                          <div
                                            class="score-title d-flex align-items-center mb-3"
                                          >
                                            <h5 class="m-0 psa-text">You</h5>
                                          </div>
                                          <div
                                            class="score-number mt-0 mt-md-0 py-1 px-2"
                                            v-bind:class="
                                              breakeven_grade_css_classes
                                            "
                                          >
                                            <p
                                              class="title is-4 mb-0"
                                              v-if="!scores_ready"
                                            >
                                              <i class="fas fa-cog fa-spin"></i>
                                            </p>
                                            <div class="spending-score" v-else>
                                              <span class="ml-1">
                                                {{
                                                  lending_score_cash_excess_formatted
                                                }}
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="mt-3">
                                          <div
                                            class="score-title d-flex align-items-center mb-3"
                                          >
                                            <h5 class="m-0 psa-text">Peers</h5>
                                          </div>
                                          <div
                                            class="score-number mt-0 mt-md-0 py-1 px-2"
                                            v-bind:class="
                                              saving_peer_amount_css_classes
                                            "
                                          >
                                            <p
                                              class="title is-4 mb-0"
                                              v-if="!scores_ready"
                                            >
                                              <i class="fas fa-cog fa-spin"></i>
                                            </p>
                                            <div class="spending-score" v-else>
                                              <span class="ml-1">
                                                {{ saving_peer_amount }}
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="text-center mt-3 mt-lg-5">
                                          <b-button
                                            v-if="isActive && age <= 60"
                                            @click="openProjectedGrowth()"
                                            size="sm"
                                            class="btn report-btn mt-4"
                                          >
                                            <span class="d-block"
                                              >USE-ing the</span
                                            >
                                            <span class="d-block"
                                              >8th Wonder</span
                                            >
                                          </b-button>
                                        </div>
                                        <!-- 
                            <div class="mt-3">
                              <div
                                class="
                                  score-title
                                  d-flex
                                  align-items-center
                                  mb-3
                                "
                              >
                                <h5 class="m-0 psa-text text-center">
                                  Enter a Monthly Amount to Save
                                </h5>
                              </div>
                              <div>
                                <NumberInput
                                  :model="savings_input_value"
                                  @changeValue="numberValueChange"
                                  title=""
                                  name="savings_input_value"
                                  class="spend-custominput"
                                  v-if="savings_input_value"
                                />
                                <NumberInput
                                  :model="savings_input_value"
                                  @changeValue="numberValueChange"
                                  title=""
                                  name="savings_input_value"
                                  class="spend-valid"
                                  v-else
                                />
                              </div>
                              <div class="text-center">
                                <b-button
                                  @click="savings_input_value = null"
                                  class="btn mt-3"
                                  variant="secondary"
                                  size="sm"
                                >
                                  Clear
                                </b-button>
                              </div>
                            </div> -->
                                      </b-card-text>
                                    </b-card>
                                  </b-col>

                                  <b-col lg="4">
                                    <b-card
                                      no-body
                                      class="min-height-100 new-frame-card-inner"
                                    >
                                      <b-card-header
                                        header-tag="header"
                                        class="border-none shadow-none p-0 m-1"
                                        role="tab"
                                      >
                                        <b-button
                                          block
                                          placeholder="Enter a value"
                                          class="font-md budgetblock d-flex align-items-center justify-content-between"
                                        >
                                          <span>Money Bucket Choices</span>
                                          <div class="hover-info-box">
                                            <span class="hover-icon ml-2">
                                              <i
                                                class="far fa-question-circle"
                                              ></i>
                                            </span>
                                            <div
                                              class="hover-info position-right"
                                            >
                                              <p class="m-0 hover-info-text">
                                                Pie chart breakdown of your
                                                categorized budget
                                              </p>
                                            </div>
                                          </div>
                                          <!-- <span class="d-block popstyle">
                                <b-button
                                  size="sm"
                                  class="btn questionsize"
                                  v-b-popover.hover.left="
                                    'Pie chart breakdown of your categorized budget '
                                  "
                                  variant="primary"
                                >
                                  <i
                                    class="far fa-question-circle"
                                  ></i>
                                </b-button>
                              </span> -->
                                          <!-- <span class="helps-text">This helps us define your Peers</span> -->
                                        </b-button>
                                      </b-card-header>
                                      <b-card-text class="p-1">
                                        <div
                                          class="chart-box d-block text-center w-100"
                                          :class="{ printbg: !isActive }"
                                        >
                                          <div class="w-100 text-center">
                                            <div
                                              id="piechart"
                                              ref="piechart"
                                            ></div>
                                            <!-- <b-row class="text-center mt-4">
                                  <b-col xs="12" sm="4" lg="12" class="text-center piechart-btns">
                                        <template v-if="!api_updates_pending">
                                          <span class="d-inline-block" v-b-tooltip.bottom title="You can even download a .pdf copy of your Results Report and fully categorized budget">
                                            <b-button v-if="isActive" @click="downloadWithCSS(true)" size="sm" class="btn btn-theme report-btn">
                                              Download Report
                                            </b-button>
                                          </span>
                                          <span class="mt-2 d-inline-block" v-b-tooltip.bottom title="You can even email a .pdf copy of your Results Report and fully categorized budget">
                                            <b-button v-if="isActive" @click="emailDownloadWithCss()" size="sm" class="btn btn-theme report-btn">
                                              Email Report
                                            </b-button>
                                          </span>
                                        </template>
                                        <template v-else>
                                            <h3 class="text-center">Please wait...</h3>
                                        </template>
                                      </b-col>
                                </b-row> -->
                                          </div>
                                        </div>
                                        <div class="text-center mt-3">
                                          <b-button
                                            v-if="isActive"
                                            @click="saveReport(false)"
                                            size="sm"
                                            class="btn report-btn visible-md mt-3"
                                          >
                                            <span class="d-block"
                                              >Export Money
                                            </span>
                                            <span class="d-block"
                                              >Vehicle Plan</span
                                            >
                                          </b-button>
                                          <b-button
                                            v-if="isActive"
                                            @click="emailDownloadWithCss()"
                                            size="sm"
                                            class="btn report-btn hidden-md mt-3"
                                          >
                                            <span class="d-block"
                                              >Export Money
                                            </span>
                                            <span class="d-block"
                                              >Vehicle Plan</span
                                            >
                                          </b-button>
                                        </div>
                                      </b-card-text>
                                    </b-card>
                                  </b-col>
                                </b-row>
                              </div>
                            </b-col>
                            <!-- end-resutls -->
                          </b-row>

                          <div id="cash-flow-score">
                            <b-row ref="second_sec" class="">
                              <b-col sm="12" xl="12">
                                <div
                                  class="cash-flow-health-accordion w-100"
                                  :class="{ printbg: !isActive }"
                                  role="tablist"
                                >
                                  <div
                                    no-body
                                    class="border-none card-shadow mb-3 w-100 spendid-removebg"
                                    :class="{ printbg: !isActive }"
                                  >
                                    <!-- <b-card-header header-tag="header" class="border-none shadow-none p-0 spendid-removebg" role="tab" :class="{'displaynone':!isActive}">
                      <b-button 
                        block
                        :disabled="(!checkForValidate() || debt_value===null || !(debt_value >= 0) || vehicle_purchase_and_lease_value===null || !(vehicle_purchase_and_lease_value>=0) || mortgage_and_rent_value===null || !(mortgage_and_rent_value>=0))"
                        @click="checkResultToggle()" 
                        :class="visibleCashHealthAnalysis ? null : 'collapsed'"
                        :aria-expanded="visibleCashHealthAnalysis ? 'true' : 'false'"
                        aria-controls="cash-flow-health"
                        class="font-lg box text-center collpase-center spendid-accord-button"
                        >
                       <//disable when uncommnet <span class="ht-number">4</span> //>
                        <p style="color:#fff">See Results</p>
                        <span class="absolute_peer">Your Results</span>
                      </b-button>
                    </b-card-header> -->
                                    <b-collapse
                                      id="cash-flow-health"
                                      class="spendid-whitbg"
                                      :class="{ 'd-none': !checkForNext1 }"
                                      v-model="visibleCashHealthAnalysis"
                                      accordion="cash-flow-health-accordion"
                                      role="tabpanel"
                                    >
                                      <div no-body class="w-100">
                                        <b-row class="mb-4">
                                          <b-col sm="12" xl="12">
                                            <div class="title-result mb-2">
                                              <!-- <span class=""></span> -->
                                              Your Opportunities
                                            </div>
                                            <div
                                              class="peer-chart-accordion accordion-collapsed h-100"
                                              :class="{ 'd-none': !showPeer }"
                                              role="tablist"
                                            >
                                              <b-card
                                                no-body
                                                class="w-100 new-frame-card-inner"
                                                :class="{ printbg: !isActive }"
                                              >
                                                <b-card-header
                                                  header-tag="header"
                                                  class="border-none shadow-none p-0 m-1"
                                                  role="tab"
                                                >
                                                  <b-button
                                                    block
                                                    variant="light"
                                                    class="green-bar cursor-auto text-capitalize"
                                                    ><span class="d-block"
                                                      >Categories Where Your
                                                      Amount is Higher Than
                                                      Peers</span
                                                    >
                                                    <h4
                                                      class="chrdhead d-block"
                                                    >
                                                      <!-- Where Your Amount > Peers -->
                                                      Click on Bars Below to
                                                      Confirm or Get Ideas
                                                    </h4>
                                                    <!-- <span class="d-inline-block d-md-none"
                                        >Focus Areas</span
                                      >-->
                                                  </b-button>
                                                </b-card-header>
                                                <b-card-body
                                                  class="w-100 p-1"
                                                  :class="{
                                                    printbg: !isActive,
                                                  }"
                                                >
                                                  <!-- <b-row>
                                                    <b-col md="8" offset-md="2">
                                                      <div
                                                        class="text-center mb-3 w-100"
                                                        :class="{
                                                          printbg: !isActive
                                                        }"
                                                      >
                                                        <h6 class="font-italic">Click on Bars Below to Confirm or Ideas</h6>
                                                      </div>
                                                    </b-col>
                                                  </b-row> -->
                                                  <b-row
                                                    :class="{
                                                      'd-none': !hideBarChart,
                                                    }"
                                                  >
                                                    <b-col md="12">
                                                      <div class="no-peers">
                                                        <h3>
                                                          There are no User
                                                          expense amounts input
                                                          higher than Peers
                                                        </h3>
                                                      </div>
                                                    </b-col>
                                                  </b-row>
                                                  <b-row
                                                    :class="{
                                                      'd-none': hideBarChart,
                                                    }"
                                                  >
                                                    <b-col>
                                                      <!-- Chart Box Area Start -->
                                                      <div
                                                        class="chart-box d-block text-center w-100"
                                                        :class="{
                                                          printbg: !isActive,
                                                        }"
                                                      >
                                                        <div
                                                          class="w-100 text-center w-100"
                                                          :class="{
                                                            printbg: !isActive,
                                                          }"
                                                        >
                                                          <div
                                                            id="barchart"
                                                            ref="barchart"
                                                            class="rm-chart-watermark"
                                                          ></div>
                                                          <!-- <div id="piechart2" ref="piechart2"></div> -->
                                                        </div>
                                                      </div>
                                                      <!-- Chart Box Area End -->
                                                    </b-col>
                                                  </b-row>
                                                </b-card-body>
                                              </b-card>
                                            </div>
                                          </b-col>
                                        </b-row>
                                        <b-row class="mt-3">
                                          <b-col sm="12" xl="12">
                                            <div
                                              class="modal-piechart-accordion accordion-collapsed"
                                              role="tablist"
                                            >
                                              <div
                                                class="border-none w-100"
                                                :class="{ printbg: !isActive }"
                                              >
                                                <b-card-header
                                                  header-tag="header"
                                                  class="border-none shadow-none p-0 w-100 budget_model d-flex mb-4 mb_none"
                                                  role="tab"
                                                  :class="{
                                                    printbg: !isActive,
                                                  }"
                                                >
                                                  <div class="title-result">
                                                    <!-- <span class=""></span> -->
                                                    <div
                                                      class="d-flex justify-content-between"
                                                    >
                                                      <span
                                                        >Your Money Buckets
                                                      </span>

                                                      <!-- <div
                                                        class="hover-info-box"
                                                      >
                                                        <span
                                                          class="hover-icon ml-2"
                                                        >
                                                          <i
                                                            class="fas fa-question teal-color"
                                                          ></i>
                                                        </span>
                                                        <div
                                                          class="hover-info position-right"
                                                        >
                                                          <h5
                                                            class="hover-info-title"
                                                          >
                                                            What is 50-30-20
                                                            Budget Modeling?
                                                          </h5>
                                                          <h5
                                                            class="hover-info-subtitle"
                                                          >
                                                            Here’s a quick
                                                            breakdown of how a
                                                            few common expenses
                                                            are divided among
                                                            three major
                                                            categories.
                                                          </h5>

                                                          <p class="mb-1">
                                                            <b
                                                              >50% Toward
                                                              Needs</b
                                                            >
                                                          </p>
                                                          <h5
                                                            class="hover-info-subtitle"
                                                          >
                                                            This approach states
                                                            that you should
                                                            budget 50% of your
                                                            take-home income on
                                                            necessary items,
                                                            such as housing,
                                                            transportation, and
                                                            other bills.
                                                          </h5>
                                                          <h5
                                                            class="hover-info-subtitle mb-2"
                                                          >
                                                            The items in this
                                                            category cover the
                                                            basics of life. Here
                                                            are the most common
                                                            “needs” included:
                                                          </h5>

                                                          <ul class="innerlist">
                                                            <li>
                                                              <h5
                                                                class="hover-info-subtitle"
                                                              >
                                                                <b>Housing.</b>
                                                              </h5>
                                                            </li>
                                                            <li>
                                                              <h5
                                                                class="hover-info-subtitle"
                                                              >
                                                                <b
                                                                  >Transportation,</b
                                                                >
                                                                including car
                                                                payments and
                                                                gas.
                                                              </h5>
                                                            </li>
                                                            <li>
                                                              <h5
                                                                class="hover-info-subtitle"
                                                              >
                                                                <b
                                                                  >Utilities,</b
                                                                >
                                                                like your cell
                                                                phone, heat,
                                                                water, gas and
                                                                trash.
                                                              </h5>
                                                            </li>
                                                            <li>
                                                              <h5
                                                                class="hover-info-subtitle"
                                                              >
                                                                <b>Groceries </b
                                                                >(but not eating
                                                                out in
                                                                restaurants).
                                                              </h5>
                                                            </li>
                                                            <li>
                                                              <h5
                                                                class="hover-info-subtitle"
                                                              >
                                                                <b
                                                                  >Insurance
                                                                  premiums,</b
                                                                >
                                                                such as life
                                                                insurance,
                                                                health insurance
                                                                and auto
                                                                insurance.
                                                              </h5>
                                                            </li>
                                                            <li>
                                                              <h5
                                                                class="hover-info-subtitle"
                                                              >
                                                                <b
                                                                  >Medical
                                                                  bills.</b
                                                                >
                                                              </h5>
                                                            </li>
                                                            <li>
                                                              <h5
                                                                class="hover-info-subtitle"
                                                              >
                                                                <b
                                                                  >Childcare.</b
                                                                >
                                                              </h5>
                                                            </li>
                                                            <li>
                                                              <h5
                                                                class="hover-info-subtitle"
                                                              >
                                                                <b
                                                                  >Basic
                                                                  clothing.</b
                                                                >
                                                              </h5>
                                                            </li>
                                                            <li>
                                                              <h5
                                                                class="hover-info-subtitle"
                                                              >
                                                                <b
                                                                  >Minimum
                                                                  payments</b
                                                                >
                                                                on your debt,
                                                                such as credit
                                                                cards, student
                                                                loans, etc.
                                                              </h5>
                                                            </li>
                                                          </ul>
                                                          <p class="mb-1">
                                                            <b
                                                              >30% Toward
                                                              Wants</b
                                                            >
                                                          </p>
                                                          <h5
                                                            class="hover-info-subtitle"
                                                          >
                                                            This is what some
                                                            people think of as
                                                            the “fun” category.
                                                            It includes things
                                                            you want but could
                                                            certainly live
                                                            without if you had
                                                            to.
                                                          </h5>
                                                          <h5
                                                            class="hover-info-subtitle mb-2"
                                                          >
                                                            Here are some of the
                                                            common expenses that
                                                            get classified as
                                                            “wants”:
                                                          </h5>

                                                          <ul class="innerlist">
                                                            <li>
                                                              <h5
                                                                class="hover-info-subtitle"
                                                              >
                                                                <b
                                                                  >Date
                                                                  nights.</b
                                                                >
                                                              </h5>
                                                            </li>
                                                            <li>
                                                              <h5
                                                                class="hover-info-subtitle"
                                                              >
                                                                <b
                                                                  >Eating
                                                                  out.</b
                                                                >
                                                              </h5>
                                                            </li>
                                                            <li>
                                                              <h5
                                                                class="hover-info-subtitle"
                                                              >
                                                                <b
                                                                  >Entertainment</b
                                                                >
                                                                (concerts,
                                                                plays, sporting
                                                                events, etc.).
                                                              </h5>
                                                            </li>
                                                            <li>
                                                              <h5
                                                                class="hover-info-subtitle"
                                                              >
                                                                <b
                                                                  >Gym
                                                                  membership.</b
                                                                >
                                                              </h5>
                                                            </li>
                                                            <li>
                                                              <h5
                                                                class="hover-info-subtitle"
                                                              >
                                                                <b>Hobbies.</b>
                                                              </h5>
                                                            </li>
                                                            <li>
                                                              <h5
                                                                class="hover-info-subtitle"
                                                              >
                                                                <b
                                                                  >Premium and
                                                                  streaming TV </b
                                                                >(like HBO and
                                                                Netflix).
                                                              </h5>
                                                            </li>
                                                            <li>
                                                              <h5
                                                                class="hover-info-subtitle"
                                                              >
                                                                <b
                                                                  >Non-essential
                                                                  shopping</b
                                                                >
                                                                (new golf clubs,
                                                                a new Kate Spade
                                                                purse, etc.).
                                                              </h5>
                                                            </li>
                                                            <li>
                                                              <h5
                                                                class="hover-info-subtitle"
                                                              >
                                                                <b>Travel.</b>
                                                              </h5>
                                                            </li>
                                                          </ul>
                                                          <p class="mb-1">
                                                            <b
                                                              >20% Toward
                                                              Savings</b
                                                            >
                                                          </p>
                                                          <h5
                                                            class="hover-info-subtitle"
                                                          >
                                                            The next number to
                                                            think about in this
                                                            budget formula is
                                                            20%. This is the
                                                            money that goes
                                                            toward achieving
                                                            your financial
                                                            goals, which may
                                                            include:
                                                          </h5>

                                                          <ul class="innerlist">
                                                            <li>
                                                              <a
                                                                href="https://www.thewaystowealth.com/save-money/how-to-build-an-emergency-fund/"
                                                                >Building an
                                                                emergency
                                                                fund.</a
                                                              >
                                                            </li>
                                                            <li>
                                                              <a
                                                                href="https://www.thewaystowealth.com/debt-payoff/get-out-of-debt-fast/"
                                                                >Paying off
                                                                high-interest
                                                                debt.</a
                                                              >
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div> -->
                                                    </div>
                                                  </div>

                                                  <!-- <b-button block variant="light" class="cursor-auto font-sm ">
                                      <span class="wraptext"> for:</span> Needs / Wants / Financial Goals
                                      <div class="hover-info-box">
                                        <span class="hover-icon ml-2" v-if="isActive"
                                        >
                                        <i class="far fa-question-circle teal-color"></i>
                                        </span>
                                        <div class="hover-info position-right">
                                          <h5 class="hover-info-title">
                                            What is 50-30-20 Budget Modeling?
                                          </h5>
                                          <h5 class="hover-info-subtitle"> 
                                            50/30/20 budget modeling is a popular “rule of thumb” method that splits your monthly income between three main categories. Here's how it works:
                                          </h5>
                                          <p class="hover-info-text">
                                            <b>Monthly after-tax income.</b> This figure is your income after taxes have been deducted and the cost of payroll deductions for health insurance, 401(k) contributions or other automatic savings have been added back in.
                                          </p>
                                          <p class="hover-info-text">
                                            <b>50% of your income: Needs.</b> Necessities are the expenses you can’t avoid. This portion of your budget should cover costs such as:
                                              Housing. <br/>

                                              Food. <br/>

                                              Transportation. (including car payments) <br/>

                                              Basic utilities. <br/>

                                              Insurance. <br/>

                                              Minimum loan payments. Anything beyond the minimum goes into the savings and debt repayment bucket. <br/>

                                              Child care or other expenses that need to be covered so you can work. <br/>
                                          </p>
                                          <p class="hover-info-text">
                                            <b>30% of your income: Wants.</b> Distinguishing between needs and wants isn’t always easy and can vary from one budget to another. Generally, though, wants are the extras that aren’t essential to living and working. They’re often for fun and may include:
                                              Monthly subscriptions. <br/>

                                              Travel. <br/>

                                              Entertainment. <br/>

                                              Meals out. 
                                          </p>
                                           <p class="hover-info-text">
                                            <b>20% of your income: Savings and Debt.</b> Savings is the amount you sock away to prepare for the future. Devote this chunk of your income to paying down existing debt and creating a comfortable financial cushion to avoid taking on future debt.
                                             How, exactly, to use this part of your budget depends on your situation, but it will likely include: <br/>

                                             Starting and growing an emergency fund. <br/>

                                             Saving for retirement through a 401(k) and perhaps an individual retirement account. <br/>

                                             Paying off debt, beginning with the toxic, high-interest type.
                                          </p>
                                        </div>
                                      </div>
                                    </b-button> -->
                                                </b-card-header>
                                                <div
                                                  class="ml-auto budget-plan-btn"
                                                >
                                                  <p>
                                                    <span
                                                      class="needs_goals"
                                                    ></span
                                                    >Compassion Choice
                                                  </p>
                                                  <p>
                                                    <span
                                                      class="wants_goals"
                                                    ></span
                                                    >Past Choice
                                                  </p>
                                                  <p>
                                                    <span
                                                      class="financial_goals"
                                                    ></span
                                                    >Present Choice
                                                  </p>
                                                  <p>
                                                    <span
                                                      class="future_goals"
                                                    ></span
                                                    >Future Choice
                                                  </p>
                                                  <!-- <button class="needs_goals">Needs</button>
                                      <button class="wants_goals">Wants</button>
                                      <button class="financial_goals">
                                        Financial Goals
                                      </button> -->
                                                </div>
                                                <div
                                                  class="w-100"
                                                  :class="{
                                                    printbg: !isActive,
                                                  }"
                                                >
                                                  <b-row>
                                                    <b-col sm="12" xl="4">
                                                      <div
                                                        class="modal-piechart mt-3 w-100"
                                                        :class="{
                                                          printbg: !isActive,
                                                        }"
                                                      >
                                                        <b-card
                                                          no-body
                                                          class="new-frame-card-inner p-1 card-shadow w-100"
                                                          :class="{
                                                            printbg: !isActive,
                                                          }"
                                                        >
                                                          <b-card-header
                                                            header-tag="header"
                                                            class="border-none shadow-none p-0 w-100"
                                                            role="tab"
                                                            :class="{
                                                              printbg:
                                                                !isActive,
                                                            }"
                                                          >
                                                            <b-button
                                                              block
                                                              variant="light"
                                                              class="cursor-auto"
                                                            >
                                                              Model</b-button
                                                            >
                                                          </b-card-header>
                                                          <b-card-body
                                                            class="px-1 w-100"
                                                            :class="{
                                                              printbg:
                                                                !isActive,
                                                            }"
                                                          >
                                                            <div
                                                              class="chart-box d-block text-center"
                                                            >
                                                              <div
                                                                class="w-100 text-center"
                                                              >
                                                                <div
                                                                  id="piechart5"
                                                                  ref="piechart5"
                                                                  class="rm-chart-watermark"
                                                                ></div>
                                                              </div>
                                                            </div>
                                                          </b-card-body>
                                                        </b-card>
                                                      </div>
                                                    </b-col>
                                                    <b-col sm="12" xl="4">
                                                      <div
                                                        class="modal-piechart mt-3 w-100"
                                                        :class="{
                                                          printbg: !isActive,
                                                        }"
                                                      >
                                                        <b-card
                                                          no-body
                                                          class="new-frame-card-inner p-1 card-shadow w-100"
                                                          :class="{
                                                            printbg: !isActive,
                                                          }"
                                                        >
                                                          <b-card-header
                                                            header-tag="header"
                                                            class="border-none shadow-none p-0 w-100"
                                                            :class="{
                                                              printbg:
                                                                !isActive,
                                                            }"
                                                            role="tab"
                                                          >
                                                            <b-button
                                                              block
                                                              variant="light"
                                                              class="cursor-auto"
                                                              >Your
                                                              Peers</b-button
                                                            >
                                                          </b-card-header>
                                                          <b-card-body
                                                            class="px-1 w-100"
                                                            :class="{
                                                              printbg:
                                                                !isActive,
                                                            }"
                                                          >
                                                            <div
                                                              class="chart-box d-block text-center"
                                                            >
                                                              <div
                                                                class="w-100 text-center"
                                                              >
                                                                <div
                                                                  id="piechart4"
                                                                  ref="piechart4"
                                                                  class="rm-chart-watermark"
                                                                ></div>
                                                              </div>
                                                            </div>
                                                          </b-card-body>
                                                        </b-card>
                                                      </div>
                                                    </b-col>
                                                    <b-col sm="12" xl="4">
                                                      <div
                                                        class="modal-piechart mt-3 w-100"
                                                        :class="{
                                                          printbg: !isActive,
                                                        }"
                                                      >
                                                        <b-card
                                                          no-body
                                                          class="new-frame-card-inner p-1 card-shadow w-100"
                                                          :class="{
                                                            printbg: !isActive,
                                                          }"
                                                        >
                                                          <b-card-header
                                                            header-tag="header"
                                                            class="border-none shadow-none p-0 w-100"
                                                            role="tab"
                                                            :class="{
                                                              printbg:
                                                                !isActive,
                                                            }"
                                                          >
                                                            <b-button
                                                              block
                                                              variant="light"
                                                              class="cursor-auto"
                                                              >You</b-button
                                                            >
                                                          </b-card-header>
                                                          <b-card-body
                                                            class="px-1 w-100"
                                                            :class="{
                                                              printbg:
                                                                !isActive,
                                                            }"
                                                          >
                                                            <div
                                                              class="chart-box d-block text-center"
                                                            >
                                                              <div
                                                                class="w-100 text-center"
                                                              >
                                                                <div
                                                                  id="piechart3"
                                                                  ref="piechart3"
                                                                  class="rm-chart-watermark"
                                                                ></div>
                                                              </div>
                                                            </div>
                                                          </b-card-body>
                                                        </b-card>
                                                      </div>
                                                    </b-col>
                                                  </b-row>
                                                </div>
                                              </div>
                                            </div>
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </b-collapse>
                                  </div>
                                </div>
                              </b-col>
                            </b-row>
                          </div>
                        </b-card>
                      </b-col>
                    </b-row>
                    <b-row class="newtabs_spendid">
                      <b-col sm="12" xl="12">
                        <b-card no-body fixed="top" class="hide-card">
                          <b-tabs card class="hide-card">
                            <!-- <h5 class="hnavigate mb-3 d-none d-md-block">
                              Click Section Headers Above To Navigate
                            </h5> -->
                            <!--profile-expense-->
                            <b-tab
                              title="Your Profile"
                              :active="activeTab === 'Your Profile'"
                              @click="goto('Your Profile')"
                            >
                            </b-tab>
                            <!--profile-end-->

                            <!-- major-expense -->
                            <b-tab
                              title="Your Major Expenses"
                              class="your-core-expenses-accordion"
                              @click="goto('Your Major Expenses')"
                              :active="activeTab === 'Your Major Expenses'"
                            >
                            </b-tab>
                            <!-- major-expense-end-->

                            <!-- new-accordin-frame -->
                            <b-tab
                              title="Common Monthly Bills"
                              id="list-view-grid-expense"
                              @click="goto('Common Monthly Bills')"
                              :active="activeTab === 'Common Monthly Bills'"
                            >
                            </b-tab>
                            <!-- new-accordin-frame-end -->

                            <!--discretionary-start-->
                            <b-tab
                              title="Other Discretionary Expenses"
                              @click="goto('Other Discretionary Expenses')"
                              :active="
                                activeTab === 'Other Discretionary Expenses'
                              "
                            >
                            </b-tab>
                            <!--discretionary-end-->

                            <!-- Your Result Tab Start -->
                            <b-tab
                              no-body
                              title="Your Result"
                              :active="activeTab === 'Your Result'"
                              @click="goto('Your Result')"
                            >
                              <template #title>
                                <div
                                  class="d-flex justify-content-between align-items-center w-100"
                                >
                                  <span
                                    >Results
                                    <i class="fa fa-check-circle text-light"></i
                                  ></span>
                                  <div class="hover-info-box d-none">
                                    <span class="hover-icon ml-2">
                                      <i
                                        class="far fa-question-circle text-light"
                                      ></i>
                                    </span>
                                    <div class="hover-info position-right">
                                      <p class="m-0 hover-info-text">
                                        Welcome to your preliminary Results
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </template>
                            </b-tab>
                            <!-- Your Result Tab Start -->
                          </b-tabs>
                        </b-card>
                      </b-col>
                    </b-row>
                  </div>
                </b-col>
                <!-- end-new-styling -->
              </b-row>
            </b-container>

            <b-modal
              id="eliminated"
              size="small"
              ref="eliminated"
              hide-footer
              title="Disable Category"
            >
              <div class="mb-4 d-block text-center">
                <i class="fas fa-exclamation-circle text-warning fa-3x"></i>
              </div>
              <div class="my-4 d-block text-center">
                <h4 class="font-weight-bold">Are you sure?</h4>
                <!-- <p>You want to Disable this category!</p> -->
              </div>
              <div class="my-4 d-block text-center">
                <b-button type="button" @click="runElimination()" variant="info"
                  >Removed Category</b-button
                >
              </div>
              <div class="bg-light border rounded mt-3 py-2 px-3">
                <h6 class="font-weight-bold">Note</h6>
                <p class="small m-0">
                  You can restore this category at the bottom of the page
                  anytime
                </p>
              </div>
            </b-modal>
            <!-- custom_blocks end-->

            <b-modal
              id="themeColor"
              size="md"
              ref="themeColor"
              hide-footer
              hide-header
            >
              <div class="d-block text-center">
                <img
                  alt="thumbs-up"
                  width="150"
                  src="light.jpg"
                  class="img-fluid"
                />
              </div>
              <div class="my-4 d-block text-center">
                <h3 class="font-weight-bold">
                  Change your theme color to light version
                </h3>
                <h6>
                  For best printing experience, <br />
                  please change your theme color to light version from toggle
                  button at top right!
                </h6>
              </div>
              <div class="my-4 d-block text-center">
                <b-button
                  variant="success"
                  class="btn-theme mx-1"
                  @click="$refs['themeColor'].hide()"
                >
                  OK
                </b-button>
              </div>
            </b-modal>
          </section>
        </b-form>
      </div>
      <!-- <Footer /> -->
    </div>
    <HowTo :class="{ 'd-none': page == 'main' }" />
    <b-modal
      ref="logout-popup"
      hide-footer
      hide-header
      id="logout-popup"
      header-text-variant="light"
      header-border-variant="none"
    >
      <b-row>
        <b-col>
          <h4 class="mt-4 mb-3 text-center">
            Automatically logged out due to 15 minutes of inactivity
          </h4>
          <b-button
            class="btn btn-success theme-color-btn w-100 btnheight50"
            @click="pageReload"
          >
            Login
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal
      ref="projectGrowth"
      hide-header
      hide-footer
      id="projectGrowth"
      header-text-variant="light"
      header-border-variant="none"
      size="lg"
    >
      <b-row>
        <b-col class="text-center mb-3">
          <h3 class="font-weight-bold">Projected Investment Balance</h3>
          <h6 class="text-capitalize">at constant Monthly Saving Amount</h6>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <!-- <div class="d-block">
            <h6 class="font-weight-bold">(Thousands $)</h6>
          </div> -->
          <div id="chartdiv" ref="chartdiv"></div>
          <!-- <h6 class="font-weight-bold chart-age">Age</h6> -->
        </b-col>
      </b-row>
      <!-- <b-row class="mt-4 align-items-center justify-content-center">
        <b-col cols="12" md="12" lg="12">
          <div class="d-flex justify-content-center align-items-center">
            <div class="d-flex align-items-center mr-3">
              <span
                class="d-inline-block mr-2"
                style="height:16px;width:16px; border-radius: 4px;background-color: #116cff;"
              ></span>
              <span>You</span>
            </div>
            <div class="d-flex align-items-center ml-3">
              <span
                class="d-inline-block mr-2"
                style="height:16px;width:16px; border-radius: 4px;background-color: #55aa55;"
              ></span>
              <span>Peers</span>
            </div>
          </div>
        </b-col>
      </b-row> -->
      <b-row class="mt-4 align-items-center justify-content-center">
        <b-col cols="12" md="11" lg="7">
          <div
            class="investment-return d-flex align-items-center flex-column flex-md-row"
          >
            <p class="mb-0 font-weight-bold flex-shrink-0 mr-3">
              Average Annual Investment Return:
            </p>
            <!-- Using slots -->
            <b-input-group class="investment-return-group">
              <template #append>
                <b-input-group-text><strong>%</strong></b-input-group-text>
              </template>
              <b-form-input
                v-model="predictGrowth"
                @change="predictGrowthChange"
                type="number"
              ></b-form-input>
            </b-input-group>
          </div>
        </b-col>
        <!-- <b-col cols="4" xs="3" sm="3">
          <b-input v-model="predictGrowth" type="number" />
        </b-col> -->
      </b-row>
      <b-row class="mt-4">
        <b-col class="text-center">
          <b-button
            class="mr-2 btn btn-theme"
            style="font-weight: 400 !important"
            @click="projectGrowthView(predictGrowth)"
            >Update</b-button
          >
          <b-button
            class="mr-2 btn btn-danger"
            style="border: solid 2px #dc3545; border-radius: 5px"
            @click="$refs['projectGrowth'].hide()"
            >Close</b-button
          >
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      ref="email-popup-pdf"
      hide-header
      hide-footer
      id="emailpopuppdf"
      header-text-variant="light"
      header-border-variant="none"
    >
      <b-row>
        <b-col>
          <b-col class="text-center">
            <img alt="logo" style="max-height: 200px" src="brown-logo.png" />
            <h4 class="mt-4 mb-3">Email of PDF</h4>
          </b-col>

          <b-form-group class="has-icons-right text-center">
            <!-- <label>Enter your email address.</label> -->
            <b-col class="d-flex align-items-center">
              <b-form-input
                placeholder="Enter Email"
                v-model="user_email_pdf"
                debounce="300"
                type="text"
                autocomplete="on"
                class="position-relative pr-30 hight50"
              >
              </b-form-input>
              <span class="check icon is-small newspace is-right pr-4">
                <i
                  v-if="!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(user_email_pdf)"
                  class="fas fa-times text-danger"
                ></i>
                <i v-else class="fas fa-check text-green"></i>
              </span>
            </b-col>
          </b-form-group>

          <b-form-group class="text-center mt-2">
            <b-col>
              <b-button
                class="btn btn-success theme-color-btn w-100 btnheight50"
                @click="saveReport(true)"
                :disabled="!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(user_email_pdf)"
              >
                Send Now
              </b-button>
            </b-col>
          </b-form-group>
          <b-form-group class="text-center mt-2">
            <b-col>
              <div class="text-secondary">
                (Popups must be enabled in device settings)
              </div>
            </b-col>
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      ref="email-popup"
      hide-footer
      id="emailpopup"
      header-text-variant="light"
      header-border-variant="none"
    >
      <b-row>
        <b-col>
          <b-col class="text-center">
            <img src="footer-logo.png" alt="" />
            <h4 class="mt-4 mb-3">Login</h4>
          </b-col>

          <b-form-group class="has-icons-right text-center">
            <!-- <label>Enter your email address.</label> -->
            <b-col class="d-flex align-items-center">
              <b-form-input
                placeholder="Enter Email"
                v-model="user_email"
                type="text"
                autocomplete="on"
                class="position-relative pr-30 hight50"
              >
              </b-form-input>
              <span class="check icon is-small newspace is-right pr-4">
                <i
                  v-if="!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(user_email)"
                  class="fas fa-times text-danger"
                ></i>
                <i v-else class="fas fa-check text-green"></i>
              </span>
            </b-col>
          </b-form-group>
          <b-form-group class="has-icons-right text-center">
            <!-- <label>Enter your email address.</label> -->
            <b-col class="d-flex align-items-center">
              <b-form-input
                placeholder="Enter Password"
                v-model="user_password"
                type="password"
                autocomplete="on"
                class="position-relative pr-30 hight50"
              >
              </b-form-input>
              <span class="check icon is-small newspace is-right pr-4">
                <i
                  v-if="user_password.length <= 6"
                  class="fas fa-times text-danger"
                ></i>
                <i v-else class="fas fa-check text-green"></i>
              </span>
            </b-col>
          </b-form-group>

          <b-form-group class="text-center mt-2">
            <b-col class="d-flex align-items-center">
              <b-button
                class="btn btn-success theme-color-btn w-100 btnheight50"
                @click="verifyEmail()"
                :disabled="
                  !(user_password.length <= 6) ||
                  !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(user_email)
                "
                aria-controls="cust-core-expense-1"
              >
                Login
              </b-button>
            </b-col>
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal
      id="chatGptList"
      v-model="modalShow"
      scrollable
      size="xl"
      content-class="get-advice-modal"
      v-if="modalShow == true"
      hide-footer
    >
      <ChatGptList :uses="uses" />
    </b-modal>
    <!-- <Blog :class="{'d-none':page=='main'}"/> -->
  </div>
</template>

<style>
@import url("https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,500;1,600&display=swap");

body {
  color: #4a4a4a;
  background-color: #fff;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  font-family: "Tahoma";
}
body::-webkit-scrollbar {
  width: 2px;
}
body::-webkit-scrollbar-track {
  background: #7c858d;
  border-radius: 100px;
}
body::-webkit-scrollbar-thumb {
  background: rgb(58, 183, 164);
  border-radius: 100px;
}

.toggle-wrap {
  display: none;
}
.darkmode h4.chrdhead.newbg {
  background: #5f58d1;
  border-radius: 5px;
  display: inline-block;
  padding: 5px 15px;
  color: #fff;
}
.darkmode .spend-custominput {
  text-align: center;
  font-size: 1.5rem;
  font-weight: 700 !important;
}
.spend-custominput {
  border: #fff solid thin !important;
  background-color: #0267e8 !important;
  font-size: 24px !important;
  color: #fff !important;
  text-align: center !important;
}
.spend-valid {
  border-color: rgb(64 155 146) !important;
  background-color: #fff !important;
}
.darkmode .spend-valid {
  border-color: rgb(64 155 146) !important;
  background-color: #090729 !important;
}
.spend-custominput::-webkit-input-placeholder {
  color: #fff !important;
}
.spendid-predicted {
  background: #5f58d1 !important;
  padding: 8px;
  color: #fff;
  border-radius: 5px;
  font-size: 24px !important;
}
span.helps-text {
  font-size: 18px;
  margin-left: 12px;
}
.darkmode p.fixedstartbtn,
.darkmode p.fixedstartbtn:hover {
  color: #88cfba !important;
}
p.fixedstartbtn,
p.fixedstartbtn:hover {
  position: absolute;
  left: -130px;
  background: transparent;
  color: #180f4f !important;
  border: none;
  outline: none;
  font-size: 20px;
  font-weight: 600;
  animation: shake 2s cubic-bezier(0.36, 0.07, 0.19, 0.97) both infinite;
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  perspective: 1000px;
}
p.fixedstartbtn2,
p.fixedstartbtn2:hover {
  background: transparent;
  color: #88cfba !important;
  border: none;
  outline: none;
  font-size: 20px;
  font-weight: 600;
  animation: shake 2s cubic-bezier(0.36, 0.07, 0.19, 0.97) both infinite;
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  perspective: 1000px;
}
h4.greeninfo {
  background: transparent;
  color: #88cfba;
  border: none;
  outline: none;
  font-size: 24px;
  font-weight: 600;
  text-align: left;
}
@keyframes shake {
  10%,
  90% {
    transform: translate3d(-1px, 0, 0);
  }

  20%,
  80% {
    transform: translate3d(2px, 0, 0);
  }

  30%,
  50%,
  70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%,
  60% {
    transform: translate3d(4px, 0, 0);
  }
}
#emailpopup___BV_modal_content_ {
  background: #2a2e5c;
  color: #fff;
}
.form-control,
.custom-select {
  border-radius: 100px !important;
  /* border: #235d37 solid thin !important; */
}
.form-control.hight50 {
  height: 50px;
  background: #181b40;
  border-color: #181b40;
  color: #fff;
}
.form-control.hight50::-webkit-input-placeholder {
  color: #fff;
}
.btn.btnheight50 {
  height: 50px;
  font-size: 20px;
  color: #fff;
  position: relative;
  z-index: 9;
}
.icon.newspace {
  top: 18px;
}

body .spendid-removebg {
  background: transparent !important;
  box-shadow: none !important;
}
/* body .spendid-whitbg {
  background: #fff;
  margin-top: 25px;
  border-radius: 5px;
  box-shadow: 0 3px 14px rgb(0 0 0 / 10%) !important;
} */
/* body .darkmode .spendid-whitbg {
  background: #1e2041;
} */
button.spendid-accord-button {
  width: 750px;
  margin: 0 auto;
}
.spendid-accord-button:disabled {
  background: gray !important;
}
@media all and (max-width: 1450px) {
  body .custom-container.container {
    /* max-width: 1090px !important; */
  }
}
@media all and (max-width: 2100px) {
  .force-overflow {
    min-height: 700px !important;
  }
  .step_form_area.side-visible #cash-flow-score {
    max-width: 1000px !important;
  }
}
@media all and (max-width: 1400px) {
  .time_duration small {
    font-size: 19px !important;
  }
  /* .mobile-flex-here {

    flex-wrap: wrap;
} */
  .budget_model.d-flex {
    display: inline-flex !important;
    flex-wrap: wrap;
    /* justify-content: center; */
  }

  .step_form_area.side-visible #cash-flow-score {
    max-width: 830px !important;
  }
}

/* december-css-media-start */
@media screen and (min-width: 1653px) and (max-width: 1752px) {
  .custom-container.container {
    max-width: 1550px !important;
  }
  .newtabs_spendid .tabs .card-header .nav-tabs {
    /* max-width: 1068px !important; */
  }
  .newtabs_spendid .tabs .card-header .nav-tabs li.nav-item .nav-link,
  .newtabs_spendid .tabs .card-header .nav-tabs li.nav-item .nav-link:hover {
    font-size: 16px !important;
  }
}

@media screen and (min-width: 1607px) and (max-width: 1652px) {
  .custom-container.container {
    max-width: 1450px !important;
  }
  .newtabs_spendid .tabs .card-header .nav-tabs {
    /* max-width: 1068px !important; */
  }
  .newtabs_spendid .tabs .card-header .nav-tabs li.nav-item .nav-link,
  .newtabs_spendid .tabs .card-header .nav-tabs li.nav-item .nav-link:hover {
    font-size: 16px !important;
  }
}

@media screen and (min-width: 1507px) and (max-width: 1606px) {
  .custom-container.container {
    max-width: 1250px !important;
  }
  .newtabs_spendid .tabs .card-header .nav-tabs {
    max-width: 1068px !important;
  }
  .newtabs_spendid .tabs .card-header .nav-tabs li.nav-item .nav-link,
  .newtabs_spendid .tabs .card-header .nav-tabs li.nav-item .nav-link:hover {
    font-size: 16px !important;
  }
}

/* @media screen and (min-width: 1451px) and (max-width: 1506px) {
  .newtabs_spendid .tabs .card-header .nav-tabs {
    max-width: 1068px !important;
  }
} */
@media screen and (min-width: 1406px) and (max-width: 1506px) {
  .custom-container.container {
    max-width: 1090px !important;
  }

  .newtabs_spendid .tabs .card-header .nav-tabs li.nav-item .nav-link,
  .newtabs_spendid .tabs .card-header .nav-tabs li.nav-item .nav-link:hover {
    font-size: 16px !important;
  }
}

@media screen and (min-width: 1351px) and (max-width: 1406px) {
  .custom-container.container {
    max-width: 1000px !important;
  }
  .newtabs_spendid .tabs .card-header .nav-tabs {
    max-width: 938px !important;
  }
  .newtabs_spendid .tabs .card-header .nav-tabs li.nav-item .nav-link,
  .newtabs_spendid .tabs .card-header .nav-tabs li.nav-item .nav-link:hover {
    font-size: 16px !important;
  }
}
@media (max-width: 1280px) {
  .scrollbar {
    height: calc(100vh - 265px);
  }
}
@media screen and (min-width: 1281px) and (max-width: 1350px) {
  .custom-container.container {
    max-width: 1000px !important;
  }
  .newtabs_spendid .tabs .card-header .nav-tabs {
    max-width: 867px !important;
  }
  .newtabs_spendid .tabs .card-header .nav-tabs li.nav-item .nav-link,
  .newtabs_spendid .tabs .card-header .nav-tabs li.nav-item .nav-link:hover {
    font-size: 16px !important;
  }
}

@media screen and (min-width: 1360px) and (max-width: 1400px) {
  body
    .mobile-flex-here
    button.btn.clear-sm.float-md-none.ml-md-0.btn-secondary {
    margin-left: 5px !important;
  }
}
@media screen and (max-width: 1359px) {
  .mobile-flex-here {
    flex-wrap: wrap;
  }
  body
    .mobile-flex-here
    button.btn.clear-sm.float-md-none.ml-md-0.btn-secondary {
    margin-left: 0px !important;
  }
}
@media screen and (min-width: 1200px) and (max-width: 1280px) {
  .custom-container.container {
    max-width: 900px;
    margin-left: 300px !important;
  }
  .newtabs_spendid .tabs .card-header .nav-tabs {
    max-width: 837px !important;
  }
  .newtabs_spendid .tabs .card-header .nav-tabs li.nav-item .nav-link,
  .newtabs_spendid .tabs .card-header .nav-tabs li.nav-item .nav-link:hover {
    font-size: 15px !important;
  }
}

@media all and (min-width: 1200px) and (max-width: 1752px) {
  .custom-container.container {
    margin: initial;
  }
}
@media (max-width: 1280px) {
  .scrollbar {
    height: calc(100vh - 215px) !important;
  }
  .tabs a.budgetabsolute {
    padding: 5px 3px;
  }
}
@media all and (min-width: 1022px) and (max-width: 1199px) {
  .newtabs_spendid .tabs .card-header .nav-tabs li.nav-item .nav-link,
  .newtabs_spendid .tabs .card-header .nav-tabs li.nav-item .nav-link:hover {
    font-size: 15px !important;
  }
  .nav-action-btns .acount-profile-wrap {
    display: none;
  }
  .newtabs_spendid .tabs .card-header {
    padding: 0px 0px 10px 8px !important;
  }
  .newtabs_spendid .tabs .card-header .nav-tabs {
    max-width: 870px !important;
  }
}
/* december-css-media-end */
@media all and (max-width: 1200px) {
  #live-demo {
    width: 100% !important;
  }
}
@media all and (max-width: 767px) {
  body .address_sec fieldset.form-group.mb-2.mt-3.pl-3 {
    padding-left: 0 !important;
  }
  /* body #live-demo {
    border-bottom: #8acfba solid 20px;
    border-left: #8acfba solid 20px;
    border-right: #8acfba solid 20px;
  } */
  .resp-mr-view button {
    margin-right: 10px;
    margin-bottom: 10px;
  }
  .mobileisize img {
    width: 250px;
  }
  /* .m_fullwidth {
    flex-wrap: wrap;
  } */
  div#list-view-grid-expense {
    padding: 0px !important;
  }
  .mobile-flex {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .psb-class {
    border: #a9a9a9 solid thin;
    padding: 15px;
    border-radius: 5px;
  }
  p.fixedstartbtn2 {
    display: flex;
    justify-content: space-between;
  }
  .darkmode .m_white {
    color: #fff;
  }
  p.fixedstartbtn {
    display: none;
  }
  p.fixedstartbtn2 i {
    transform: rotate(90deg);
  }
  .expense h6 {
    background: transparent;
    /* padding: 10px 0px;
    margin-top: 10px; */
    color: #000;
    font-size: 16px !important;
  }
  /* .darkmode .expense h6 {
    background: #404379;
    color: #fff;
  } */
  span.wraptext {
    width: 100%;
    display: inline-block;
  }
  span.helps-text {
    font-size: 16px;
    margin-left: 0px;
    display: inline-block;
  }
}
@media all and (max-width: 700px) {
  .newtabs_spendid .tabs .card-header .nav-tabs {
    padding: 10px;
    flex-direction: column;
  }
  .newtabs_spendid .tabs .card-header .nav-tabs li.nav-item,
  .newtabs_spendid .tabs .card-header .nav-tabs li:not(:last-child).nav-item {
    width: 100% !important;
    margin-bottom: 10px !important;
  }
  .newtabs_spendid .tabs .card-header .nav-tabs li.nav-item:last-child {
    margin-bottom: 0 !important;
  }
  .newtabs_spendid .tabs .card-header .nav-tabs li.nav-item:last-child {
    margin-right: 0px;
    border-right: none !important;
  }
  .custom-container.container {
    padding: 0 !important;
  }
  .budget-tables.p-3 {
    padding: 0 !important;
  }
}
.min-height538 {
  min-height: 538px;
}

.min-height-460 {
  min-height: 546px;
}

.min-height-100 {
  height: 100%;
}

.teal-color {
  color: #235d37 !important;
}
.login-modal {
  position: relative;
  height: 100%;
  overflow: hidden;
  margin: 40px 0;
}
#login-page {
  position: absolute;
  z-index: 9;
  margin: auto 0;
  width: 100%;
  display: flex;
  justify-content: center;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  align-items: center;
}

.darkmode #login-page {
  background: rgba(256, 256, 256, 0.8);
}
.login-modal {
  width: 450px;
  height: 200px;
  box-sizing: border-box;
  background: #fff;
  text-align: center;
  padding: 20px;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 90px auto auto auto;
  position: relative;
}
.darkmode .login-modal {
  background: #1e2041;
}
.darkmode .login-modal h4 {
  color: #fff;
}
#live-demo.blur {
  filter: blur(4px);
  -webkit-filter: blur(4px);
}

.speedometer {
  /* width: 348px!important; */
  height: 280px !important;
  overflow: visible !important;
}
/* .current-value{
  font-size: 32px!important;
}
.segment-value{
  font-size: 18px!important;
} */

.printlogo .light-logo,
.darkmode .printlogo .dark-logo {
  display: block;
}
.printlogo .dark-logo,
.darkmode .printlogo .light-logo {
  display: none;
}
.printbg {
  background-color: #ffffff;
}
.darkmode .printbg {
  background-color: #090729;
}
.card-header.displaynone .btn::after {
  display: none;
}
.print-loader {
  background-color: rgba(256, 256, 256, 1);
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 9999;
  width: 100%;
}
.print-loader-message {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.darkmode .print-loader-message {
  color: #fff;
}
.darkmode .print-loader {
  background-color: #090729;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 9999;
  width: 100%;
}
.printinfo {
  min-height: 460px;
}
@media screen and (max-width: 767px) {
  .printinfo {
    min-height: auto;
  }
}
.login-modal-divider {
  position: relative;
  padding: 30px 0;
}
.login-modal-divider::before {
  content: "";
  position: absolute;
  display: block;
  width: 2px;
  top: 0;
  bottom: 0;
  height: 100%;
  margin: 0 auto;
  left: -7px;
  right: 0;
  text-align: center;
}
.login-modal-divider::before {
  background-color: #cbcbcb;
}
.darkmode .login-modal-divider::before {
  background-color: #383b65;
}
.v-divider {
  color: #000;
  border: solid 2px #cbcbcb;
  background-color: #f5f5f5;
}
.darkmode .v-divider {
  color: #fff;
  border: solid 2px #383b65;
  background-color: #000;
}
.v-divider {
  font-size: 14px;
  width: 38px;
  height: 38px;
  line-height: 2.4;
  border-radius: 100px;
  margin: 0 20px;
  position: relative;
  z-index: 1;
}
.modal-open,
.modal.show {
  padding-right: 0 !important;
}
/* ScoreCard New CSS Start Here*/
.unneeded-summery {
  background-color: #180f4f;
  border: solid 2px #180f4f;
}

.unneeded-summery,
.score-information {
  padding: 20px;
  border-radius: 5px;
}
.score-information {
  background-color: #eae7fb;
  border: solid 2px #4b456d;
}
.darkmode .score-information {
  background-color: #404379;
  border: solid 2px #5f58d1;
}
.darkmode .score-information h5,
.darkmode .score-information h6,
.darkmode .score-information p {
  color: #fff;
}
.score-information h5,
.score-information p {
  color: #000;
}
.score-information p {
  margin-bottom: 0;
}
/* Range Slider Css */
.step-slider .vue-slider {
  background: #2a2e5c;
  border-radius: 40px;
  width: 90% !important;
  margin: 0 auto;
}
.step-slider .vue-slider {
  height: 12px !important;
  padding: 0 !important;
}
.step-slider .vue-slider-rail {
  /* background-color: #2a2e5c; */
  background-color: #f3ede1;
  border-radius: 15px;
}

.step-slider .vue-slider-mark-step {
  display: none;
}
.step-slider .vue-slider-dot-handle {
  height: 26px;
  width: 26px;
  margin-top: -6px;
  border-color: #d3bb8e;
  background: #d3bb8e;
}
.step-slider .vue-slider:hover .vue-slider-dot-handle:hover {
  background: #d3bb8e;
}
.step-slider .vue-slider:hover .vue-slider-dot-handle,
.step-slider .vue-slider-dot-handle {
  border-color: #f3ede1;
}
.step-slider .vue-slider:hover .vue-slider-rail {
  background-color: #f3ede1;
}
.step-slider .vue-slider:hover .vue-slider-process,
.step-slider .vue-slider-process {
  background-color: #225935;
}
.step-slider .vue-slider-mark-label {
  font-size: 16px;
  font-weight: 400;
  width: 0;
}
/* Speedo Css */
.darkmode .result-speedo .psa-text,
.darkmode .result-speedo .score-title,
.darkmode .result-speedo .hover-icon i {
  color: #fff;
}
.darkmode .result-speedo .card-header {
  border-bottom: solid 1px #2e2b6b;
}
.darkmode .card.result-speedo {
  background-color: #090729;
}
.sorecard-box {
  background-color: #ffdd57;
  padding: 14px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  display: -webkit-flex;
  -webkit-align-items: center;
  -webkit-justify-content: space-between;
  min-height: 60px;
  position: relative;
}
.score-title,
.score-number h1 {
  color: #000;
}
.score-title {
  font-size: 16px;
  font-weight: 500;
}
.cat-edit-disable {
  color: #000;
}
.score-number {
  border-radius: 5px;
}
.score-number .spending-score {
  font-size: 18px;
  font-weight: 500;
  border-radius: 5px;
}
/* ScoreCard New CSS End Here*/
.card-shadow {
  border-radius: 5px;
  /* background: #fff; */
  box-shadow: 0 3px 14px rgb(0 0 0 / 10%) !important;
  width: 100%;
}
.custom_tabs > div {
  display: block;
  white-space: normal;
  box-sizing: border-box;
}
.btn.cross-btn:hover,
.btn.cross-btn:focus,
.btn.cross-btn:not(:disabled):not(.disabled):active,
.btn.cross-btn:not(:disabled):not(.disabled):active:focus {
  background-color: transparent;
  border-color: transparent;
  outline: none;
  color: #f20;
  box-shadow: none;
}

/* Accordion Style */
.hover-info-box {
  display: inline-block;
  position: relative;
  cursor: pointer;
}
.hover-info-box .hover-info-text,
.hover-info-box .hover-info-title,
.hover-info-box .hover-info-subtitle {
  text-align: left;
}
.hover-info-box .hover-info-text {
  font-size: 18px;
  color: rgb(33, 37, 41) !important;
  font-weight: normal;
  font-weight: 800;
  line-height: 30px;
  text-align: center;
}
.hover-info-box .hover-info-title {
  font-size: 16px;
  color: rgb(0, 0, 0) !important;
  font-weight: 500;
}
.hover-info-box .hover-info-subtitle {
  font-size: 14px;
  color: rgb(32, 32, 32) !important;
  font-weight: 500;
}
.hover-info-box .hover-info,
.hover-info-box .hover-info,
.hover-info-box .hover-info {
  position: absolute;
  z-index: 2;
  top: 20px;
  display: none;
  border-radius: 5px;
  cursor: pointer;
  padding: 16px;
  width: 300px;
  max-height: 500px;
  overflow-y: auto;
  background: #fff;
  -webkit-box-shadow: 0 3px 14px rgb(0 0 0 / 10%);
  box-shadow: 0 3px 14px rgb(0 0 0 / 10%);
  z-index: 9;
}
.hover-info-box:hover .hover-info {
  display: block;
  margin-top: 15px;
}
.hover-info-box .position-left {
  left: 0;
}
.hover-info-box .position-right {
  right: 0;
}
.custom_tabs .nav-tabs .nav-link {
  /* display: inline-block; */
  text-align: center;
  vertical-align: middle;
  user-select: none;
  background-color: #ddd;
  border: 1px solid #ddd;
  color: black;
  border-radius: 5px;
  padding: 8px 20px;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  transition: color 0.15s ease-in-out;
  cursor: pointer;
  position: relative;
  top: 1px;
  margin-right: 10px;
}
.custom_tabs .nav-tabs .nav-item:last-child .nav-link {
  margin-right: 0;
}
.custom_tabs .nav-tabs .nav-link.active {
  background-color: #180f4f;
  border-bottom: 1px solid #180f4f;
  color: #fff;
}

.rec-cat a {
  font-size: 20px;
  color: #000;
  font-weight: 700;
  line-height: 1.4;
}
.chrdhead {
  font-size: 13px;
  /* color: #fff; */
  margin-top: 5px;
  margin-bottom: 0;
  font-weight: 400;
}
.darkmode .chrdhead,
.darkmode .rec-cat a {
  color: #000;
}
.rec-cat {
  position: absolute;
  background-color: rgba(256, 256, 256, 0.8);
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1;
  text-align: right;
  height: 100%;
}
.rec-cat .btn {
  margin-right: 10px;
  margin-top: 10px;
}
.darkmode .rec-cat {
  background-color: rgba(0, 0, 0, 0.8);
}
.rec-cat a {
  color: #9a2f2f;
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
}
.custom_tabs .subtagline {
  border-bottom: 1px dashed #ccc;
  padding: 15px 15px 10px 15px;
  font-size: 17px;
  color: #000;
  /* margin-bottom: 15px; */
}
.custom_tabs .nav-tabs {
  border: 0;
  margin-top: 20px;
}
.cust-accordion .card {
  border: 0;
  margin-bottom: 20px;
  box-shadow: none;
}
.cust-accordion .card .card-body {
  padding-top: 14px !important;
}
.cust-accordion .card .card-header {
  border: 0;
}
.cust-accordion .card .card-header .btn {
  background-color: transparent;
  border: none;
  color: #000;
  text-align: left;
  font-size: 16px;
  font-weight: 600;
  box-shadow: inset 0 -3em 3em rgba(0, 0, 0, 0.1),
    0 0 0 0px rgba(255, 255, 255, 9), 0.3em 0.3em 1em rgba(0, 0, 0, 0.1);
  /* margin-bottom: 10px; */
}
.cust-core-expense-accordion .card {
  border: 0;
  margin-bottom: 8px;
  box-shadow: none;
}
.cust-core-expense-accordion .card:last-child {
  margin-bottom: 0;
}
.your-core-expenses-accordion
  .card
  .cust-core-expense-accordion
  .card
  .card-header
  .btn {
  font-size: 22px;
  font-weight: 600;
  padding: 10px 15px;
}
.cust-core-expense-accordion .card {
  margin-bottom: 16px;
}
.cust-core-expense-accordion .card .card-body {
  padding-top: 0px !important;
}
.cust-core-expense-accordion .card .card-header {
  border: 0;
}
.cust-core-expense-accordion .card .card-header .btn,
.core-expense-accordion .card .card-header .btn,
.other-expense-accordion .card .card-header .btn,
.eliminate-category-accordion .card .card-header .btn,
.cust-core-expense-accordion .card .card-header .btn {
  text-align: left;
}
.budget-chart-accordion .card .card-header .btn,
.modal-piechart .card .card-header .btn {
  text-align: center !important;
}
.has-icons-right {
  position: relative;
  z-index: 0;
}
.has-icons-right .check {
  position: absolute;
  right: 20px;
  bottom: 14px;
}
.has-icons-right .check.more-right {
  right: 32px;
}
.has-icons-right .check .text-green {
  color: #28a745;
}
.eliminate-category-accordion .card {
  border-radius: 5px;
  background: #fff;
  -webkit-box-shadow: 0 3px 14px rgb(0 0 0 / 10%);
  box-shadow: 0 3px 14px rgb(0 0 0 / 10%);
}
.eliminate-category-accordion .card-header {
  box-shadow: none;
  border: 0;
}
.eliminate-category-accordion .el-card .card {
  border-radius: 5px;
  border: 1px solid rgba(0, 0, 0, 0.125);
}
.budget-tables-header {
  /* background-color: #ffdd57; */
  background-color: #f5f5f5;
  border-radius: 5px;
  padding: 10px 14px;
}
.darkmode .budget-tables-header {
  background-color: #f3ede1 !important;
  border: solid 2px #d3bb8e !important;
}
.darkmode .add-fudget-form {
  background-color: #1c1d21 !important;
  border: solid 2px #1c1d21 !important;
}

.darkmode .budget-tables-header .cat-edit-disable,
.darkmode .budget-tables-header h6 {
  color: #000;
}
/* .edit-budget-amount{
  margin: 0 4px;
} */
.budget-tables-header .btn-group {
  margin-right: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 10px;
}
.budget-tables-header .btn-group:last-child {
  margin-right: 0px;
}
.teal-bx,
.dr-blue-bx {
  width: 32px;
  height: 32px;
  display: inline-block;
  vertical-align: middle;
  border-radius: 4px;
  margin-right: 4px;
  /* font-size: 18px; */
}
.action-tools .btn {
  background-color: #000;
  margin-right: 10px;
  font-size: 14px;
}
.action-tools .btn + .btn {
  margin-right: 0px;
}
.clr-box-btns .clr-bx-btn {
  border-radius: 4px;
  border: solid 2px;
  cursor: pointer;
  min-width: 56px;
  color: #fff;
  /* white-space: nowrap; */
  /* min-width: 70px; */
}
/* .budget-tables .card .card-body, */
.el-card .card .card-body {
  padding: 0.6rem;
}
.budget-tables .card .card-body .card-title,
.budget-tables .card .card-body .clr-bx-btn,
.el-card .card .card-body .card-title,
.el-card .card .card-body .clr-bx-btn {
  font-size: 16px;
}
.budget-tables .card .card-body .card-title,
.budget-tables .card .card-body .clr-bx-btn,
.el-card .card .card-body .card-title,
.el-card .card .card-body .clr-bx-btn,
.edit-budget-amount,
.add-fudget-form {
  margin: 4px;
}
.eliminate-category .card-title {
  position: relative;
  z-index: 1;
  display: inline-block;
}
.darkmode .eliminate-category .card-title {
  color: #cfcfcf;
}
.your-amount {
  background-color: #987e4c !important;
  border-color: #987e4c !important;
}
.darkmode .your-amount {
  background-color: #987e4c !important;
  border-color: #987e4c !important;
}
.fixed-amount {
  background-color: #0267e8;
  border-color: #0267e8 !important;
}
.darkmode .fixed-amount {
  border: solid 1px #bbbbbb !important;
  font-weight: 700 !important;
}
.peers-amount {
  background-color: #235d37;
  border-color: #235d37 !important;
}

.custom_tabs .form-group {
  position: relative;
}
.custom_tabs .form-group .check {
  position: absolute;
  right: 10px;
  bottom: 10px;
  /* opacity: 1; */
}
.edit-budget-amount .your-amount-text,
.edit-budget-amount .your-amount-text:hover {
  padding: 0;
  border-bottom: none;
}
.custom_tabs .form-group .check .text-green {
  color: #28a745;
}
.custom_tabs .form-group label span.required {
  background: #ff5050;
}
.custom_tabs .form-group label span.optional {
  background: #3d3d3d;
}
.custom_tabs .form-group label span.required,
.custom_tabs .form-group label span.optional {
  position: absolute;
  right: 0;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 3px;
  color: #fff;
}
.faq-accordion .card-header .btn {
  text-align: left;
  color: #180f4f;
  font-weight: 600;
}
.faq-accordion .card {
  -webkit-box-shadow: none;
  box-shadow: none;
  border: none;
}
button.collpase-center.collapsed {
  text-align: left !important;
}
button.collpase-center {
  text-align: center !important;
}
button.collpase-center.collapsed .hover-info.position-left {
  left: 0;
  transform: translate(0, 0);
}
button.collpase-center .hover-info.position-left {
  left: 50%;
  transform: translate(-50%, 10px);
}
.ht-number {
  color: #fff;
  background-color: #235d37;
  border-color: #235d37;
  width: 32px;
  /* display: inline-block; */
  height: 32px;
  border-radius: 100px;
  float: none;
  font-size: 20px;
  text-align: center;
  margin-right: 15px;
  display: inline-block;
}
.unneeded-summery .ht-number {
  /* display: inline-block; */
  float: left;
  text-align: center;
  line-height: 1.5;
}
.unneeded-summery ul li {
  color: #fff;
  position: relative;
  font-size: 18px;
  margin-bottom: 1rem;
  line-height: 1.5;
  font-weight: 500;
  display: inline-block;
  width: 100%;
}
.unneeded-summery ul li:last-child {
  margin-bottom: 0;
}
/*.unneeded-summery ul li::before{
  content: "";
  position: absolute;
  top:0;
  color: #fff;
  background-color: #235d37;
  border-color: #235d37;
  width: 32px;
  display: inline-block;
  height: 32px;
  border-radius: 100px;
  text-align: center;
  font-size: 20px;
} */

.legends .btn,
.legends .btn:hover,
.legends .btn:focus,
.legends .btn.active,
.legends .btn-light:not(:disabled):not(.disabled):active,
.legends .btn-light:not(:disabled):not(.disabled):active:focus {
  background-color: transparent;
  border-color: transparent;
  box-shadow: none;
}
.darkmode .legends .btn.btn-light,
.darkmode .legends .btn.btn-light:hover,
.darkmode .legends .btn.btn-light:focus {
  color: #b5b5b5;
}
.result-summery-accordion .card .card-header .btn,
.about-you-accordion .card .card-header .btn,
.your-core-expenses-accordion .card .card-header .btn,
.your-core-expenses-accordion
  .card
  .cust-core-expense-accordion
  .card
  .card-header
  .btn,
.personalization-accordion .card .card-header .btn,
.personalization-accordion
  .card
  .core-expense-accordion
  .card
  .card-header
  .btn,
.personalization-accordion
  .card
  .other-expense-accordion
  .card
  .card-header
  .btn,
.personalization-accordion
  .card
  .eliminate-category-accordion
  .card
  .card-header
  .btn,
.budget-chart-accordion .card .card-header .btn,
.peer-chart-accordion .card .card-header .btn,
.result-detail-accordion .card .card-header .btn,
.result-detail-accordion .card .budget-chart-accordion .card .card-header .btn,
.result-detail-accordion .card .peer-chart-accordion .card .card-header .btn,
/* .cash-flow-health-accordion .card .card-header .btn, */
.frequently-questions-accordion .card .card-header .btn,
.frequently-questions-accordion .card .faq-accordion .card .card-header .btn,
.accordion-collapsed
  .card
  .accordion-collapsed
  .card
  .card-header
  .btn.collapsed,
.modal-piechart-accordion .card .modal-piechart .card-header .btn {
  background-color: #ddd;
  border: 1px solid #ddd;
  color: #000;
  font-weight: 600;
  transition: color 0.15s ease-in-out;
}
.darkmode .result-summery-accordion .card .card-header .btn,
.darkmode .about-you-accordion .card .card-header .btn,
.darkmode .your-core-expenses-accordion .card .card-header .btn,
.darkmode
  .your-core-expenses-accordion
  .card
  .cust-core-expense-accordion
  .card
  .card-header
  .btn,
.darkmode .personalization-accordion .card .card-header .btn,
.darkmode
  .personalization-accordion
  .card
  .core-expense-accordion
  .card
  .card-header
  .btn,
.darkmode
  .personalization-accordion
  .card
  .other-expense-accordion
  .card
  .card-header
  .btn,
.darkmode
  .personalization-accordion
  .card
  .eliminate-category-accordion
  .card
  .card-header
  .btn,
.darkmode .budget-chart-accordion .card .card-header .btn,
.darkmode .peer-chart-accordion .card .card-header .btn,
.darkmode .result-detail-accordion .card .card-header .btn,
.darkmode
  .result-detail-accordion
  .card
  .budget-chart-accordion
  .card
  .card-header
  .btn,
.darkmode
  .result-detail-accordion
  .card
  .peer-chart-accordion
  .card
  .card-header
  .btn,
/* .darkmode .cash-flow-health-accordion .card .card-header .btn, */
.darkmode .frequently-questions-accordion .card .card-header .btn,
.darkmode
  .frequently-questions-accordion
  .card
  .faq-accordion
  .card
  .card-header
  .btn,
.darkmode
  .accordion-collapsed
  .card
  .accordion-collapsed
  .card
  .card-header
  .btn.collapsed,
.darkmode
  .modal-piechart-accordion
  .card
  .modal-piechart
  .card
  .card-header
  .btn,
.darkmode
  .modal-piechart-accordion
  .card
  .modal-piechart
  .card
  .card-header
  .btn.collapsed,
.darkmode .spacediv .card .card-header .btn {
  background-color: #f3ede1;
  border: solid 2px #d3bb8e;
  color: #000;
}
.result-summery-accordion .card .card-header .btn,
.about-you-accordion .card .card-header .btn,
.your-core-expenses-accordion .card .card-header .btn,
.personalization-accordion .card .card-header .btn,
.result-detail-accordion .card .card-header .btn,
.budget-chart-accordion .card .card-header .btn,
.peer-chart-accordion .card .card-header .btn,
/* .cash-flow-health-accordion .card .card-header .btn, */
.frequently-questions-accordion .card .card-header .btn,
.accordion-collapsed .card .accordion-collapsed .card .card-header .btn,
/* .modal-piechart-accordion .card .card-header .btn, */
.spacediv .card .card-header .btn {
  background-color: #f3ede1;
  border: solid 2px #d3bb8e;
  color: #000;
}
.other-expense-accordion .card .card-header .btn {
  background-color: #d3bb8e !important;
  border: 1px solid #d3bb8e !important;
  color: #000 !important;
}
.darkmode .other-expense-accordion .card .card-header .btn {
  background-color: #d3bb8e !important;
  border: 1px solid #d3bb8e !important;
  color: #000 !important;
}
.darkmode .result-summery-accordion .card .card-header .btn,
.darkmode .about-you-accordion .card .card-header .btn,
.darkmode .your-core-expenses-accordion .card .card-header .btn,
.darkmode .personalization-accordion .card .card-header .btn,
.darkmode .result-detail-accordion .card .card-header .btn,
.darkmode .budget-chart-accordion .card .card-header .btn,
.darkmode .peer-chart-accordion .card .card-header .btn,
/* .darkmode .cash-flow-health-accordion .card .card-header .btn, */
.darkmode .frequently-questions-accordion .card .card-header .btn,
.darkmode
  .accordion-collapsed
  .card
  .accordion-collapsed
  .card
  .card-header
  .btn {
  background-color: #2e2b6b;
  border: 1px solid #2e2b6b;
  color: #000;
}
.result-summery-accordion .card .card-header .btn:hover,
.result-summery-accordion .card .card-header .btn:focus,
.about-you-accordion .card .card-header .btn:hover,
.about-you-accordion .card .card-header .btn:focus,
.your-core-expenses-accordion .card .card-header .btn .btn:hover,
.your-core-expenses-accordion .card .card-header .btn .btn:focus,
.cust-core-expense-accordion .card .card-header .btn:hover,
.cust-core-expense-accordion .card .card-header .btn:focus,
.personalization-accordion .card .card-header .btn:hover,
.personalization-accordion .card .card-header .btn:focus,
.your-core-expenses-accordion
  .card
  .cust-core-expense-accordion
  .card
  .card-header
  .btn.not-collapsed,
.personalization-accordion
  .card
  .core-expense-accordion
  .card
  .card-header
  .btn.not-collapsed,
.personalization-accordion
  .card
  .other-expense-accordion
  .card
  .card-header
  .btn.not-collapsed,
.personalization-accordion
  .card
  .eliminate-category-accordion
  .card
  .card-header
  .btn.not-collapsed,
.result-detail-accordion .card .card-header .btn:hover,
.result-detail-accordion .card .card-header .btn:focus,
.budget-chart-accordion .card .card-header .btn:hover,
.budget-chart-accordion .card .card-header .btn:focus,
.peer-chart-accordion .card .card-header .btn:hover,
.peer-chart-accordion .card .card-header .btn:focus,
.result-detail-accordion
  .card
  .budget-chart-accordion
  .card
  .card-header
  .btn.not-collapsed,
.result-detail-accordion
  .card
  .peer-chart-accordion
  .card
  .card-header
  .btn.not-collapsed,
.cash-flow-health-accordion .card .card-header .btn:hover,
.cash-flow-health-accordion .card .card-header .btn:focus,
.frequently-questions-accordion .card .card-header .btn:hover,
.frequently-questions-accordion .card .card-header .btn:focus,
.frequently-questions-accordion
  .faq-accordion
  .card
  .card-header
  .btn.not-collapsed
/* .modal-piechart-accordion .card .card-header .btn:hover,
.modal-piechart-accordion .card .card-header .btn:focus  */ {
  background-color: #180f4f;
  border: 1px solid #180f4f;
  color: #000;
}
.darkmode .result-summery-accordion .card .card-header .btn:hover,
.darkmode .result-summery-accordion .card .card-header .btn:focus,
.darkmode .about-you-accordion .card .card-header .btn:hover,
.darkmode .about-you-accordion .card .card-header .btn:focus,
.darkmode .your-core-expenses-accordion .card .card-header .btn .btn:hover,
.darkmode .your-core-expenses-accordion .card .card-header .btn .btn:focus,
.darkmode .cust-core-expense-accordion .card .card-header .btn:hover,
.darkmode .cust-core-expense-accordion .card .card-header .btn:focus,
.darkmode .personalization-accordion .card .card-header .btn:hover,
.darkmode .personalization-accordion .card .card-header .btn:focus,
.darkmode
  .your-core-expenses-accordion
  .card
  .cust-core-expense-accordion
  .card
  .card-header
  .btn.not-collapsed,
.darkmode
  .personalization-accordion
  .card
  .core-expense-accordion
  .card
  .card-header
  .btn.not-collapsed,
.darkmode
  .personalization-accordion
  .card
  .other-expense-accordion
  .card
  .card-header
  .btn.not-collapsed,
.darkmode
  .personalization-accordion
  .card
  .eliminate-category-accordion
  .card
  .card-header
  .btn.not-collapsed,
.darkmode .result-detail-accordion .card .card-header .btn:hover,
.darkmode .result-detail-accordion .card .card-header .btn:focus,
.darkmode .budget-chart-accordion .card .card-header .btn:hover,
.darkmode .budget-chart-accordion .card .card-header .btn:focus,
.darkmode .peer-chart-accordion .card .card-header .btn:hover,
.darkmode .peer-chart-accordion .card .card-header .btn:focus,
.darkmode
  .result-detail-accordion
  .card
  .budget-chart-accordion
  .card
  .card-header
  .btn.not-collapsed,
.darkmode
  .result-detail-accordion
  .card
  .peer-chart-accordion
  .card
  .card-header
  .btn.not-collapsed,
.darkmode .cash-flow-health-accordion .card .card-header .btn:hover,
.darkmode .cash-flow-health-accordion .card .card-header .btn:focus,
.darkmode .frequently-questions-accordion .card .card-header .btn:hover,
.darkmode .frequently-questions-accordion .card .card-header .btn:focus,
.darkmode
  .frequently-questions-accordion
  .faq-accordion
  .card
  .card-header
  .btn.not-collapsed
/* .darkmode .modal-piechart-accordion .card .card-header .btn:hover,
.darkmode .modal-piechart-accordion .card .card-header .btn:focus  */ {
  background-color: #f3ede1 !important;
  border: solid 2px #d3bb8e !important;
  color: #000;
}
.modal-piechart-accordion .card .card-header {
  background-color: transparent;
}
.your-core-expenses-accordion .card .card-header .btn,
.about-you-accordion .card .card-header .btn,
.cust-core-expense-accordion .card .card-header .btn,
.personalization-accordion .card .card-header .btn,
.frequently-questions-accordion .card .card-header .btn {
  font-size: 18px;
  font-weight: 600;
}
.darkmode .modal-piechart-accordion .card .card-header .btn
/* .cash-flow-health-accordion .card .card-header .btn, */
/* .darkmode .modal-piechart-accordion .card .card-header .btn:hover,
.cash-flow-health-accordion .card .card-header .btn.btn:hover{ */ {
  background-color: #f3ede1 !important;
  border: solid 2px #d3bb8e !important;
  color: #000;
}
.modal-piechart-accordion .card .card-header .btn {
  font-size: 14px;
}
.your-core-expenses-accordion .card .card-header .btn,
.about-you-accordion .card .card-header .btn,
.cust-core-expense-accordion .card .card-header .btn,
.personalization-accordion .card .card-header .btn,
.cash-flow-health-accordion .card .card-header .btn {
  text-align: left;
}
.cash-flow-health-accordion
  .modal-piechart
  .new-frame-card-inner
  .card-header
  .btn:focus,
.cash-flow-health-accordion
  .modal-piechart
  .new-frame-card-inner
  .card-header
  .btn:hover {
  color: #212529;
  background-color: #f8f9fa;
  border-color: #f8f9fa;
}
.darkmode
  .cash-flow-health-accordion
  .modal-piechart
  .new-frame-card-inner
  .card-header
  .btn:hover,
.darkmode
  .cash-flow-health-accordion
  .modal-piechart
  .new-frame-card-inner
  .card-header
  .btn:focus {
  color: #000;
  background-color: #1e2041;
  border-color: #1e2041;
}

/* .personalization-accordion .card .core-expense-accordion .card .card-header .btn,
.personalization-accordion .card .other-expense-accordion .card .card-header .btn,
.personalization-accordion .card .eliminate-category-accordion .card .card-header .btn, */
.result-detail-accordion .card .budget-chart-accordion .card .card-header .btn,
.result-detail-accordion .card .peer-chart-accordion .card .card-header .btn,
.frequently-questions-accordion .card .faq-accordion .card .card-header .btn
/* .modal-piechart-accordion .card .modal-piechart .card .card-header .btn */ {
  font-size: 14px;
  font-weight: 600;
}
.result-summery-accordion .card .card-header .btn,
.about-you-accordion .card .card-header .btn,
.your-core-expenses-accordion .card .card-header .btn,
.cust-core-expense-accordion .card .card-header .btn,
.personalization-accordion .card .card-header .btn,
.other-expense-accordion .card .card-header .btn,
.eliminate-category-accordion .card .card-header .btn,
.result-detail-accordion .card .card-header .btn,
.budget-chart-accordion .card .card-header .btn,
.peer-chart-accordion .card .card-header .btn,
.cash-flow-health-accordion .card .card-header .btn,
.frequently-questions-accordion .card .card-header .btn,
.faq-accordion .card .card-header .btn,
.modal-piechart-accordion .card .card-header .btn,
.new-accordin-frame .btn {
  position: relative;
}

.accordion-collapsed
  .card
  .accordion-collapsed
  .card
  .card-header
  .btn.collapsed {
  background-color: #ddd;
  border: 1px solid #ddd;
  color: #000;
  font-weight: 600;
  -webkit-transition: color 0.15s ease-in-out;
  transition: color 0.15s ease-in-out;
}
.eliminate-category-accordion .card .card-header .btn:after,
.new-accordin-frame .btn:after {
  position: absolute;
  content: "";
  font-family: "Font Awesome 5 Pro";
  font-weight: 900;
  right: 10px;
  transition: all 0.3ms;
  -webkit-transition: all 0.3ms;
}
.eliminate-category-accordion .card .card-header .btn:after,
.new-accordin-frame .btn:after {
  content: "\F078";
}
.eliminate-category-accordion .card .card-header .btn.collapsed:after,
.new-accordin-frame .btn.collapsed:after {
  content: "\F077";
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
}

.new-accordin-frame .btn::after,
.new-accordin-frame .not-collapsed::after {
  top: 0;
  right: 10px;
}
.darkmode .new-accordin-frame .btn::after,
.darkmode .new-accordin-frame .not-collapsed::after {
  color: #000;
}
.new-accordin-frame .eliminate-category-accordion .card .btn::after {
  top: initial;
}
.result-summery-accordion .card .card-header .not-collapsed::after,
.cash-flow-health-accordion
  .card
  .budget-chart-accordion
  .card-header
  .btn::after,
.cash-flow-health-accordion
  .card
  .peer-chart-accordion
  .card-header
  .btn::after,
.modal-piechart-accordion .card .card-header .btn::after,
.new-frame-card .btn.add-income-src::after {
  display: none;
}

.cash-flow-health-accordion .card .card-header .btn::after,
.cat-comps .card .btn::after,
.new-accordin-frame .orderby .btn:after,
.new-accordin-frame .sortby .btn:after,
.new-accordin-frame .legends .btn:after,
.new-accordin-frame .order-filter .btn:after {
  display: none;
}

.darkmode .card {
  background-color: #1c1d21;
}
.darkmode .card .budget-tables .card .cat-comps .card,
.darkmode .eliminate-category-accordion .el-card .card,
.darkmode .budget-chart-accordion .card,
.darkmode .peer-chart-accordion .card,
.darkmode .faq-accordion .card .card-body,
.darkmode .modal-piechart-accordion .card .modal-piechart .card {
  background-color: #2a2f3b;
}
.darkmode .card .budget-tables .card .cat-comps .card .edit-budget-amount {
  background-color: #2a2f3b !important;
  border-color: #2a2f3b !important;
}
.darkmode .card .budget-tables .card .cat-comps .card .edit-budget-amount,
.darkmode .cat-comps .edit-budget-amount {
  background-color: #1c1d21 !important;
  border-color: #424242 !important;
}
.darkmode label {
  color: #fff;
}
.darkmode .category-filter label {
  color: #000;
}
.darkmode .custom-select,
.darkmode .form-control,
.darkmode .form-control[readonly],
.darkmode .form-control:hover,
.darkmode .form-control:focus,
.darkmode .address_sec .form-control,
.darkmode .income-method-inner .form-control {
  background-color: #2a2f3b;
  border: #656870 solid 2px !important;
  color: #fff;
}
.darkmode .home_income .annual-gross-input .form-control,
.darkmode .manually-input-radios .amount_data .form-control {
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  border-bottom: #734d77 solid 1px !important;
}
.darkmode .card,
.darkmode .card p,
.darkmode a.your-amount-text,
.darkmode a.your-amount-text:hover {
  color: #cecece;
  padding: 0;
  border-bottom: none;
}
.listview .cat-comps {
  -ms-flex: 0 0 100%;
  -webkit-box-flex: 100%;
  flex: 0 0 100%;
  max-width: 100%;
}
.listview .cat-comps .clr-box-btns,
.listview .cat-comps .clr-box-btns span,
.listview .cat-comps .edit-budget-amount > div {
  display: block !important;
  max-width: 100%;
  /* overflow-x: hidden; */
}
.budget-tables.listview .card .card-body .clr-bx-btn,
.budget-tables.listview .card .cat-comps .card .edit-budget-amount {
  margin: 4px 0;
}
/* .list-view .cat-comps .clr-box-btns span,
.list-view .cat-comps .edit-budget-amount > div{
  width: 100%!important;
} */
.listview .cat-comps .clr-box-btns span,
.listview .cat-comps .edit-budget-amount > div {
  text-align: left !important;
}

.listview .cat-comps .edit-budget-amount .your-peers-text {
  display: none;
}

.barchart-outer {
  background-color: #e5e5e5;
  border-radius: 5px;
}
.darkmode .barchart-outer {
  background-color: #000000;
}
.darkmode .form-control,
.darkmode .custom-select,
.darkmode .form-control .check i {
  color: #fff;
}
.font-lg {
  font-size: 28px !important;
  font-weight: 600 !important;
}
.list-style li {
  list-style-type: disc;
  margin-bottom: 15px;
  font-size: 14px;
}
.columns {
  margin-top: 0rem !important;
}
.add-income-src.btn-secondary {
  background: #235d37;
  border-color: #235d37;
  border: 1px;
}
#live-demo-title {
  color: #292562;
  align-items: center;
}
.is-vertical-center {
  display: flex;
  align-items: center;
}
#powered-by-spendid {
  font-family: "Tahoma";
}
#powered-by-spendid img {
  height: 60px;
}
#donut-chart-title {
  font-family: "Tahoma";
  color: #292562;
}
#bar-chart-title {
  font-family: "Tahoma";
  color: #292562;
  margin-left: 1.5rem;
}
.logo img {
  height: 100px;
}
#live-demo {
  padding: 15px 0;
  background-color: #d9d9d9;
  /* min-height: calc(100vh - 0px); */
  min-height: 100vh;
  width: 100%;
  margin-left: auto;
  margin-top: 130px;
  /* border-bottom: #8acfba solid 30px;
  border-left: #8acfba solid 30px;
  border-right: #8acfba solid 30px; */
}
@media only screen and (min-width: 1025px) {
  #live-demo {
    margin-top: 160px;
  }
}
.darkmode #live-demo,
.darkmode {
  background-color: #23242a;
}
.readonly-input {
  cursor: pointer;
}
#piechart,
#piechart2,
#piechart3,
#piechart4,
#piechart5 {
  max-height: 100%;
  height: 208px;
  /* width: 208px; */
}
/* .rm-chart-watermark::after{
  content: "";
  background-color: #ffffff;
  position: absolute;
  left:0;
  bottom:0;
  width: 70px;
  height: 20px;
} */
/* #speedometer {
  height: 100px;
}  */
.comment-animation iframe::before {
  content: "";
  background-color: #ffffff;
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
}
.darkmode .rm-chart-watermark::after,
.darkmode .comment-animation iframe::before {
  background-color: #090729;
}
.btn.btn-theme {
  background-color: #235d37 !important;
  border: solid 2px #235d37 !important;
  color: #fff;
  font-weight: 600 !important;
  border-radius: 6px !important;
}
.btn.border-radius {
  border-radius: 30px !important;
}

.btn.report-btn {
  background-color: #225935 !important;
  border: solid 2px #225935 !important;
  color: #fff;
  font-size: 18px;
  padding: 6px 12px;
  font-weight: 600 !important;
  border-radius: 6px !important;
}
.btn.report-btn:hover {
  background-color: #143f23 !important;
  border: solid 2px #143f23 !important;
}
.progress_data ul li a {
  pointer-events: none;
}
.progress_data ul li.max_active a {
  pointer-events: auto;
}
.btn.btn-theme:hover {
  background-color: #143f23 !important;
  border: solid 2px #143f23 !important;
  color: #fff;
}
.btn.btn-theme-outline {
  background-color: transparent !important;
  border: solid 2px #235d37 !important;
  color: #235d37;
  font-weight: 600 !important;
  border-radius: 6px !important;
}
.btn.btn-theme-outline:hover {
  background-color: #143f23 !important;
  border: solid 2px #143f23 !important;
  color: #fff !important;
}
.btn.cross-btn {
  padding: 0;
  color: #f20;
  border: 0;
  position: absolute;
  top: 4px;
  right: 6px;
  background-color: transparent;
}
.edit-budget-amount .btn {
  text-align: left;
  font-size: 12px;
  /* background-color: #e6e6e6; */
  border: solid 1px #eee;
  color: #000;
}
.your-amount-text {
  color: #4a4a4a;
}
.your-amount-text:hover {
  text-decoration: none;
}
.add-fudget-form {
  position: relative;
}
.add-fudget-form .btn.cross-btn {
  padding: 0;
  color: #000;
  border: 0;
  position: absolute;
  top: -4px;
  right: -2px;
  background-color: transparent;
  z-index: 9;
}
.edit-budget-amount .btn:hover,
.edit-budget-amount .btn:focus {
  box-shadow: none;
  background-color: #e6e6e6;
}

.barchart-wrapper {
  height: 300px;
  /* overflow: scroll; */
}
.shadow-none {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
.border-none {
  border: none !important;
}
#barchart,
#chartdiv {
  width: 100%;
  height: 300px;
}
#barchart {
  font-size: 14px;
}
#demographics-box {
  background-color: #73b9ad;
  color: white;
}
#demographics-box .title {
  font-family: "Tahoma";
  font-size: 1.7rem;
}
#homeowner-dropdown:after {
  border-color: #b5b5b5;
}
#expenses-box {
  background-color: #180f4f;
  color: white;
}
#expenses-box label {
  color: white;
}
#expenses-box .title {
  font-family: "Tahoma";
  font-size: 1.7rem;
}
#savings-box {
  background-color: #180f4f;
  color: white;
}
#savings-box label {
  color: white;
}
.zIndex1 {
  z-index: 2;
}
#savings-box .title {
  font-family: "Tahoma";
  font-size: 1.7rem;
}
.is-grade-a-plus {
  background-color: #235d37;
  color: #fff;
  border-radius: 5px;
}
.is-grade-a {
  background: #6e9277;
  color: #000;
}
.is-grade-a-minus {
  background: #80d785;
  color: #000;
}
.is-grade-b-plus {
  background: #bfda6e;
  color: #000;
}
.is-grade-b {
  background: #ffdd57;
  color: #000;
}
.is-grade-b-minus {
  background: #ffb459;
}
.is-grade-c {
  background: #ff8b5c;
  color: #000;
}
.is-grade-d {
  background: #ff615e;
  color: #000;
}
.is-grade-f {
  background: #ff3860;
  color: #000;
}

.tooltip {
  z-index: 5;
}
.modal-title {
  font-size: 30px;
}
.bigsize h4 {
  font-size: 44px;
}

/* .tooltip .tooltip-inner {
  text-align: left;
  color: #000;
  font-size: 14px;
  border-radius: 5px;
  padding: 20px;
  max-width: 550px;
  background: #fff;
  -webkit-box-shadow: 0 3px 14px rgb(0 0 0 / 10%);
  box-shadow: 0 3px 14px rgb(0 0 0 / 10%);
}
#scores-modal .modal-background {
  background: transparent;
}
#scores-modal .modal-content .box {
  background: #6181a6;
  color: white;
  font-size: 1.5rem;
  padding: 24px;
}
.tooltip.score-description .tooltip-inner {
  max-width: 500px;
}
.tooltip.popover .popover-inner {
  background: #6181a6;
  color: white;
  font-size: 1.25rem;
  padding: 24px;
  border-radius: 5px;
  max-width: 650px;
  box-shadow: 0 5px 30px rgba(black, 0.1);
}
.tooltip.popover .popover-arrow {
  border-color: #f9f9f9;
}
.tooltip[aria-hidden="true"] {
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.15s, visibility 0.15s;
}
.tooltip[aria-hidden="false"] {
  visibility: visible;
  opacity: 1;
  transition: opacity 0.15s;
}*/
.button.is-dark-button {
  background: #292562;
  color: white;
}
.button.is-dark-button:hover {
  color: white;
}
.dropdown > .dropdown-trigger > button.is-dark-button {
  color: white;
}
.dropdown-item {
  font-size: 1.25rem;
}
.dropdown-item.is-active {
  background: #292562;
}
.bar-chart-title-bar {
  justify-content: space-evenly;
}
.category-select {
  direction: rtl;
}
.category-option {
  direction: ltr;
}
.orderby .btn.active,
.orderby .btn.active:hover,
.orderby .btn.active:focus {
  background-color: #235d37 !important;
  border-color: #235d37 !important;
}
.negative-bg,
.darkmode .negative-bg {
  background-color: crimson;
  border-color: crimson !important;
}
.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #235d37 !important;
  background-color: #235d37 !important;
}
.btn.clear-sm {
  font-size: 10px;
  padding: 2px 6px;
  float: right;
  margin-left: 12px;
}
.btn.cursor-auto {
  cursor: auto !important;
}
.btn-light:not(:disabled):not(.disabled):active:focus,
.btn-light:focus,
.btn-light.focus,
.btn-secondary:focus,
.btn-secondary.focus,
.btn-light.cursor-auto:not(:disabled):not(.disabled):active:focus {
  box-shadow: none !important;
}
.monthlybig {
  font-size: larger;
  font-weight: 700;
}
.relative_peer {
  position: relative;
}
.darkmode button.collpase-center.collapsed p {
  color: #fff;
}
button.collpase-center.collapsed p {
  margin-bottom: 0px;
  display: inline-block;
  color: #000;
}
button.collpase-center.collapsed span.absolute_peer {
  display: none;
}
button.collpase-center span.absolute_peer {
  display: inline-block;
  position: relative;
  left: initial;
  transform: initial;
}
button.collpase-center > p {
  display: none;
}
span.absolute_peer {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0px);
}
body .btn-next-new {
  background-color: #235d37;
  border: 2px solid #235d37;
  font-weight: 600;
  border-radius: 6px;
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translate(-50%, 0%);
}
body .btn-next-new2 {
  background-color: #235d37;
  border: 2px solid #235d37;
  font-weight: 600;
  border-radius: 6px;
  bottom: 20px;
  transform: translate(-50%, 0%);
}

@media all and (max-width: 767px) {
  #piechart {
    height: 210px;
  }
  .darkmode .theme-change-mode,
  .theme-change-mode {
    top: 3px !important;
  }
  .btn.clear-sm {
    margin-left: 0px;
  }
  body .btn-next-new {
    position: relative;
    left: initial;
    transform: initial;
    bottom: initial;
  }

  span.absolute_peer {
    position: relative;
    display: block;
  }
  .relative_peer button::after {
    top: 10px;
  }
  body .btn-next-new2 {
    transform: initial;
  }
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
.step-slider
  .vue-slider-mark:nth-last-of-type(1)
  .vue-slider-mark-label:last-child:after {
  content: "+";
}
input,
select {
  font-weight: bold !important;
}
.darkmode input,
.darkmode select {
  font-weight: initial !important;
}
.send_otp {
  position: absolute;
  right: 0;
  font-size: 13px;
  font-weight: bold;
  cursor: pointer;
}
#speedometer g[font-size*="32"] > g {
  display: none;
}
.visible-md,
.hidden-md {
  display: block;
}
@media only screen and (min-width: 991px) {
  .visible-md {
    display: inline-block !important;
  }
  .hidden-md {
    display: none !important;
  }
}
@media only screen and (max-width: 992px) {
  .visible-md {
    display: none !important;
  }
  .hidden-md {
    display: inline-block !important;
  }
}
@media screen and (max-width: 1024px) {
  .newtabs_spendid .tabs .card-header .nav-tabs li.nav-item:last-child {
    border: none !important;
  }

  .newtabs_spendid .tabs {
    z-index: 0 !important;
  }
  /* .b-sidebar-outer {
    z-index: 999999 !important;
  }
  .toggle-wrap {
    display: block;
  }
  .toggle-wrap a {
    height: 70px;
    width: 60px;
    background: #fff;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: flex-end;
    border-radius: 10px;
    position: absolute;
    left: -50px;
    top: -50px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  } */
  .hover-info-box .hover-info {
    width: 450px;
  }
  /* .toggle-wrap {
    z-index: 1049;
    position: relative;
  }
  .toggle-wrap a img.img-fluid {
    z-index: 1049;
    height: 50px;
    width: 50px;
    object-fit: contain;
    position: relative;
    right: -6px;
  } */
  .score-number .spending-score {
    font-size: 16px;
    text-align: center;
  }
  .score-title {
    font-size: 14px;
  }
  .result-summery-accordion .card .card-body {
    padding: 0.8rem;
  }
  .predicted-score {
    background-color: #f5f5f5;
  }
  .darkmode .predicted-score {
    background-color: #1e2041;
  }
  .predicted-score {
    margin: 20px 0;
    padding: 20px;
    text-align: center;
  }
}
@media screen and (max-width: 767px) {
  #speedometer {
    height: 140px;
  }
  /* .report-btn {
    display: none !important;
  } */
  /* .predicted-score{
    background-color: #1E2041;
    margin: 20px 0;
    padding: 20px;
    text-align: center;
  } */
  .predicted-score .score-number {
    display: inline-block;
  }
  .predicted-score .score-title {
    justify-content: center;
  }
  .h-100 {
    height: auto !important;
  }
  .card-body {
    padding: 0.6rem !important;
  }
  .login-modal {
    width: 94%;
  }
  .cat-edit-disable {
    font-size: 14px;
  }
  #live-demo {
    margin-top: 50px !important;
    padding: 10px 0;
    width: 100%;
  }
  /* .custom-control.custom-switch .custom-control-label {
    font-size: 13px;
  } */
  .hover-info-box .position-right {
    right: inherit;
  }
  .action-tools {
    display: flex;
  }
  .action-tools .btn {
    -ms-flex: 1 1 !important;
    -webkit-box-flex: 1 !important;
    flex: 1 1 !important;
  }
  .custom_tabs .nav-tabs .nav-link,
  .custom_tabs .tabs ul {
    display: block !important;
    margin-right: 0;
  }
  .custom_tabs .tab-content .tab-pane .active {
    display: none;
  }
  .modal-content,
  .modal-card {
    margin: 0 0 !important;
  }
  .faq-accordion .card .card-body {
    padding: 0.8rem 0;
  }
  .custom_tabs .nav-tabs {
    margin-top: 0;
  }
  .hover-info-box {
    position: initial;
  }
  .unneeded-summery,
  .score-information {
    padding: 10px;
  }
  .hover-info-box .hover-info {
    top: 40px;
    left: 0;
    width: 100%;
  }
  .your-core-expenses-accordion .card .card-header .btn,
  .about-you-accordion .card .card-header .btn,
  .cust-core-expense-accordion .card .card-header .btn,
  .personalization-accordion .card .card-header .btn,
  .chrdhead,
  .rec-cat a,
  .score-information h4,
  .card .card-header .btn,
  .chrdhead-edit h4,
  .frequently-questions-accordion .card .card-header .btn,
  .modal-piechart-accordion .card .card-header .btn,
  .your-core-expenses-accordion
    .card
    .cust-core-expense-accordion
    .card
    .card-header
    .btn {
    font-size: 15px;
  }
  .your-core-expenses-accordion > .card > .card-header > .btn,
  .about-you-accordion > .card > .card-header > .btn,
  .other-expense-accordion .card .card-header .btn,
  .personalization-accordion > .card > .card-header > .btn {
    padding: 0.375rem 2rem;
  }
  .ht-number {
    position: absolute;
    top: 8px;
    left: 5px;
  }
  .unneeded-summery ul li,
  .ht-number {
    font-size: 14px;
  }
  .unneeded-summery ul li .info-text {
    margin-left: 30px;
    margin-top: 6px;
  }
  .unneeded-summery .ht-number {
    left: 0;
  }
  .font-lg {
    font-size: 16px !important;
  }
  .faq-accordion .card .card-body p,
  .list-style li,
  #barchart,
  .score-information p,
  .frequently-questions-accordion .card .faq-accordion .card .card-header .btn {
    font-size: 13px;
  }
  .ht-number {
    width: 20px;
    height: 20px;
  }
}
* {
  box-sizing: border-box;
}
img {
  max-width: 100%;
}

.width-400 input {
  width: 400px;
}
.debt-list li {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.darkmode .question_answer .debt-list .form-control::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #fff;
  opacity: 1; /* Firefox */
}

.darkmode .question_answer .debt-list .form-control::-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #fff;
}

.darkmode .question_answer .debt-list .form-control::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #fff;
}

.debt-list li span {
  font-size: 21px;
}
.darkmode .debt-list li span {
  color: #fff;
}
@media all and (min-width: 768px) and (max-width: 1350px) {
  .mobile-width {
    max-width: 900px !important;
  }
  p.fixedstartbtn {
    display: none;
  }
}

@media all and (max-width: 900px) {
  .width-400 input {
    width: 100%;
  }
  .debt-list li {
    display: block;
    margin-top: 20px;
  }
  .absolute-in-mobile {
    position: absolute;
    left: 50%;
    transform: translate(-50%, 0px);
  }
  .budgetabsolute {
    position: absolute;
    left: 50%;
    top: -28px;
    transform: translate(-50%, 0px);
  }
  .mobile-flex-here {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}

/*.container {
  max-width: 1200px !important;
  padding: 0 15px;
} */
/*.row{
  margin:0 -15px;
  margin-bottom:0px !important;
} */
/*.custom_tabs{
  margin-bottom: 25px;
  display: flex;
  flex-wrap: wrap;
  display: -webkit-flex;
  -webkit-flex-wrap: wrap;
  width: 100%;
} */
#feedbackIframe {
  width: 100%;
  height: 450px;
}
.pr-30 {
  padding-right: 30px !important;
}
.theme-color-btn {
  background-color: #235d37 !important;
  border: solid 2px #235d37 !important;
}
.no-result .action-btns .r-btn {
  background: gray !important;
  pointer-events: none !important;
  border-color: gray !important;
}
.no-result #cash-flow-health {
  /* display: none; */
}

.step_form_area {
  position: fixed;
  z-index: 999;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: #f5f5f5;
  /* background-image: url("../public/large.jpg"); */
  background-position: center top;
  background-size: cover;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  -webkit-justify-content: center;
  align-items: flex-start;
  -webkit-align-items: flex-start;
  align-content: flex-start;
  -webkit-align-content: flex-start;
  flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  overflow-y: scroll;
}
.darkmode .step_form_area {
  background-color: #23242a;
}
.step_form_area::-webkit-scrollbar {
  height: 2px;
  width: 2px;
}
.step_form_area::-webkit-scrollbar-track {
  background: #7c858d;
  border-radius: 100px;
}
.step_form_area::-webkit-scrollbar-thumb {
  background: rgb(58, 183, 164);
  border-radius: 100px;
}
.logo_area {
  position: relative;
  padding: 15px;
}
.logo_area img {
  max-width: 73px;
}
span.press {
  margin-left: 10px;
  text-transform: capitalize;
  font-size: 13px;
  font-weight: 500;
  /*position: absolute;
  right: calc(50% - 147px);
  top: 54%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);*/
}
.darkmode span.press {
  color: #fff;
}
#cash-flow-score {
  max-width: 1100px !important;
}
button.cta {
  box-shadow: rgb(0 0 0 / 10%) 0px 3px 12px 0px;
  padding: 8px 18px;
  min-height: 48px;
  background-color: #235d37;
  color: rgb(255, 255, 255);
  border-radius: 4px;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 22px;
  border: none;
}
button.cta:hover {
  background-color: #235d37;
}
button.cta:active {
  background-color: #235d37 !important;
}
<!-- button.cta.cta_icons i {
  font-weight: 300;
} -->
button.cta.cta_icons + span.press {
  right: initial;
  left: 114px;
  margin-left: 0px;
  top: 50%;
}
.time_duration {
  margin-top: 14px;
  align-items: center;
  -webkit-align-items: center;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  -webkit-justify-content: center;
  font-size: 20px;
}
.darkmode .time_duration {
  color: rgba(255, 255, 255, 0.7);
}
.question {
  display: flex;
  display: -webkit-flex;
  position: relative;
}
.question h5 {
  margin-bottom: 0px;
  padding-left: 0;
  position: relative;
  font-size: 32px;
  margin-top: 0px;
  font-weight: 400;
  margin-left: 0px;
}
.question span {
  display: block;
  border-radius: 100px;
  margin-right: 7px;
  text-align: center;
  line-height: 37px;
  position: absolute;
  left: -54px;
}
.darkmode .question h5,
.darkmode .question span {
  color: white;
}
.question h5::after {
  content: "";
  width: 10px;
  height: 2px;
  background: #2e2b6b;
  position: absolute;
  left: -31px;
  top: 17px;
}
.question h5::before {
  content: "";
  width: 10px;
  height: 10px;
  border-right: 2px solid #2e2b6b;
  border-bottom: 2px solid #2e2b6b;
  position: absolute;
  left: -31px;
  transform: rotate(-45deg);
  top: 13px;
}

.darkmode .question h5::before {
  border-color: #fff;
}
.darkmode .question h5::after {
  background: #fff;
}
.question_answer.animation_disable.combine_questions,
.question_answer.disable-animation-effect {
  animation: none;
}
.question_answer {
  -webkit-animation-name: fadeInUpBig;
  animation-name: fadeInUpBig;
  -webkit-animation-duration: 0.5s;
  animation-duration: 0.5s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
@media (max-width: 767px) {
  .question_answer {
    animation: none;
  }
}

@-webkit-keyframes fadeInUpBig {
  0% {
    opacity: 0;
    -webkit-transform: translateY(2000px);
  }
  100% {
    opacity: 1;
    -webkit-transform: translateY(0);
  }
}

@keyframes fadeInUpBig {
  0% {
    opacity: 0;
    transform: translateY(2000px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
.question_answer .form-control {
  height: 60px;
  font-size: 28px;
  background: transparent !important;
  border: none !important;
  border-bottom: 1px solid #734d77 !important;
  border-radius: 0px !important;
  font-weight: 400 !important;
  padding: 0px !important;
}
.question_answer .amount_data .form-control,
.question_answer .annual-gross-input .form-control {
  font-size: 16px;
}
.darkmode .question_answer .form-control {
  color: #fff;
}
.question_answer .form-control:focus,
.question_answer .form-control:hover {
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  border-bottom: 1px solid #734d77 !important;
}
/* .side-visible {
  left: 300px;
} */
.question_answer .form-control::-webkit-input-placeholder {
  color: #6b4d74;
}
.question_answer .form-control::input-placeholder {
  color: #6b4d74;
}
.question h5 p {
  font-size: 17px;
  margin: 11px 0 0;
  opacity: 0.8;
}
.prev_next {
  display: flex;
  justify-content: flex-end;
  display: -webkit-flex;
  -webkit-justify-content: flex-end;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 20px;
}
.prev_next button {
  background: #3ab6a3;
  border: none;
  font-size: 23px;
  padding: 0 11px;
  color: #fff;
  border-radius: 3px;
  border-radius: 3px 0 0 3px;
}
.prev_next button:hover {
  background: #77c0b9;
}
.prev_next button + button {
  border-left: 1px solid #51dbcd !important;
  border-right: none !important;
  border-radius: 0 3px 3px 0;
}
.radio_part {
  margin: 8px 0;
  max-width: 200px;
  position: relative;
  z-index: 1;
}
.address_sec .custom-control {
  z-index: 0;
}
.abst {
  position: absolute;
  top: 50%;
  right: 0;
  left: 0;
  margin: 0 auto;
  text-align: center;
  bottom: 0;
  transform: translateY(-40%);
}
.radio_part .radio_label {
  width: 100%;
  margin: 8px 0;
  background-color: rgba(255, 255, 255, 0.1);
  border: 1px solid rgb(68, 68, 68);
  display: flex;
  align-items: center;
  padding: 5px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  border-radius: 5px;
  z-index: -1;
}
.darkmode .radio_part .radio_label {
  color: #fff;
}
.radio_part .radio_label:hover {
  background-color: #235d37;
}
.radio_part .radio_label:hover {
  color: #fff;
}
.radio_part .radio_label:hover span {
  color: #000;
}
.darkmode .radio_part .radio_label:hover {
  background-color: rgba(255, 255, 255, 0.3);
}
.radio_part .radio_label input[type="radio"] {
  display: none;
}
.radio_part .radio_label p {
  margin: 0;
}
.radio_part .radio_label span {
  background: rgb(245, 245, 245);
  border: 1px solid rgba(0, 0, 0, 0.6);
  width: 20px;
  height: 20px;
  text-align: center;
  border-radius: 2px;
  margin-right: 12px;
  display: flex;
  display: -webkit-flex;
  line-height: 18px;
  align-content: center;
  -webkit-align-content: center;
  justify-content: center;
  -webkit-justify-content: center;
}
.darkmode .radio_part .radio_label span {
  background: rgb(35 93 55);
  color: rgb(255, 255, 255);
  border: 1px solid rgba(35, 93, 55, 0.6);
}
.radio_part .radio_label input:checked + span {
  background: #fff;
  color: rgb(35, 2, 71);
}
.returnScore {
  position: relative;
  /* margin-top: -30px; */
  font-size: 32px;
  font-weight: 600;
  color: #000;
}
.darkmode .returnScore {
  color: #fff;
}
.radio_part .radio_label input:checked + span::after {
  content: "";
  position: absolute;
  background-color: rgba(255, 255, 255, 0.3);
  border: 1px solid #235d37;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
  border-radius: 5px;
}
.darkmode .radio_part .radio_label input:checked + span::after {
  border: 1px solid #fff;
}
.darkmode .radio_part .radio_label input:checked + span::after {
  background-color: #235d37;
  border: 1px solid #235d37;
}
.radio_part .radio_label input:checked + span::before {
  content: "";
  position: absolute;
  right: 10px;
  width: 18px;
  height: 9px;
  border-bottom: 2px solid #235d37;
  border-left: 2px solid #235d37;
  transform: rotate(-45deg);
  top: 12px;
}
.darkmode .radio_part .radio_label input:checked + span::before {
  border-bottom: 2px solid #fff;
  border-left: 2px solid #fff;
}
/* .darkmode .radio_part .radio_label input:checked + span::before {
  border-bottom: 2px solid #235d37;
  border-left: 2px solid #235d37;
} */
.step_form_area .check {
  /* font-size: 60px; */
  font-size: 26px;
  font-weight: 200;
  color: #235d37;
}
.prev_next button.disabled {
  pointer-events: none;
  opacity: 0.8;
}
.question_answer .error {
  color: #ff8585;
  margin: 10px 0;
}
.step_form_area .back_button {
  position: absolute;
  bottom: 0;
  right: 0;
  text-align: right;
  width: 200px;
}
.step_form_area .back_button button {
  margin-left: 5px;
}
button.cta.btn-sm {
  font-size: 16px;
  min-height: 27px;
  padding: 7px 16px;
}
.cursor-pointer {
  cursor: pointer;
}
#step1 {
  margin-top: 0px;
}
/* .form_block_area {
  margin: 40px 0;
} */
.progress_data {
  margin: 10px 0 70px;
}
.progress_data ul {
  margin: 0;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  overflow-x: auto;
  width: 100%;
  padding-bottom: 10px;
}
.progress_data ul::-webkit-scrollbar {
  height: 5px;
  border-radius: 100px;
}
.progress_data ul::-webkit-scrollbar-track {
  background: #d3bb8e;
  border-radius: 100px;
}
.progress_data ul::-webkit-scrollbar-thumb {
  background: #d3bb8e;
  border-radius: 100px;
}

.step-p {
  overflow-x: auto;
  padding-left: 15px;
  padding-right: 15px;
}
.step-p::-webkit-scrollbar {
  height: 5px;
  border-radius: 100px;
}
.step-p::-webkit-scrollbar-track {
  background: #7c858d;
  border-radius: 100px;
}
.step-p::-webkit-scrollbar-thumb {
  background: #235d37;
  border-radius: 100px;
}
.progress_data ul li a {
  display: block;
  padding: 15px 7px;
  text-align: center;
  white-space: nowrap;
  border: 1px solid transparent;
  text-decoration: none;
  font-size: 13px;
  padding: 5px 7px;
  border-radius: 5px 5px 5px 5px;
  width: 120px;
  position: relative;
}
.progress_data ul li a::after {
  content: "";
  width: 30px;
  height: 30px;
  background: #235d37;
  position: absolute;
  top: 35%;
  left: 50%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  border-radius: 100px;
}
.progress_data ul li a::before {
  content: "";
  width: 14px;
  height: 7px;
  border-bottom: 2px solid #fff;
  border-left: 2px solid #fff;
  position: absolute;
  top: 34%;
  z-index: 9;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-45deg);
  -webkit-transform: translate(-50%, -50%) rotate(-45deg);
}
.progress_data ul li a span {
  width: 100%;
  display: block;
  opacity: 0.3;
}
.progress_data ul li a {
  color: #000;
}
@media only screen and (max-width: 1180px) {
  .progress_data ul {
    justify-content: center;
  }
  .progress_data ul li a {
    width: 92px;
  }
}
@media only screen and (max-width: 767px) {
  .progress_data ul {
    justify-content: flex-start;
  }
}
.darkmode .progress_data ul li a span,
.darkmode .progress_data ul li a {
  color: #fff;
}
.progress_data ul li a div {
  max-width: 35px;
  height: 35px;
  margin: 0 auto 5px;
  opacity: 0.3;
}
.progress_data ul li a div img {
  max-width: 100%;
  height: 100%;
  object-fit: contain;
}

.progress_data ul li a:hover,
.progress_data ul li.active a {
  background: #235d37;
}
.progress_data ul li.active a span {
  color: #fff;
}
.progress_data ul li a:hover span,
.progress_data ul li a:hover div,
.progress_data ul li.active a span,
.progress_data ul li.active a div {
  opacity: 1;
}
.progress_data ul li.active a::after,
.progress_data ul li.active a::before,
.progress_data ul li.active ~ li a::after,
.progress_data ul li.active ~ li a::before,
.progress_data ul li a:hover::after,
.progress_data ul li a:hover::before {
  display: none;
}
.question_answer.combine_questions {
  margin-top: -80px !important;
}

/* .total_monthly_inc {
  font-size: 28px;
  font-weight: 400;
  text-align: right;
} */
.darkmode .total_monthly_inc {
  color: #fff;
}
.total_monthly_inc span {
  display: inline-block;
  width: 120px;
  margin-left: 10px;
}
.all_radio_parts {
  display: grid;
  grid-template-columns: 24% 24% 24% 24%;
  grid-column-gap: 14px;
}
.all_radio_parts .radio_part {
  width: 100%;
  max-width: 100%;
}
.all_radio_parts .radio_part .tagline,
.all_radio_parts .radio_part .tagline h6 {
  font-size: 20px;
  margin-bottom: 15px;
}
.all_radio_parts .radio_part .amount_data {
  margin-top: 20px;
}
.all_radio_parts .radio_part .amount_data h4 {
  font-size: 20px;
}
.darkmode .all_radio_parts .radio_part .tagline,
.darkmode .all_radio_parts .radio_part .tagline h6,
.darkmode .all_radio_parts .radio_part .amount_data h4 {
  color: #fff;
}
.all_radio_parts .radio_part .amount_data input {
  font-size: 18px;
  height: 45px;
}
.all_radio_parts .radio_part .add_more_data {
  position: absolute;
  top: 70px;
  bottom: 96px;
  right: 0;
  left: 0;
  background: #fff;
  border: 1px solid rgb(68, 68, 68);
  display: flex;
  align-items: center;
  justify-content: center;
  display: -webkit-flex;
  -webkit-align-items: center;
  -webkit-justify-content: center;
  flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  align-content: center;
  -webkit-align-content: center;
  cursor: pointer;
  border-radius: 5px;
}
.darkmode .all_radio_parts .radio_part .add_more_data {
  background: #393a40;
  border: 1px solid rgb(68, 68, 68);
}
.all_radio_parts .radio_part .add_more_data i {
  font-size: 30px;
  padding: 0;
  border-radius: 100px;
  border: 2px solid #235d37;
  color: #235d37;
  width: 70px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  display: -webkit-flex;
  -webkit-align-items: center;
  -webkit-justify-content: center;
}
@media screen and (max-width: 767px) {
  .all_radio_parts .radio_part .add_more_data {
    position: relative;
    padding: 10px;
    top: 0;
    bottom: 0;
  }
  /* .all_radio_parts .radio_part .add_more_data i {
    font-size: 24px;
    width: 40px;
    height: 40px;
  } */
}
.all_radio_parts .radio_part .add_more_data i {
  border: 1px solid #235d37;
  color: #235d37;
}
.all_radio_parts .radio_part .add_more_data h6 {
  display: block;
  width: 100%;
  text-align: center;
  font-size: 20px;
  margin-top: 20px;
}
.darkmode .all_radio_parts .radio_part .add_more_data h6 {
  color: #fff;
}
.all_radio_parts .radio_part .add_more_data ~ * {
  opacity: 0.1;
  pointer-events: none;
}
#instructionModal .modal-header {
  align-items: center;
  -webkit-align-items: center;
  padding: 10px;
}
#instructionModal .modal-header h5 {
  font-size: 24px;
}
#instructionModal .modal-header .close {
  margin: 0;
  padding: 0;
  font-size: 33px;
  font-weight: 400;
}
#instructionModal .modal-body p {
  line-height: 30px;
}
#instructionModal .modal-body p i {
  color: red;
  cursor: pointer;
  margin: 0 10px;
}
#instructionModal .modal-dialog {
  margin: 134px auto;
}
#instructionModal .modal-content {
  border-radius: 50%;
  background: linear-gradient(to right, #0da4a2, #19e1de);
}
#instructionModal .modal-content button {
  border: 4px solid #2e2b6b;
}
/* .form-control.dis{
  background-color: #090729 !important;
} */

/* december-css */
.backhome,
.backhome:hover {
  background: #0da4a2;
  color: #fff;
  padding: 8px 14px;
  margin-bottom: 0;
  border-radius: 4px;
  position: fixed;
  left: 20px;
  top: 20px;
}
.tutorial_bg {
  position: absolute;
  left: 0;
  margin-top: 35px;
  width: 500px;
  height: auto;
  z-index: 999999;
  background: #fff;
  text-align: right;
  transition: 0.2s;
}
.onboardhide {
  background: #3ab7a4;
  display: block;
  position: absolute;
  right: -110px;
  border: none;
  border-radius: 0 10px 10px 0px;
  top: 35%;
  max-width: 120px;
}

.fixedtutorial_bg {
  position: relative;
  left: 0;
  top: 0;
  width: auto;
  height: auto;
  z-index: 999999;
  text-align: right;
}
.tutorial_bg.toggle {
  width: 0px;
  transition: 0.2s;
}
.popbudgetstyle .hover-icon i {
  font-size: 40px;
}
.popbudgetstyle .hover-icon,
.popbudgetstyle .hover-icon:hover {
  background: transparent;
  border: transparent;
}
.popstyle i.teal-color {
  font-size: 16px;
  font-weight: 800;
}
button.budgetblock {
  height: 58px;
}
.get_advice_btn {
  position: absolute !important;
  left: 50%;
  -webkit-transform: translateX(-50%);
  -moz-transform: translateX(-50%);
  transform: translateX(-50%);
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 21px !important;
  padding: 0.25rem 0.5rem !important;
}
@media only screen and (max-width: 767px) {
  button.budgetblock {
    height: auto;
  }
  .download_as_pdf {
    display: none !important;
  }
}
button.budgetblock span {
  text-align: left;
  line-height: 18px;
  font-size: 15px;
  font-weight: 600;
}
.popstyle .btn.questionsize {
  padding: 0px;
}
.popover-body {
  font-size: 28px;
}
.popstyle .btn.questionsize i,
.hover-info-box .hover-icon {
  font-size: 22px;
}
/* end-december-css */

/* november-css */
.hnavigate {
  font-weight: 700;
  color: #000;
  text-align: center;
  padding-top: 15px;
  padding-bottom: 8px;
}
.darkmode .hnavigate {
  color: #fff;
}

.fa-check-circle.bright {
  color: green !important;
}
.grade-score-info .hover-icon i {
  font-size: 40px;
}
.tab-content > .active div#other-expense-accordion-2 {
  display: block !important;
}

.big-font h4 {
  font-size: 40px;
  color: #000;
}
.big-font h4.text-small {
  font-size: 20px;
}
/* .spacediv {
  background: #fff;
  padding: ;
  border-radius: 5px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 16%);
}
.darkmode .spacediv {
  background: #1e2040;
}
.darkmode .spacediv .card {
  background-color: #090729;
} */
.darkmode .big-font h4 {
  color: #fff;
  font-size: 40px;
}
.darkmode .big-font h4.text-small {
  font-size: 20px;
}

.title-result {
  color: #000;
  font-size: 1.5rem;
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 5px;
  background-color: #e6d6b8;
  width: 100%;
}

/* .darkmode .title-result {
  color: #fff;
} */
/* .title-result span {
  background: #235d37;
  width: 40px;
  height: 40px;
  display: inline-block;
  margin-right: 16px;
  position: relative;
}
.title-result span::after {
  content: "";
  display: block;
  width: 30px;
  background: #fff;
  right: -1px;
  bottom: 0;
  top: 0;
  position: absolute;
  clip-path: polygon(50% 50%, 100% 100%, 100% 0);
} */
/* .darkmode .title-result span::after {
  content: "";
  display: block;
  width: 30px;
  background: #1d1f3f;
  right: -1px;
  bottom: 0;
  top: 0;
  position: absolute;
  clip-path: polygon(50% 50%, 100% 100%, 100% 0);
} */
.newtabs_spendid .tabs {
  all: inherit;
  display: none;
}
.delete-spendid {
  background: #f20019;
  border-radius: 100px;
  padding: 2px 15px;
}

.newtabs_spendid .tab-content {
  background: #fff;
  padding: 0px;
  box-shadow: 0 4px 10px rgb(0 0 0 / 16%);
  margin-top: 36px;
}
.newtabs_spendid .tab-content .card-body {
  padding: 16px;
  background: #fff;
  border: #ccc solid thin;
}
.darkmode .newtabs_spendid .tab-content {
  background: #1d1f3f;
}
.darkmode .newtabs_spendid .tab-content .card-body {
  background: #090729;
  border: #2e2b6b solid thin;
}
.newtabs_spendid .tabs .card-header {
  padding: 0px 10px 10px 10px;
}
.newtabs_spendid .tabs .card-header .nav-tabs {
  border-bottom: none;
  flex-shrink: 0;
  display: flex;
  align-items: inherit;
  width: 100%;
  background: #235d37;
}
.newtabs_spendid .tabs .card-header .nav-tabs {
  /* position: fixed; */
  z-index: 9;
  width: 100%;
  max-width: 1067px;
  top: 110px;
}
.newtabs_spendid .tabs .card-header .nav-tabs li.nav-item {
  flex: 1;
  margin-right: 0;
  border-right: 2px solid transparent;
}
.newtabs_spendid .tabs .card-header .nav-tabs li.nav-item:last-child {
  margin-right: 0px;
  border-right: 2px solid #303360;
}
.newtabs_spendid .tabs .card-header .nav-tabs li.nav-item .nav-link,
.newtabs_spendid .tabs .card-header .nav-tabs li.nav-item .nav-link:hover {
  color: #fff;
  border-radius: 0;
  border: none;
  font-size: 19px;
  height: 100%;
  background: #303360;
  position: relative;
  padding-left: 28px;
  font-weight: 700;
}
.newtabs_spendid
  .tabs
  .card-header
  .nav-tabs
  li:not(:first-child).nav-item
  .nav-link::before {
  content: "";
  display: block;
  position: absolute;
  left: 0px;
  width: 16px;
  height: 100%;
  clip-path: polygon(100% 50%, 0 0, 0 100%);
  z-index: 1;
  background: #235d37;
}
.newtabs_spendid
  .tabs
  .card-header
  .nav-tabs
  li:not(:last-child).nav-item
  .nav-link::after {
  content: "";
  display: block;
  position: absolute;
  right: -16px;
  width: 17px;
  height: 100%;
  clip-path: polygon(100% 50%, 0 0, 0 100%);
  z-index: 2;
  background: #303360;
}
.newtabs_spendid .tabs .card-header .nav-tabs li.nav-item .nav-link.active {
  background: #235d37;
  border: none;
}
.newtabs_spendid
  .tabs
  .card-header
  .nav-tabs
  li:not(:last-child).nav-item
  .nav-link.active::after {
  content: "";
  display: block;
  position: absolute;
  right: -18px;
  width: 17px;
  height: 100%;
  clip-path: polygon(100% 50%, 0 0, 0 100%);
  z-index: 2;
  background: #235d37;
}
a.budgetabsolute {
  color: #fff !important;
  border-bottom: none !important;
}
.category-titles .card-body {
  border: none !important;
  padding: 0px;
}
.time_duration {
  font-size: 32px;
  font-weight: 600;
}
.darkmode .time_duration {
  color: #fff;
}
/* end-november-css */
.budget-plan-btn {
  display: flex;
  align-items: center;
  /* grid-template-columns: 33% 34% 33%; */
  justify-content: center;
}
.budget-plan-btn p {
  display: flex;
  align-items: center;
  margin-bottom: 0;
  justify-content: center;
}
.financial_goals {
  width: 28px;
  height: 28px;
  border: 0;
  padding: 5px 10px;
  border-radius: 30px;

  background: #d45159;
  color: #fff;
  box-shadow: none;
  margin-left: 10px;
  margin-right: 5px;
  display: inline-flex;
}
.future_goals {
  width: 28px;
  height: 28px;
  border: 0;
  padding: 5px 10px;
  border-radius: 30px;

  background: #0267e8;
  color: #fff;
  box-shadow: none;
  margin-left: 10px;
  margin-right: 5px;
  display: inline-flex;
}
.wants_goals {
  width: 28px;
  height: 28px;
  border: 0;
  padding: 5px 10px;
  border-radius: 30px;

  background: #235d37;
  color: #fff;
  /* box-shadow: 0px 2px 5px 1px #aaa; */

  margin-left: 10px;
  margin-right: 5px;
  display: inline-flex;
}
.needs_goals {
  width: 28px;
  height: 28px;
  border: 0;
  padding: 5px 10px;
  border-radius: 30px;
  background: #987e4c;
  color: #fff;
  -webkit-box-shadow: 0px 2px 5px 1px #aaa;
  box-shadow: none;
  /* margin-left: 10px; */
  margin-right: 5px;
  display: inline-block;
}

/* .address_sec {
  display: grid;
  grid-template-columns: 33.3% 33.3% 33.3%;
  z-index: 0;
  position: relative;
}
.address_sec .form-group:nth-child(1),
.address_sec .form-group:nth-child(2) {
  padding-right: 7px;
} */
#chatGptList .modal-header {
  padding: 6px 10px;
  border: none;
}
#chatGptList .modal-header button.close {
  color: #fff;
  position: absolute;
  right: 25px;
  top: 10px;
  z-index: 1;
  font-size: 18px;
  font-weight: 100;
  opacity: 1;
  background-color: #dc3545;
  padding: 0;
  margin: 0;
  display: inline-block;
  line-height: 1.3;
  width: 24px;
  height: 24px;
  border-radius: 100px;
  cursor: pointer;
}
#chatGptList .modal-header button.close:hover {
  opacity: 0.75;
}
#chatGptList .get-advice-articles-head {
  background-color: #f5f5f5;
  padding: 10px;
  /* margin-top: -10px; */
}
#chatGptList .get-advice-articles-head h4 {
  color: #2a2e5c;
}
#chatGptList .get-advice-articles-list {
  padding: 20px;
  border: 1px solid #eee;
  margin-bottom: 15px;
  color: rgba(74, 74, 74, 1);
}
/* @media all and (max-width: 1280px) {
  .custom-radio.b-custom-control-sm, .input-group-sm .custom-radio {
    font-size: 0.875rem !important;
      line-height: 1.5!important;
      padding-left: 1.2125rem!important;
  }
  .custom-control-inline {
      margin-right: 0.6rem!important;
  }
} */

@media all and (min-width: 1400px) and (max-width: 1450px) {
  .newtabs_spendid .tabs .card-header .nav-tabs {
    /* max-width: 1028px; */
  }
}
@media all and (max-width: 1179px) {
  #live-demo {
    margin-top: 70px;
  }
  .nav-action-btns .acount-profile-wrap {
    display: none;
  }
  body div#modal-fullscreen {
    width: 100%;
  }
  .side-visible {
    left: 0 !important;
  }
  .side-visible {
    left: 0 !important;
  }
  #step1 img {
    max-width: 320px;
  }
  .question h5 {
    font-size: 25px;
  }
  .question h5 p {
    font-size: 16px;
  }
  .question_answer .form-control {
    height: 50px;
    font-size: 20px;
  }
  .question_answer .amount_data .form-control,
  .question_answer .annual-gross-input .form-control {
    font-size: 14px;
  }
  .form_block_area button.btn {
    font-size: 18px;
    min-height: 40px;
    padding: 10px 16px;
  }
  .question span {
    left: -50px;
    line-height: 30px;
    margin: 0;
  }
  .question h5::after {
    left: -27px;
    top: 13px;
  }
  .question h5::before {
    left: -26px;
    top: 9px;
  }
  .radio_part .radio_label {
    padding: 5px;
  }
  .form_block_area .time_duration.end button.btn {
    font-size: 14px;
    padding: 7px 10px;
    margin: 0px;
  }
  .progress_data ul li a {
    padding: 9px 7px;
  }
  .question {
    padding-left: 55px;
  }
  .question span {
    left: 0;
  }
}
/* @media all and (max-width: 1199px) {
  #live-demo {
    margin-top: 130px;
  }
} */
#modal-fullscreen___BV_modal_header_ .close::after {
  content: "\f00d  Close";
  font-family: "Font Awesome 5 Pro", "Poppins";
  font-size: 15px;
  background: red;
  padding: 5px 12px;
  border-radius: 5px;
  position: relative;
  top: 7px;
}

#modal-fullscreen___BV_modal_header_ .close {
  font-size: 0;
}
#step1 img {
  max-width: 290px;
}
@media all and (max-width: 991px) {
  body .acount-profile-wrap {
    top: -50px;
    right: 20px;
  }
  .popover-body {
    font-size: 13px !important;
    line-height: 18px !important;
  }
  header.card-header.border-none.shadow-none.p-0.w-100.budget_model.d-flex
    .ml-auto {
    margin-left: 0 !important;
  }
  #live-demo {
    margin-top: 70px;
  }
  /* #step1 {
    margin-top: 30px;
  } */
  .progress_data {
    margin: 40px 0 10px;
  }
  .form_block_area {
    margin: 30px 0;
  }
  .question_answer.combine_questions {
    margin-top: 0px !important;
  }
  .all_radio_parts {
    grid-template-columns: 49% 49%;
    grid-column-gap: 17px;
  }
  .total_monthly_inc {
    font-size: 24px;
  }

  #instructionModal .modal-dialog {
    margin: 50px auto;
  }
}

@media all and (max-width: 767px) {
  .step_form_area {
    overflow-y: scroll;
    height: 100vh;
  }
  .total_monthly_inc span {
    display: block;
    width: 100%;
    margin-left: 0px;
  }
  .total_monthly_inc {
    font-size: 16px;
  }
  .address_sec {
    display: block;
  }
  .address_sec .form-group:nth-child(1),
  .address_sec .form-group:nth-child(2) {
    padding-right: 0px;
  }
  #instructionModal .modal-content {
    border-radius: 100px;
  }
  #step1 img {
    max-width: 290px;
  }
  .debt-list li span {
    font-size: 20px;
  }
  #step1 .time_duration {
    max-width: 460px;
    margin: 0 auto;
  }
  #step1 .time_duration.end {
    flex-wrap: wrap;
    -webkit-flex-wrap: wrap;
  }
  #step1 .time_duration.end small {
    margin-bottom: 20px;
  }
  .step_form_area .back_button {
    position: relative;
    width: 100%;
    text-align: center;
    margin-top: 24px;
    padding-top: 20px;
    border-top: 1px solid #1c1c1c;
  }
  .all_radio_parts {
    grid-template-columns: auto;
  }
  .radio_part {
    max-width: 100%;
  }
  .low-score h4 {
    display: none;
  }
}
@media (max-width: 810px) {
  div#app_steps .time_duration {
    display: flex;
    flex-direction: column;
  }
  .time_duration small {
    font-size: 19px;
    margin-bottom: 15px;
  }
  .form_block_area .time_duration.end button.btn {
    font-size: 14px;
    padding: 13px 16.5px;
    margin: 0 !important;
  }
}
@media (max-width: 600px) {
  header.card-header.border-none.shadow-none.p-0.w-100.budget_model.d-flex
    .ml-auto
    button {
    margin-bottom: 10px;
    margin-left: 5px;
    padding: 5px !important;
    width: 48%;
  }

  /* .custom-radio .custom-control-input:checked ~ .custom-control-label::after {
    left: -30px;
  }
  .custom-radio.b-custom-control-lg .custom-control-label::before,
  .input-group-lg .custom-radio .custom-control-label::before {
    top: 0.3125rem;
    left: -1.875rem !important;
    width: 1.25rem;
    height: 1.25rem;
    border-radius: 50%;
  }
  .custom-radio.b-custom-control-lg .custom-control-label::before,
  .input-group-lg .custom-radio .custom-control-label::before {
    left: -20px !important;
  } */
}
/* @media (max-width: 510px) {
  .custom-radio .custom-control-input:checked ~ .custom-control-label::after {
    left: -30px;
  }
} */

/* @media all and (min-width: 489px) and (max-width: 509px) {
  .custom-radio .custom-control-input:checked ~ .custom-control-label::after {
    left: -30px;
  }
  .custom-radio.b-custom-control-lg .custom-control-label::before,
  .input-group-lg .custom-radio .custom-control-label::before {
    left: -20px !important;
  }
} */

@media (max-width: 480px) {
  .action-btns button:nth-child(3) {
    margin-right: 8px;
  }
  /* .custom-radio .custom-control-input:checked ~ .custom-control-label::after {
    left: -30px;
  } */
  .d-none.mbl-logo img {
    height: 100%;
    width: 100%;
    object-fit: contain;
  }
  /* body .custom-control.custom-switch .custom-control-label {
    top: -5px;
  } */

  .legends p {
    margin-bottom: 10px;
    margin-right: 0;
  }

  /* .legends, .budget-plan-btn {
    flex-direction: column;
    align-items: flex-start;
  } */
  .budget_model.d-flex {
    align-items: center;
    justify-content: center;
  }

  header.card-header.border-none.shadow-none.p-0.w-100.budget_model.d-flex
    .ml-auto {
    width: 100%;
    margin: 20px 0px 0 !important;
  }
  header.card-header.border-none.shadow-none.p-0.w-100.budget_model.d-flex
    .ml-auto
    button {
    width: 100%;
  }
}
@media all and (max-width: 440px) {
  #live-demo {
    margin-top: 50px !important;
    width: 100%;
  }
}
@media (max-width: 380px) {
  .nav-action-btns button {
    margin-right: 3px !important;
    padding: 4px;
  }
}
/* fullscreen modal css */

#modal-fullscreen .modal-header .close {
  opacity: 1;
  font-weight: 100;
  display: none;
}
#modal-fullscreen .modal {
  padding: 0 !important;
}
#modal-fullscreen .modal-header,
#modal-fullscreen .modal {
  border-radius: 0;
}
#modal-fullscreen .modal-dialog.modal-xl {
  max-width: 100%;
  height: 100%;
  margin: 0;
}
#modal-fullscreen .modal-content {
  border-radius: 0;
  min-height: 100%;
  height: auto;
}

#modal-fullscreen .modal-content {
  border: 0;
}

.report-assesment .table thead th {
  padding-top: 15px;
  padding-bottom: 15px;
  padding-left: 15px;
}

#modal-fullscreen .modal-dialog.modal-xl .modal-title,
.report-assesment .card .card-header h5 {
  font-size: 18px;
}

.vertical-sidenav ul li a {
  display: flex;
  align-items: center;
}
.vertical-sidenav ul li a i.fa {
  width: 30px;
}

#modal-fullscreen .modal-header,
#change-popup .modal-header,
#modal-fullscreen .modal-header .close,
#change-popup .modal-header .close,
.darkmode .b-sidebar .sidebar-header h5,
.darkmode .vertical-sidenav ul li a,
.darkmode .logout-info h5,
.darkmode .logout-info p,
.report-assesment .table thead th,
.report-assesment .table tbody td,
.report-assesment .card .card-header h5,
#change-popup h4 {
  color: #fff !important;
}

.report-assesment .card .card-header h5 {
  margin: 0;
}

#modal-fullscreen .modal-header,
#change-popup .modal-header,
.darkmode .vertical-sidenav ul li a,
.report-assesment .table tbody td,
.report-assesment .table thead th,
.report-assesment .card .card-header,
.report-assesment .table thead {
  border: 1px solid #4f5397 !important;
}

#modal-fullscreen .modal-header,
.report-assesment .table thead,
#change-popup .modal-header {
  background-color: #2e2b6b;
}

.darkmode .b-sidebar .sidebar-header {
  background-color: #110f39;
}
.report-assesment .card .card-body {
  background-color: #090729;
}
.report-assesment .card {
  border: 1px solid #444357 !important;
}

#modal-fullscreen .modal-body {
  background-color: #f9f9f9;
}
body.darkmode #modal-fullscreen .modal-body {
  background-color: #1e2041;
}

#change-popup .modal-body,
.darkmode .b-sidebar .b-sidebar-body,
.report-assesment .card .card-header {
  background-color: #1e2041;
}

.darkmode .logot-alerts-slide .card,
.darkmode .vertical-sidenav ul li a {
  background-color: #090729;
}

.report-assesment .table tbody tr:nth-of-type(odd) {
  background-color: #7874b3 !important;
}
.report-assesment .table tbody tr:nth-of-type(even) {
  background-color: #5c5797 !important;
}
@media all and (max-width: 1260px) {
  .budget_model.d-flex {
    flex-wrap: wrap;
  }
  /* .navbar-logo a img[data-v-2bb78d39],
  .navbar-logo img[data-v-2bb78d39],
  .navbar-logo-customer img[data-v-2bb78d39],
  .navbar-logo-customer a img[data-v-2bb78d39] {
    max-height: 38px;
  } */
  header.card-header.border-none.shadow-none.p-0.w-100.budget_model.d-flex.mb-4.mb_none {
    margin-bottom: 0 !important;
  }
  header.card-header .title-result {
    margin-bottom: 15px !important;
  }

  .ml-auto.budget-plan-btn p:first-child span {
    margin-left: 0;
  }
  header.card-header.border-none.shadow-none.p-0.w-100.budget_model.d-flex
    .ml-auto {
    margin-left: 0 !important;
    width: 100%;
    justify-content: flex-start;
  }
}
@media all and (min-width: 1200px) {
  body .b-sidebar.b-sidebar-left,
  body .b-sidebar:not(.b-sidebar-right) {
    display: block !important;
    top: 110px;
    left: 0;
  }
}

@media all and (max-width: 1022px) {
  .newtabs_spendid .tabs .card-header .nav-tabs {
    position: static;
    background: #090729;
    background: #090729;
    display: flex;
    flex-shrink: initial;
    max-width: initial;
  }
  .newtabs_spendid .tab-content {
    margin-top: 0px;
  }
  .newtabs_spendid .tabs .card-header .nav-tabs li.nav-item,
  .newtabs_spendid .tabs .card-header .nav-tabs li:not(:last-child).nav-item {
    flex: auto;
    width: 20%;
    margin-bottom: 0px;
  }
  .newtabs_spendid
    .tabs
    .card-header
    .nav-tabs
    li:not(:last-child).nav-item
    .nav-link.active::after,
  .newtabs_spendid
    .tabs
    .card-header
    .nav-tabs
    li:not(:last-child).nav-item
    .nav-link::after,
  .newtabs_spendid
    .tabs
    .card-header
    .nav-tabs
    li:not(:first-child).nav-item
    .nav-link::before {
    display: none;
  }
  .newtabs_spendid .tabs .card-header .nav-tabs li.nav-item .nav-link,
  .newtabs_spendid .tabs .card-header .nav-tabs li.nav-item .nav-link:hover {
    padding-left: 8px;
    font-size: 11px;
    border-radius: 8px;
  }
}

@media all and (min-width: 767px) and (max-width: 1199px) {
  /* #live-demo {
    width: calc(100% - 0px);
    margin-left: auto;
  } */
}

/* 5 jan css start */
.custom-container.container,
#cash-flow-score.custom-container.container {
  margin: 0 !important;
  max-width: 100% !important;
  padding: 0 20px 0 0px;
}
.b-sidebar-outer {
  z-index: 998 !important;
}
.b-sidebar-outer .b-sidebar {
  top: 0 !important;
}
.b-sidebar-outer .b-sidebar .b-sidebar-body {
  background: #1e2041;
}
nav#navbar {
  width: auto !important;
}
.sidebar-header {
  display: none;
}
.b-sidebar-body .user-detail p {
  color: #fff;
}
.b-sidebar-body .nav .nav-item a {
  color: #fff;
  border-radius: 0px;
  border: none;
  padding: 13px;
  background: transparent;
}
.b-sidebar-body .nav .nav-item a.active {
  border: 3px solid #409a91;
  border-radius: 30px;
}
.b-sidebar-body .logot-button .btn.btn-success {
  border-radius: 0px;
  padding: 10px;
}
.card-body .logout-info h5 {
  color: #fff;
}
.card-body .logout-info p {
  color: #fff;
  opacity: 0.6;
}
.logot-alerts-slide .card {
  background-color: #090729 !important;
  border: none !important;
}

@media all and (max-width: 1199px) {
  .px-3.py-2.sidebar-header
    button.btn.btn.btn-danger.d-block.d-md-none.btn-secondary.btn-sm {
    display: block !important;
  }
  .custom-container.container,
  #cash-flow-score.custom-container.container {
    padding: 0 20px 0 20px;
  }
  nav#navbar {
    left: 0;
  }
  .sidebar-header {
    display: block;
  }
}

@media (max-width: 810px) {
  div#app_steps .time_duration {
    display: flex;
    flex-direction: column;
  }
  .time_duration small {
    font-size: 19px;
    margin-bottom: 15px;
  }
  .form_block_area .time_duration.end button.btn {
    font-size: 14px;
    padding: 13px 16.5px;
    margin: 0 !important;
  }
}
@media (max-width: 600px) {
  header.card-header.border-none.shadow-none.p-0.w-100.budget_model.d-flex
    .ml-auto
    button {
    margin-bottom: 10px;
    margin-left: 5px;
    padding: 5px !important;
    width: 48%;
  }
}
@media (max-width: 480px) {
  .budget_model.d-flex {
    align-items: center;
    justify-content: center;
  }

  .newtabs_spendid .tabs .card-header .nav-tabs {
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    flex-direction: unset;
    gap: 10px;
  }
  .budget-plan-btn p {
    margin-bottom: 10px;
    font-size: 13px;
    justify-content: flex-start;
  }
  .budget-plan-btn p span {
    margin-left: 0px;
    margin-right: 10px;
  }
  .budget-plan-btn {
    display: grid;
    grid-template-columns: 50% 50%;
  }
  .budget-plan-btn span {
    flex-shrink: 0;
  }
  header.card-header.border-none.shadow-none.p-0.w-100.budget_model.d-flex
    .ml-auto {
    width: 100%;
    margin: 20px 0px 0 !important;
  }
  header.card-header.border-none.shadow-none.p-0.w-100.budget_model.d-flex
    .ml-auto {
    width: 100%;
    margin: 20px 0px 0 !important;
    flex-direction: column;
    align-items: flex-start;
  }
}
@media (max-width: 350px) {
  .newtabs_spendid .tabs .card-header .nav-tabs li.nav-item,
  .newtabs_spendid .tabs .card-header .nav-tabs li:not(:last-child).nav-item {
    width: 46% !important;
  }
}
/* @media all and (max-width: 1024px) {
  .side-visible {
    left: 0px;
  }
  #live-demo {
    width: 100% !important;
  }
} */

/* new sidebar design */
#sidebar-right .b-sidebar-body {
  overflow: hidden;
  padding: 20px;
  background: #110f39;
}
#sidebar-right {
  width: 100%;
  max-width: 300px;
  overflow: hidden;
}
#sidebar-right .vertical-sidenav .user-detail a {
  display: block;
  height: 120px;
  width: 120px;
  margin: 10px auto 40px;
}
#sidebar-right .user-detail a img {
  width: 120px !important;
  height: 120px !important;
  margin: 0px !important;
}
#sidebar-right .nav_scroll_area {
  width: 100%;
  height: calc(100vh - 360px);
  overflow-y: auto;
}
/* #sidebar-right .nav_scroll_area::-webkit-scrollbar{
  width: 0px;
} */
#sidebar-right .bottom_nav_section {
  /* position: absolute;
    left: 0;
    bottom: 0;
    padding: 20px;
    right: 0;
    */
  background: #110f39;
  margin-top: 30px;
}
.bottom_nav_section {
  /* position: absolute;
    left: 0;
    bottom: 0;
    padding: 20px;
    right: 0;
    */
  background: #110f39;
  margin-top: 30px;
}
#sidebar-right .nav li {
  position: relative;
  z-index: 9999;
}
#sidebar-right .nav li a:hover {
  border: 3px solid #3ab7a4 !important;
}
#sidebar-right .nav li a {
  border: 3px solid #110f39 !important;
  font-family: "Tahoma";
  font-size: 12px !important;
  font-weight: 600;
  text-transform: uppercase;
  line-height: 18px;
  letter-spacing: 1px;
  height: 49px;
  color: #ffffff;
  transition-duration: 0.3s;
  transition-property: transform;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  text-decoration: none;
  cursor: pointer;
  padding: 7px 15px;
  width: 100%;
  margin-bottom: 10px;
  border: 3px solid #110f39;
  color: #fff;
  text-decoration: none;
  box-shadow: none;
  border-radius: 100px;
  background-color: transparent !important;
}
#sidebar-right .nav li a:hover {
  border: 3px solid #3ab7a4;
}
#sidebar-right .nav li a p {
  margin: 0px;
}
#sidebar-right .nav li a img {
  height: 20px;
  width: 18px;
  margin-right: 15px;
  object-fit: contain;
}
.submenu_items {
  position: relative;
  margin-bottom: 10px !important;
}
#sidebar-right .submenu_items .submenu li a {
  background: #3ab7a4 !important;
  font-size: 10px !important;
  margin-bottom: 5px !important;
}
#sidebar-right .submenu_items .submenu li a:hover {
  background: transparent !important;
}
.submenu_items .arrow_down {
  position: relative;
}

.submenu_items li.nav-item.arrow_down.active-drop::after {
  transform: rotate(-45deg);
}
.submenu_items .arrow_down::after {
  position: absolute;
  content: "";
  top: 18px;
  right: 20px;
  width: 10px;
  height: 10px;
  background: transparent;
  border: none;
  border-bottom: 2px solid #fff;
  border-left: 2px solid #fff;
  padding: 0px;
  z-index: -5;

  transform: rotate(-135deg);
}
#sidebar-right .no_click {
  all: initial;
  width: 100%;
}

.top_nav_section {
  margin-bottom: 30px;
  /* height: 167px; */
}
div#modal-fullscreen {
  width: calc(100% - 300px);
  margin-left: auto;
  right: 0;
  left: unset;
}
div#modal-fullscreen___BV_modal_outer_
  div#modal-fullscreen___BV_modal_backdrop_ {
  width: calc(100% - 300px);
  margin-left: auto;
  right: 0;
  left: unset;
}

/* header scroll bar css  */

.scrollbar {
  margin-left: 0;
  float: left;
  height: calc(100vh - 235px);
  width: 280px;
  background: transparent;
  overflow-y: scroll;
  margin-bottom: 0;
}

.force-overflow {
  min-height: 450px;
  padding-right: 20px;
}

#wrapper {
  text-align: center;
  width: 500px;
  margin: auto;
}
#style-3::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);
  background-color: #110f39;
}

#style-3::-webkit-scrollbar {
  width: 6px;
  background-color: #110f39;
}

#style-3::-webkit-scrollbar-thumb {
  background-color: #3ab7a4;
}
header.card-header.border-none.shadow-none.p-0.w-100.budget_model.d-flex
  .hover-info-box
  span.hover-icon.ml-2 {
  line-height: 40px;
}
.font-20 {
  font-size: 20px;
}
header.card-header.border-none.shadow-none.p-0.w-100.budget_model.d-flex
  .hover-info-box
  span.hover-icon.ml-2 {
  line-height: 40px;
  height: 24px;
  width: 24px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  position: relative;
  top: 2px;
}
header.card-header.border-none.shadow-none.p-0.w-100.budget_model.d-flex
  .hover-info-box
  span.hover-icon.ml-2
  i {
  color: #235d37 !important;
  font-size: 14px !important;
}

/* 1-27-23 css */
.time_duration small {
  font-size: 23px;
}

@media (max-width: 1400px) {
  .time_duration small {
    font-size: 19px;
  }
}
@media (max-width: 1199px) {
  .side-visible {
    left: 0 !important;
  }
}
@media (max-width: 810px) {
  div#app_steps .time_duration {
    display: flex;
    flex-direction: column;
  }
  .time_duration small {
    font-size: 19px;
    margin-bottom: 15px;
  }
  .form_block_area .time_duration.end button.btn {
    font-size: 14px;
    padding: 13px 16.5px;
    margin: 0 !important;
  }
}
@media (max-width: 600px) {
  header.card-header.border-none.shadow-none.p-0.w-100.budget_model.d-flex
    .ml-auto
    button {
    margin-bottom: 10px;
    margin-left: 5px;
    padding: 5px !important;
    width: 48%;
  }
}
@media (max-width: 580px) {
  body #live-demo {
    border-bottom: #8acfba solid 10px;
    border-left: #8acfba solid 10px;
    border-right: #8acfba solid 10px;
  }

  .resp-mr-view {
    margin-top: 15px;
  }
  .resp-mr-view button {
    margin-right: 10px;
    margin-bottom: 10px;
  }
  .resp-mr-view button:last-child {
    margin-right: 0 !important;
  }
  header.card-header.border-none.shadow-none.p-0.w-100.budget_model.d-flex
    .ml-auto {
    margin-top: 15px;
  }
  .mb_none .hover-info-box span.hover-icon.ml-2 {
    margin-left: 0 !important;
  }
}
@media (max-width: 555px) {
}
@media (max-width: 510px) {
  .newtabs_spendid .tabs .card-header .nav-tabs li.nav-item,
  .newtabs_spendid .tabs .card-header .nav-tabs li:not(:last-child).nav-item {
    width: 48% !important;
    margin-bottom: 0px !important;
  }

  body .action-btns {
    /* margin-top: 30px; */
    align-items: center !important;
    justify-content: center !important;
  }

  .newtabs_spendid .tabs .card-header .nav-tabs li:last-child a span {
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }
  .newtabs_spendid .tabs .card-header .nav-tabs {
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-orient: unset;
    -webkit-box-direction: unset;
    -ms-flex-direction: unset;
    flex-direction: unset;
    gap: 10px;
  }
  .newtabs_spendid .tabs .card-header .nav-tabs li:last-child a span i {
    margin-left: 5px;
  }
  nav#navbar .collapse-nav.ml-auto {
    margin-left: 0 !important;
    width: 100%;
  }
  .d-none.mbl-logo {
    display: block !important;
    height: 40px;
    /* width: 120px; */
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 5px;
  }
  /* body .custom-control-label::before {
    position: absolute;
    top: 23px;
    left: 50% !important;
    transform: translateX(-50%);
  }
  body .custom-switch .custom-control-label::after {
    left: unset;
    right: 36px;
    top: 25px;
  } */
  button.btn.mr-2.btn-sm.btn-success.d-block.d-xl-none.btn-secondary {
    position: absolute;
    top: 10px;
    left: 5px;
    height: 30px;
    width: 30px;
    display: flex;
    text-align: center;
    justify-content: center;
    padding: 0;
  }
  body button.btn.mr-2.btn-sm.btn-success.d-block.d-xl-none.btn-secondary i {
    font-size: 16px;
    line-height: 28px;
  }
}
@media (max-width: 480px) {
  .darkmode .theme-change-mode,
  .theme-change-mode {
    top: 10px !important;
  }
  .budget_model.d-flex {
    align-items: center;
    justify-content: flex-start;
  }
  .legends {
    -webkit-box-align: start;
    -ms-flex-align: start;
    align-items: flex-start;
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    justify-content: flex-start !important;
    align-items: flex-start !important;
  }
  body .legends p {
    margin-bottom: 10px;
  }
  body .legends p:last-child {
    margin-bottom: 0px;
  }
  header.card-header .title-result {
    font-size: 19px;
  }
  body .nav-action-btns .btn.btn-success {
    font-size: 10px;
    margin-right: 5px !important;
  }

  /* body .nav-action-btns .nav-divider {
    display: none !important;
  } */
  /* body .custom-switch .custom-control-label::after {
    left: unset;
    right: 36px;
    top: 25px;
  } */

  header.card-header.border-none.shadow-none.p-0.w-100.budget_model.d-flex
    .ml-auto {
    width: 100%;
    margin: 20px 0px 0 !important;
  }
  header.card-header.border-none.shadow-none.p-0.w-100.budget_model.d-flex
    .ml-auto
    button {
    width: 100%;
  }
  .new-frame-first-card label,
  .address_sec .form-control,
  .form-group.has-icons-right .custom-select,
  fieldset.form-group.has-icons-right .form-control {
    font-size: 13px;
  }
  .new-frame-first-card .custom-radio label {
    font-size: initial;
  }
}
/* @media (max-width: 350px) {
  body .nav-action-btns .nav-divider {
    display: none !important;
  }
} */
/* @media screen and (min-width: 767px) {
  .new-frame-first-card .new-accordin-frame .btn::after,
  .new-frame-first-card .new-accordin-frame .not-collapsed::after {
    display: none;
  }
  .new-frame-first-card .new-accordin-frame .btn {
    cursor: revert !important;
  }
} */
header.card-header.border-none.shadow-none.p-0.w-100.budget_model.d-flex
  .hover-info-box
  span.hover-icon.ml-2
  i {
  color: #303360 !important;
  font-size: 15px !important;
}
.time_duration small {
  font-size: 23px;
}
.popover-body {
  padding: 0.5rem 0.75rem;
  color: #212529;
  font-size: 13px;
  font-weight: 500;
  text-align: left;
  line-height: 18px;
}
#sidebar-right .nav li.nav-item.active .nav-link {
  background-color: transparent !important;
  border: 3px solid #3ab7a4 !important;
  box-shadow: none;
  border-radius: 100px;
}
.legends span.commmon-circle button i,
span.input-btn i {
  font-size: 14px;
  position: relative;
  top: 1px;
}
.legends .commmon-circle button,
span.input-btn {
  width: 26px;
  height: 26px;
  border: 0;
  padding: 5px 10px;
  border-radius: 30px;
  background: #0267e8;
  color: #fff;
  -webkit-box-shadow: 0px 2px 5px 1px #aaa;
  box-shadow: none;
  margin-left: 5px;
  margin-right: 5px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.legends .predict button {
  background: #987e4c !important;
}
.legends .your-peers button {
  background: #235d37 !important;
}
.legends,
.legends p {
  display: flex;
  align-items: center;
}
.legends p {
  margin-right: 20px;
  text-transform: capitalize;
  font-weight: 500;
  color: #4a4a4a;
  margin-bottom: 0;
  font-size: 12px;
}
.tabs.hide-card .card-header {
  box-shadow: none !important;

  border-radius: 0 !important;
  border: none !important;
  padding: 0px 10px 0px 10px;
}
.card.hide-card {
  box-shadow: none !important;
  border-color: #fff;
  display: none;
}
button.btn.cross-btn.btn-secondary,
button.btn.cross-btn.btn-secondary:active {
  height: 16px;
  width: 16px;
  background: #dc3545 !important;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
button.btn.cross-btn.btn-secondary i {
  color: #fff !important;
  font-size: 10px;
}

.cross-icon {
  height: 20px;
  width: 20px;
  background: #dc3545 !important;
  border-radius: 100%;
  display: inline-flex !important;
  justify-content: center;
  align-items: center;
  align-items: center;
  justify-content: center;
  margin: 0 5px;
}
.w-100.text-center.d-none.d-md-block.d-lg-block.line-text {
  display: flex !important;
  align-items: center;
  justify-content: center;
}
.cross-icon i {
  color: #fff !important;
  font-size: 12px;
}
.line-text .fa-edit {
  margin: 0 5px;
}
.mobile-flex-here {
  display: flex;
}
.mobile-flex-here button.btn.clear-sm.float-md-none.ml-md-0.btn-secondary {
  margin-left: 12px !important;
}
.address_sec .form-control,
fieldset.form-group.has-icons-right .form-control,
fieldset.form-group.has-icons-right select {
  border: 2px solid #656870 !important;
}
.submenu_items li a {
  padding-right: 0 !important;
}
.no-result input.position-relative.dis.no-border-input.form-control {
  border: 2px solid #e9ecef !important;
}
input.position-relative.dis.no-border-input.form-control.asa,
.darkmode.no-result
  input.position-relative.dis.no-border-input.form-control.asa {
  border: 2px solid #656870 !important;
}

.darkmode.no-result input.position-relative.dis.no-border-input.form-control {
  border-color: #656870 !important;
}
.feedback-btn {
  min-width: 190px;
  text-transform: uppercase;
}
.input-capitalize::placeholder {
  text-transform: capitalize;
}

.debt-list .total-amout.wrap span {
  font-weight: 600;
  font-size: 25px;
}
.total-amout.wrap {
  border-top: 2px solid #e4e4e4;
  /* margin-top: 20px; */
}
.darkmode .total-amout.wrap {
  border-top: 2px solid #fff;
  /* margin-top: 20px; */
}

a.profile_icon:hover {
  text-decoration: none !important;
}
a.profile_icon {
  display: flex;
  align-items: center;
}
.profile_name {
  margin: 0 0 0px 10px;
  white-space: nowrap;
}
.profile_name:hover {
  text-decoration: none;
}
.acount-profile-wrap {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: relative;
  top: -20px;
  right: -30px;
}
.profile_name {
  margin: 0 0 0px 10px;
  white-space: nowrap;
  font-size: 18px;
  color: #fff;
}
.acount-profile-wrap.savd-report-profile {
  position: absolute;
  top: -56px;
  right: 30px;
}
.acount-profile-wrap.savd-report-profile .profile_name {
  font-size: 16px;
}
ul.innerlist {
  list-style-type: disc;
  padding-left: 25px;
}
ul.innerlist li h5 {
  margin-bottom: 5px;
}
ul.innerlist li :last-child h5 {
  margin-bottom: 0px;
}
ul.innerlist li a {
  color: #fc3c2d !important;
  text-decoration: underline;
  font-size: 14px;

  font-weight: 500;
}
.top_nav_section li:last-child {
  position: relative;
}
.top_nav_section li:last-child::after {
  position: absolute;
  content: "";
  bottom: -16px;
  left: 0;
  right: 0;
  width: 100%;
  height: 3px;
  background: #86858c;
}
a.profile_icon img {
  height: 50px;
  background: #eaeff6;
  border-radius: 100%;
}
.past-credit {
  padding-right: 30px;
}
.past-credit i {
  font-size: 15px;
  /* padding-right: 55px!important; */
  /* display: initial; */
  line-height: 20px;
}
.darkmode .card.hide-card {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  border-color: #090729;
}
.user-detail a {
  pointer-events: none;
}
/* path
{
  pointer-events: none;
} */
.newframe-card-title h4 {
  /* margin-bottom: 20px; */
  font-weight: 600;
  /* color:#000; */
  font-size: 28px;
}
.darkmode .newframe-card-title h4 {
  color: #000;
}
.card.new-frame-card {
  box-shadow: none;
}
.gross-net-home-radios {
  z-index: 0;
  position: relative;
}
.darkmode .card.new-frame-card,
.darkmode .card.new-frame-card-inner {
  background-color: #2a2f3b;
}
.card.new-frame-card,
.card.new-frame-card-inner,
.border.category-titles {
  border: 1px solid #000 !important;
}
.darkmode .card.new-frame-card,
.darkmode .card.new-frame-card-inner,
.darkmode .border.category-titles {
  border: 1px solid #525b75 !important;
}

.new-frame-card .card-body,
.new-frame-first-card > .card-body,
.new-frame-second-card > .card-body,
.new-frame-third-card > .card-body {
  padding: 0.6rem;
}
.piechart-btns .btn.btn-theme {
  font-weight: 600 !important;
  border-radius: 6px !important;
  font-size: 12px;
  width: 140px;
}

.new-accordin-frame .btn-primary,
.new-accordin-frame .btn-primary:hover,
.new-accordin-frame .btn-primary:focus,
.new-accordin-frame .btn-primary:not(:disabled):not(.disabled):active {
  padding: 0px;
  background-color: #fff;
  border: solid 1px #fff;
  color: #444;
}
.darkmode .new-accordin-frame .btn-primary,
.darkmode .new-accordin-frame .btn-primary:hover,
.darkmode .new-accordin-frame .btn-primary:focus,
.darkmode
  .new-accordin-frame
  .btn-primary:not(:disabled):not(.disabled):active {
  padding: 6px;
  background-color: #e6d6b8;
  border: solid 1px #e6d6b8;
  color: #000;
}
.new-accordin-frame .btn-primary {
  width: 100%;
}
.new-accordin-frame .newcatgory-header {
  display: flex;
  justify-content: space-between;
}
.new-accordin-frame .newcatgory-header .newcatgory-title {
  font-size: 1.5rem;
  font-weight: 600;
  /* color:#000; */
}
@media only screen and (max-width: 767px) {
  .new-accordin-frame .newcatgory-header .newcatgory-title,
  .title-result {
    font-size: 1.2rem;
  }
}
.darkmode .new-accordin-frame .newcatgory-header .newcatgory-title {
  color: #000000;
}
.new-accordin-frame .newcatgory-header .newcatgory-num {
  font-weight: 600;
  color: #180f4f;
  margin-right: 20px;
}
#piechart g[style*="cursor: pointer;"],
div#speedometer g[style*="cursor: pointer;"],
#projectGrowth g[style*="cursor: pointer;"] {
  pointer-events: none;
}
#projectGrowth g[role="switch"] {
  pointer-events: auto !important;
}
.rm-chart-watermark g[style*="cursor: pointer;"] {
  pointer-events: none;
}
.chatGptList .embed-responsive .embed-responsive-item {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border: 0;
  object-position: 0% 18%;
}
.new-accordin-frame > .newframe-card-title > .btn,
.new-accordin-frame > .newframe-card-title > .btn:hover,
.new-accordin-frame > .newframe-card-title > .btn:focus,
.new-accordin-frame > .btn,
.new-accordin-frame > .btn:focus,
.new-accordin-frame > .btn:hover,
.new-accordin-frame .btn-primary:not(:disabled):not(.disabled):active,
.new-accordin-frame > .btn:active {
  color: #000 !important;
  font-size: 1.5rem;
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 5px;
  background-color: #e6d6b8;
  width: 100%;
}
.green-bar {
  background-color: #6e9277 !important;
  border: solid 1px #6e9277 !important;
}
.chatgpt-info h3 {
  font-size: 22px;
  font-weight: 600;
  /* margin-bottom: -10px; */
  margin-top: 0px;
  display: block;
  width: 100%;
}
@media only screen and (max-width: 767px) {
  #chatGptList .modal-dialog-scrollable {
    max-height: calc(90% - 1rem);
  }
  .new-accordin-frame > .newframe-card-title > .btn,
  .new-accordin-frame > .newframe-card-title > .btn,
  .new-accordin-frame > .btn {
    font-size: 1.2rem !important;
  }
}
.chatgpt-info h3 {
  font-size: 23px;
  color: #000;
}

.chatgpt-info {
  font-size: 17px;
  color: #000;
}
.chart-age {
  position: absolute;
  bottom: 95px;
  left: 0;
  right: 0;
  font-size: 14px;
  text-align: center;
}
.investment-return-group .input-group-append {
  margin-left: -45px;
  border-radius: 100px;
  position: relative;
  z-index: 1;
  height: 34px;
  margin-top: 1px;
}
.investment-return .input-group > .form-control:focus {
  z-index: 0;
}

.investment-return .form-control {
  background-color: #fff !important;
  border: thin solid #1aa59b !important;
}
.investment-return .form-control:focus {
  border: thin solid #eee !important;
}
.darkmode .investment-return-group .form-control,
.darkmode .investment-return-group .form-control:hover,
.darkmode .investment-return-group .input-group-text,
.investment-return-group .input-group-text {
  border-radius: 100px;
  background-color: #fff;
  color: #000;
}

.investment-return-group .input-group-text {
  border: none;
}
.occup-amount {
  display: inline-block;
  background-color: #ffffff;
  border: solid 1px #eeeeee;
  padding: 2px 20px;
}
.darkmode .occup-amount {
  background-color: #235d37;
  border: solid 1px #fff;
}
.darkmode .occup-amount,
.darkmode .combine_questions h4,
.darkmode .combine_questions h5,
.darkmode .custom-control label {
  color: #fff;
}
.occupation-amonut {
  /* display: inline-block; */
  background-color: #fff;
  border-radius: 100px;
  border: solid 2px #235d37;
  font-weight: bold;
  padding: 2px 10px;
  position: relative;
  z-index: 1;
  float: right;
  margin-top: -30px;
  color: #000;
}
.instruction-tooltip {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
}
.instruction-tooltip .hover-icon i {
  color: #000;
}
.instruction-tooltip .hover-info-box .hover-icon {
  font-size: initial;
}
.instruction-tooltip .hover-info-box .hover-info-text {
  font-size: 17px;
}
.multiselect__tags {
  border: 2px solid #656870 !important;
  background-color: #ffffff;
  border-radius: 100px;
}
.multiselect__tags,
.multiselect--above.multiselect--active .multiselect__current,
.multiselect--above.multiselect--active .multiselect__input,
.multiselect--above.multiselect--active .multiselect__tags,
.multiselect--active:not(.multiselect--above) .multiselect__tags {
  border-top-left-radius: 100px;
  border-top-right-radius: 100px;
  border-bottom-left-radius: 100px;
  border-bottom-right-radius: 100px;
}

.multiselect__tags,
.multiselect__input,
.multiselect__single {
  background-color: transparent;
}
.darkmode .multiselect__tags {
  background-color: #2a2f3b;
  color: #fff;
}
.darkmode .instruction-tooltip .hover-icon i {
  color: #fff;
}
.no-peers {
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  padding: 10px;
  text-align: center;
}
.darkmode .no-peers .h3 {
  color: #fff;
}
.darkmode .no-peers {
  background-color: #1c1d21;
}
@media only screen and (max-width: 820px) {
  #step1 .time_duration {
    flex-direction: column;
  }
}
@media only screen and (max-width: 767px) {
  .instruction-tooltip {
    position: relative;
    width: 100%;
  }
  .investment-return-group {
    max-width: 150px;
  }
  .chart-age {
    bottom: 60px;
  }
}
@media only screen and (max-width: 767px) {
  .investment-return-group {
    max-width: 150px;
  }
  .chart-age {
    bottom: 60px;
  }
}

.interview-customer-logo {
  display: inline-block;
  position: absolute;
  top: 20px;
  left: 10px;
  /* background-color: #fff; */
  padding: 10px;
  border-radius: 5px;
}

@media only screen and (max-width: 1024px) {
  .custom-switch-step-style {
    right: 4px;
    top: 2px;
    font-size: 14px;
    z-index: 999;
  }
  /* .interview-customer-logo {
    display: block;
    position: relative;
    right: 0;
    top: -20px;
    left: 0;
    width: 110px;
    margin: 0 auto;
  }
  .createprofile-step .interview-customer-logo {
    top: 20px;
  }
  .interview-customer-logo img {
    max-height: 80px;
  } */
}
.interview-customer-logo img {
  max-height: 80px;
}
@media only screen and (min-width: 1024px) {
  .interview-customer-logo img {
    max-height: 96px;
  }
}
@media only screen and (max-width: 768px) {
  .occupation-amonut {
    font-size: 14px;
    padding: 2px 6px;
  }
  .interview-customer-logo {
    display: block;
    position: relative;
    right: 0;
    top: 0px;
    left: 0;
    width: 146px;
    margin: 0 auto;
  }
  .createprofile-step .interview-customer-logo {
    top: 10px;
    margin-bottom: 20px;
  }
  .interview-customer-logo img {
    max-height: 116px;
  }
}
.not-applicable {
  color: #000;
  font-size: 18px;
  font-weight: 600;
}
.darkmode .not-applicable {
  color: #fff;
}
.income-method-inner-card {
  background-color: #fff;
  height: calc(100% - 44px);
}
.add_more_data {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  height: 100%;
}
.add_more_data i {
  font-size: 30px;
  padding: 0;
  border-radius: 100px;
  border: 2px solid #16cfbc;
  color: #16cfbc;
  width: 70px;
  height: 70px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  display: -webkit-flex;
  -webkit-align-items: center;
  -webkit-justify-content: center;
}
@media (max-width: 767px) {
  .add_more_data i {
    font-size: 18px;
    width: 40px;
    height: 40px;
  }
}

.darkmode .add_more_data i {
  background-color: #212329;
  border: 2px solid #55575b;
  color: #fff;
}

.add_more_data h6 {
  display: block;
  width: 100%;
  text-align: center;
  font-size: 20px;
  color: #303360;
  margin-top: 20px;
}

.darkmode .add_more_data h6,
.darkmode .source-count,
.darkmode .manually-input-radios .col-form-label,
.darkmode .annual-gross-input .col-form-label,
.darkmode .amount_data .col-form-label {
  color: #d0d2e8;
}
.btn-purple, .btn-purple:hover, .btn-purple:focus {
    background-color: #6e2c98!important;
    border-color: #6e2c98!important;
}

.chatGptList .embed-responsive .embed-responsive-item {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border: 0;
  object-position: 0% 18%;
}

/* .chatgpt-info h3 {
    font-size: 22px;
    font-weight: 600;
    margin-top: 0px;
    display: block;
    width: 100%;
  } */
@media only screen and (max-width: 767px) {
  #chatGptList .modal-dialog-scrollable {
    max-height: calc(90% - 1rem);
  }
}

/* .chatgpt-info h3 {
    font-size: 23px;
    color: #000;
  }
  .chatgpt-info {
    font-size: 16px;
    color: #000;
    padding: 30px 0;
  } */
@media only screen and (max-width: 767px) {

  /* .chatgpt-info h3 {
      font-size: 16px;
    }
    .chatgpt-info {
      font-size: 13px;
      padding: 20px 0;
    } */
  .get-advice-articles-head {
    margin-top: 20px;
  }

  .chatGptList-header .logo,
  .chatGptList-header .logo-w {
    max-height: 60px !important;
  }
}

.chatgpt-info {
  padding: 10px 0;
}
.chatGptList-disclaimer {
    margin: 15px 15px 10px 15px;
}
.disclaimer-ai-text {
    margin-bottom: 0;
    font-size: 20px;
    font-style: italic;
    font-weight: 500;
    color: #8e8c8c;
    line-height: 26px;
    text-align: center;
}


@media only screen and (max-width: 767px) {
  .chatgpt-info {
    padding: 10px 0;
  }
  .disclaimer-ai-text {
    font-size: 14px;
  }
}

/* .message-ai-list ul {
    margin-bottom: 30px;
  }
  .message-ai-list h3 {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 10px;
  } */
/* .message-ai-list {
  display: grid;
  grid-template-columns: 60% 40%;
  gap: 30px;
  margin: 50px 0;
  padding: 30px;
  align-items: center;
} */
.response-info-text {
    background-color: #fff;
    position: relative;
    padding: 20px;
    height: 100%;
    border: 1px solid #eee;
    border-radius: 10px;
    margin-bottom: 15px;
}
.message-ai-list ul {
  margin-bottom: 30px;
}
.ai-response-profile-list li, .message-ai-list ul li {
    margin-bottom: 12px;
    padding-left: 20px;
    font-size: 16px;
    color: #4a4a4a;
}



.ai-response-profile-list li, .how-to-listing li, .message-ai-list ul li {
    position: relative;
    display: block;
}
.message-ai-list ul li {
    margin-bottom: 15px; 
    font-size: 16px;
    font-weight: 500; 
}
.ai-response-profile-list li:before, .how-to-listing li:before, .message-ai-list li:before {
    content: "\F061";
}
.ai-response-profile-list li:before, .how-to-listing li:before, .message-ai-list li:before {
    font-family: Font Awesome\ 5 Pro;
    font-weight: 900;
    position: absolute;
    left: 0;
    color: #009688;
}

.message-ai-list h3 {
  font-size: 36px;
  font-weight: 700;
  margin-bottom: 15px;
  color: #4a4a4a;
}

.message-ai-list p {
  font-size: 20px;
  line-height: 32px;
  font-weight: 600;
}

@media only screen and (max-width: 1279px) {

  .message-ai-list p,
  .message-ai-list ul li,
  .ai-response-profile-list li,
  .message-ai-list ul li {
    font-size: 14px;
    line-height: 24px;
  }

  .message-ai-list h3 {
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 15px;
  }

  .message-ai-list {
    display: grid;
    grid-template-columns: 100%;
    margin: 20px 0;
    padding: 0;
  }
}

.response-info-text {
  background-color: #fff;
  /* margin-right: -100px; */
  position: relative;
  /* padding: 20px; */
  /* box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.2); */
  padding: 20px;
  height: 100%;
  border: solid 1px #eee;
  border-radius: 10px;
}

.response-image img {
  border-radius: 10px;
}

@media only screen and (max-width: 767px) {
  .message-ai-list h3 {
    font-size: 18px !important;
  }
}

@media only screen and (max-width: 767px) {
  .message-ai-list ul li {
    font-size: 14px;
  }
}

.message-ai-list ul li {
  margin-bottom: 15px;
}

.clear-inputs-modal h3,
.clear-inputs-modal p {
  color: #141722;
}

.darkmode .chatgpt-info,
.darkmode .loading-text,
.darkmode .clear-inputs-modal .modal-content p

/* .darkmode .projected-investment-header h6,
  /* .darkmode .investment-return p  */
  {
  color: #c2c2c2;
}

.steps-body .income-method-inner {
    border-radius: 10px;
    background-color: #fff;
    border: 1px solid #c9c9c9;
    padding: 10px;
}
.income-method-inner-card {
    background-color: #fff;
    height: calc(100% - 44px);
}
.darkmode .income-method-inner {
    background-color: #292f45;
    border: 1px solid #555f79;
}
.no-box-shadow {
    -webkit-box-shadow: none!important;
    box-shadow: none!important
}

.border-radius-10 {
    border-radius: 10px!important
}

.profile-innercard-title {
    font-size: 16px;
    color: #3a3a3a;
    margin: 0;
    font-weight: 700
}

.darkmode .profile-innercard-title {
    color: #d0d2e8
}

@media (min-width: 1366px) {
    .profile-innercard-title {
        font-size:17px
    }
}

.ai-response-profile-card-outer {
    height: auto!important;
    position: absolute;
    bottom: 0;
    top: 0;
    left: 0;
    right: 0
}

@media (max-width: 992px) {
    .ai-response-profile-card-outer {
        height:auto!important;
        position: relative
    }
}

.ai-response-profile-card-outer {
    overflow-y: auto;
    display: -webkit-box!important;
    display: -ms-flexbox!important;
    display: flex!important;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap
}

.ai-response-profile-card-body,.budget-health-score-card-body,.budget-health-score-card-footer,.budget-health-score-card-header,.result-profile-innercard-body,.result-profile-innercard-footer,.result-profile-innercard-header {
    padding-left: 15px;
    padding-right: 15px
}

@media (max-width: 1442px) {
    .budget-health-score-card-footer,.budget-health-score-card-header,.result-profile-card .result-profile-innercard-body,.result-profile-innercard-footer,.result-profile-innercard-header {
        padding-left:10px;
        padding-right: 10px
    }
}

@media (max-width: 991px) {
    .income-method-inner .result-profile-innercard {
        width:100%!important
    }

    .income-method-inner {
        padding: 0!important;
        margin: 0!important
    }

    .budget-health-score-card-footer,.budget-health-score-card-header,.profile-innercard .card-body,.result-profile-innercard-body,.result-profile-innercard-footer,.result-profile-innercard-header {
        padding-left: 15px;
        padding-right: 15px
    }

    .xs-mt-2 {
        margin-top: 10px
    }
}

.ai-response-profile-card-body,.budget-health-score-card-body,.budget-health-score-card-footer,.budget-health-score-card-header,.result-profile-innercard-body,.result-profile-innercard-footer,.result-profile-innercard-header {
    padding-top: 10px;
    padding-bottom: 10px
}

.darkmode .annual-gross-level-radios .custom-control-label,.darkmode .result-profile-innercard-body .custom-control-label {
    color: #d0d2e8
}
.darkmode .steps-body .message-ai-list h3{
  color: #f9f9f9;
}
.darkmode .steps-body .ai-response-profile-list li,
.darkmode .steps-body .message-ai-list li 
{
  color: #aeafc0;
}



</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
